{
  "general.login": "ログイン",
  "general.logout": "ログアウト",
  "general.title_zero": "ストーリー",
  "general.title_one": "ストーリー",
  "general.title_other": "ストーリー",
  "general.chapter_zero": "エピソード",
  "general.chapter_one": "エピソード",
  "general.chapter_other": "エピソード",
  "general.character_zero": "キャラクター",
  "general.character_one": "キャラクター",
  "general.character_other": "キャラクター",
  "general.title_language": "ストーリー言語",
  "general.display_language": "表示言語",
  "general.category_zero": "カテゴリー",
  "general.category_one": "カテゴリー",
  "general.category_other": "カテゴリー",
  "general.category.fantasy": "ファンタジー",
  "general.category.urban_fantasy": "現代ファンタジー",
  "general.category.romance_fantasy": "ロマンスファンタジー",
  "general.category.oriental_fantasy": "武時代劇アクション",
  "general.category.boyslove": "BL",
  "general.category.girlslove": "GL",
  "general.category.alternative_history": "歴史改変",
  "general.category.drama": "ドラマ",
  "general.category.daily": "日常",
  "general.category.action": "アクション",
  "general.category.romance": "ロマンス",
  "general.category.gag_comedy": "お笑い/コメディ",
  "general.category.horror": "ホラー",
  "general.category.mystery": "ミステリー",
  "general.category.horror_mystery": "ホラー/ミステリー",
  "general.category.sci_fi": "SF",
  "general.category.know_how": "ノウハウ",
  "general.category.Daily": "日常",
  "general.create_title": "ストーリー作成",
  "general.edit_title": "ストーリー修正",
  "general.create_character": "キャラクター作成",
  "general.edit_character": "キャラクター修正",
  "general.all": "すべて",
  "general.home": "ホーム",
  "general.navigation": "メインメニュー",
  "general.best": "HotTap",
  "general.discover": "見つける",
  "general.my_titles": "マイストーリー",
  "general.library": "コレクション",
  "general.profile": "プロフィール",
  "general.my": "マイページ",
  "general.bubblepick": "Bubble Pick",
  "general.username": "ユーザーコード",
  "general.writername": "ニックネーム",
  "general.description": "説明",
  "general.setting": "設定",
  "general.setting_email": "メール",
  "general.setting_autosave": "自動保存",
  "general.setting_reading_mode": "閲覧モード",
  "general.setting_change_password": "パスワード変更",
  "general.save": "保存",
  "general.exitsave": "保存して戻る",
  "general.cancel": "取消",
  "general.next": "次へ",
  "general.create": "作成",
  "general.create_button": "作成する",
  "general.add_chapter": "エピソードを作成",
  "general.edit": "編集",
  "general.delete": "削除",
  "general.publish": "公開",
  "general.unpublish": "非公開",
  "general.publishrequest": "公開申請",
  "general.stay_on": "キャンセル",
  "general.leave": "退出",
  "general.done": "完了",
  "general.no_chapter_name": "無題",
  "general.unsaved_changes": "保存されていない変更があります。",
  "general.unsaved_changes_message": "変更内容を保存しますか？",
  "general.unsaved_changes_warning_message": "変更内容が保存されない可能性があります。",
  "general.leave_confirm_message": "このページから移動しますか？",
  "general.asset_no_list_message": "登録されたアセットがありません。",
  "general.chapter_status.publish_requested": "公開申請中",
  "general.chapter_status.published": "公開済み",
  "general.chapter_status.unpublished": "非公開",
  "general.title_status.draft": "下書き",
  "general.title_status.ongoing": "連載中",
  "general.title_status.completed": "完結",
  "general.title_status.blocked": "ブロック済",
  "general.title_status.waiting": "待機中",
  "general.character_name": "キャラクター名",
  "general.character_status": "キャラクター説明",
  "general.character_position.left": "左",
  "general.character_position.right": "右",
  "general.image_filetype_validation_message": "アップロードできるファイルは、webp、png、jpg及びjpegが可能です。",
  "general.image_size_validation_message": "画像ファイルは1枚につき10MBまで可能です。",
  "general.image_load_validation_message": "画像の読み込みに失敗しました。もう一度お試しください。",
  "general.contact_customer_support_error_message": "問題が発生しました。お客様センターまでお問い合わせください。",
  "general.yes": "はい",
  "general.no": "いいえ",
  "general.modify": "修正",
  "general.modify_button": "修正する",
  "general.save_alert": "保存されていない変更事項があります。<br/>それでも終了しますか？",
  "general.save_success_message": "変更内容が保存されました。",
  "general.save_fail_message": "変更内容の保存に失敗しました。もう一度お試しください。",
  "general.delete_alert_message": "本当に削除しますか？",
  "general.delete_success_message": "内容が削除されました。",
  "general.saving_successful": "保存に成功しました。",
  "general.saving_unsuccessful": "保存に失敗しました。 もう一度お試しください。",
  "general.terms_of_service": "利用規約",
  "general.privacy_policy": "プライバシーポリシー",
  "general.operation_policy": "運営ポリシー",
  "general.juvenile_protection_policy": "青少年保護ポリシー",
  "general.apply": "適用",
  "general.language_letter_zero": "字",
  "general.language_letter_one": "字",
  "general.language_letter_other": "字",
  "general.tap_zero": "タップ",
  "general.tap_one": "タップ",
  "general.tap_other": "タップ",
  "general.scroll_zero": "スクロール",
  "general.scroll_one": "スクロール",
  "general.scroll_other": "スクロール",
  "general.original": "オリジナル",
  "general.gallery": "ギャラリー",
  "general.camera": "カメラ",
  "general.size": "サイズ",
  "general.contest": "コンテスト",
  "general.challenge": "チャレンジ",
  "general.bubbletap_original": "BubbleTapオリジナル",
  "general.bubbleup": "BubbleUp",
  "general.bubbleup.challenge_header_button": "BubbleUpチャレンジ",
  "general.bubbleup.challenge_message": "BubbleUpチャレンジ中です。",
  "general.story_created_complete": "ストーリーが作成されました。",
  "general.list_tap_asset_sort_last_hour": "直近一時間",
  "general.list_tap_asset_sort_daily": "日間",
  "general.list_tap_asset_sort_weekly": "週間",
  "general.list_tap_asset_sort_monthly": "月間",
  "general.list_tap_asset_sort_all": "全体",
  "general.tap_order_newest": "最新順",
  "general.tap_order_liked": "いいね多い順",
  "general.tap_order_oldest": "古い順",
  "general.tap.order_int_hourly": "{{int_number}}時間",
  "general.tap.order_int_daily": "{{int_number}}日間",
  "general.tap.order_int_weekly": "{{int_number}}週間",
  "general.tap.order_int_monthly": "{{int_number}}ヵ月間",
  "general.pass.basic": "BASIC",
  "general.pass.super": "SUPER",
  "general.pass.hyper": "HYPER",
  "general.comments": "コメント",
  "general.event_awarded": "{{int_numbers}} バブル付与完了!",
  "general.event_awarded_description1": "探偵活動費と探偵のみが使用できるデコターが付与されました<br/>今すぐ犯人を見つけてください！",
  "general.event_popup_alert1": "本イベントは韓国ユーザーのみご参加いただけます",
  "general.event_popup_alert2": "本人認証が完了しているユーザーのみご参加いただけます",
  "general.event_popup_alert3": "すでに参加済みのイベントです",
  "general.event_popup_alert4": "終了したイベントです",
  "general.bubbles_zero": "{{int_numbers}} バブル",
  "general.bubbles_one": "{{int_numbers}} バブル",
  "general.bubbles_other": "{{int_numbers}} バブル",
  "general.copy": "コピー",
  "general.maintenance_title": "サービスメンテナンス中",
  "general.maintenance_title2": "より良いサービス提供のため、現在サーバーメンテナンスを実施しております。<br/>しばらくしてから再度ご利用ください。",
  "general.maintenance_description": "メンテナンス時間: 本日午前 06:30~09:30",
  "general.maintenance_period": "メンテナンス時間: {{startDate}} {{startTime}}~{{endTime}}",
  "popup.banner_close_button": "閉じる",
  "popup.close_for_a_day_button": "今日は見ない",
  "popup.banner_close_for_a_day_button": "3日間非表示",
  "register.userinfo_username_message": "ユーザーコードを決めてください。",
  "register.userinfo_username_used_validation_message": "すでに使用されているユーザーコードです。",
  "register.userinfo_writername_used_validation_message": "すでに使用されているニックネームです。",
  "register.userinfo_username_impossible_used_validation_message": "使用できないユーザーコードです。",
  "register.userinfo_writername_impossible_used_validation_message": "使用できないニックネームです。",
  "register.userinfo_username_format_validation_message": "ユーザーコードは半角英数字6~25文字の間で入力してください。",
  "register.userinfo_writername_format_validation_message": "半角英数字記号2〜25文字の間で入力してください。",
  "register.userinfo_password_message": "パスワードを入力してください。",
  "register.userinfo_password_placeholder": "パスワード",
  "register.userinfo_password_format_validation_message": "パスワードは英数字を含む8〜25文字で設定してください。",
  "register.userinfo_next": "確認",
  "register.userinfo_password_retype_placeholder": "パスワード再入力",
  "register.userinfo_username_description_message": "ユーザーコードは後から変更できません。ご注意ください。",
  "register.userinfo_email_title_message": "メールアドレスを入力してください。",
  "register.userinfo_email_description_message": "登録後、認証していただくとパスワードを再発行できます。",
  "register.userinfo_email_description_message2": "メール認証完了後<br/>以下のサービスがご利用いただけます。",
  "register.userinfo_email_certification_message": "メール認証が必要です。",
  "register.userinfo_email_certification_message2": "メール認証の状態を確認してください。",
  "register.userinfo_email_certification_button": "認証画面へ進む",
  "register.userinfo_email_checkbox_description_message1": "パスワードを忘れた方はこちら",
  "register.userinfo_email_checkbox_description_message2": "イベント当選のお知らせ",
  "register.userinfo_email_checkbox_description_message3": "BubbleUp入選のお知らせ",
  "register.userinfo_email_checkbox_description_message4": "連載提案",
  "register.userinfo_verification_agree_select_all": "すべて同意する",
  "register.userinfo_verification_privacy_policy": "個人情報処理ポリシー",
  "register.userinfo_verification_terms_of_service": "サービス利用規約",
  "register.userinfo_verification_agree_description1": "1つの名義で最大3つのアカウントまで本人認証が可能です。",
  "register.userinfo_verification_agree_description2": "本人認証で成人であることが確認されると、成人向けコンテンツの作成・利用が可能になります。",
  "register.userinfo_verification_failed_modal_description": "本⼈認証は1つの名義につき、最大3つのアカウントまで可能です。",
  "register.userinfo_verification_failed_modal_retry": "やり直す",
  "register.userinfo_set_nickname_title": "ニックネーム設定",
  "register.userinfo_set_nickname_skip": "スキップ",
  "register.userinfo_set_nickname_placeholder": "ご利用になるニックネームを入力してください。",
  "register.userinfo_set_nickname_description1": "会話の中で呼ばれる名前で、サービス全体で使われるニックネームです。",
  "register.userinfo_set_nickname_description2": "キャラ設定すると、キャラクターがこのニックネームの代わりに別の名前で呼んでくれます。",
  "register.userinfo_set_nickname_description3": "ニックネームはマイページでいつでも変更できます。",
  "register.userinfo_set_nickname_done_button": "完了",
  "register.userinfo_set_nickname_format_validation_message": "半角英数字・記号を使って、2～25文字以内で入力してください。",
  "register.userinfo_set_nickname_already_used_validation_message": "すでに使われているニックネームです。",
  "register.userinfo_set_nickname_inappropriate_words_validation_message": "不適切な言葉が含まれています。別のニックネームを入力してください。",
  "register.userinfo_set_nickname_invalid_characters_validation_message": "使用できない文字が含まれています。別の文字で入力してください。",
  "register.userinfo_set_country_korea": "대한민국",
  "register.userinfo_set_country_thai": "ประเทศไทย",
  "register.userinfo_set_country_taiwan": "臺灣",
  "register.userinfo_set_country_japan": "日本",
  "login.userinfo_message": "ログインするには<strong>ユーザーコード<strong>と<strong>パスワード<strong>を入力してください。",
  "login.userinfo_login": "ログイン",
  "login.userinfo_forgot_password_message": "パスワードをお忘れですか？",
  "login.userinfo_username_format_validation_message": "ユーザーコードは半角英数字6~25文字で入力してください。",
  "login.userinfo_password_format_validation_message": "パスワードは半角英数字８~25文字で入力してください。",
  "login.userinfo_username_fail_validation_message": "存在しないユーザーコードです。再度ご確認ください。",
  "login.userinfo_password_fail_validation_message": "パスワードに誤りがあります。もう一度お試しください。",
  "login.userinfo_password_not_set_validation_message": "パスワードがまだ設定されていません。 SNSでログイン後パスワードを設定してください。",
  "login.password_reset_password_first_description_message": "ユーザーコードと認証済みのメールアドレスを入力してください。",
  "login.password_reset_password_second_description_message": "<strong>パスワード</strong>の再設定メールが送信されます。",
  "login.password_reset_password_username_placeholder": "ユーザーコードを入力してください。",
  "login.password_reset_password_email_placeholder": "認証済みのメールアドレスを入力してください。",
  "login.password_reset_password_button": "新しいパスワードを再設定",
  "login.password_reset_password_username_fail_validation_message": "ユーザーコードは6文字以上で入力してください。",
  "login.password_reset_password_email_fail_validation_message": "有効なメールアドレスを入力してください。",
  "login.password_reset_password_username_fail_validation_toast": "存在しないユーザーコードです。再度ご確認ください。",
  "login.password_reset_password_email_validation_email_none_message": "このアカウントには認証されたメールアドレスがありません。",
  "login.password_reset_password_email_success_title": "パスワードの再設定用のメールを送信しました。",
  "login.password_reset_password_email_success_message": "受信トレイを確認してください。",
  "login.password_reset_password_email_current_validation_toast": "お使いのパスワードが無効です。 もう一度確認をお願いします。",
  "login.password_reset_password_email_new_validation_toast": "お使いのパスワードと新しいパスワードが一致しません。",
  "login.password_reset_password_email_validation_email_verify_message": "有効なメールアドレスを入力してください。",
  "login.connect_fail_unknown_title": "予期せぬエラーが発生しました。",
  "login.connect_fail_unknown_description": "このエラーについて、ご連絡いただけますと幸いです。<br/>(jp.support@bubbletap.com)",
  "login.account_member": "すでにアカウントをお持ちですか？",
  "login.account_kakao": "<strong>Kakao<strong>でログイン",
  "login.account_google": "<strong>Google<strong>でログイン",
  "login.account_facebook": "<strong>Facebook<strong>でログイン",
  "login.account_apple": "<strong>Apple<strong>でログイン",
  "login.account_agree_policy": "ログインすることで、BubbleChatの<link1>利用規約</link1>および<link2>プライバシーポリシー</link2>に同意したものとみなされます。",
  "login.account_fail_toast": "ログインに失敗しました。 もう一度お試しください。",
  "login.account_fail_password_toast": "パスワードが正しくありません。",
  "login.account_cancel_toast": "ログインがキャンセルされました。",
  "login.account_must_login": "ログイン後にご利用いただけます。",
  "login.nonlogin_users_login_button": "ログインする",
  "login.account_existing_account_title": "既存アカウントでログイン",
  "login.account_social_account_title": "SNSアカウントでログイン",
  "login.password_reset_modal_title": "パスワード再設定用のメールを送信しました",
  "login.password_reset_modal_description": "メールをご確認ください",
  "login.password_change_login_button": "パスワードを変更してログイン",
  "login.password_change_title": "パスワードを変更",
  "gnb.about_bubblechat": "バブルチャットの紹介",
  "gnb.studio": "スタジオ",
  "gnb.faq": "よくある質問",
  "gnb.guide_download": "ガイドダウンロード",
  "story.my_titles.title_list": "ストーリー·リスト",
  "story.my_titles.published_titles": "公開したストーリー",
  "story.create_title.list_thumbnail_guide_message": "新しいストーリーを作成してみましょう",
  "story.create_title.list_null_text": "まだストーリーを作成していません。",
  "story.create_edit_title.add_cover": "表紙を登録してください。",
  "story.create_edit_title.bubbletap_original_cover_assets_alert_name": "オリジナル表紙アセット",
  "story.create_edit_title.title_completed_label": "ストーリー完結",
  "story.create_edit_title.select_categories_text": "カテゴリは最大2つまで選択できます。",
  "story.create_edit_title.add_characters_text": "ストーリーにキャラクターを追加してみましょう",
  "story.create_characters.name_guide_text": "新しいキャラクター名を入力してください。",
  "story.create_characters.status_guide_text": "キャラクターの説明を入力してください。",
  "story.create_characters.position_guide_text": "キャラクターの左右位置を選択してください。",
  "story.select_characters_text": "キャラクターを選択してください。",
  "story.delete_characters_confirmation_message": "このキャラクターを削除しますか？",
  "story.delete_characters_warning_message": "このキャラクターはこのストーリーで使用できなくなります。",
  "story.delete_characters_validation_message": "このキャラクターを削除できません。",
  "story.delete_characters_info_message": "ストーリー内で使用されているキャラクターは削除できません",
  "story.delete_title_confirmation_message": "このストーリーを削除すると復元できません。<br/>本当にこのストーリーを削除しますか？",
  "story.delete_title_character_chapter_warning_message": "ストーリー内のすべてのキャラクターとエピソードが削除されます。",
  "story.delete_title_like_warning_message": "該当するストーリーのすべての「いいね」が削除されます。",
  "story.delete_title_comment_warning_message": "該当するストーリーのすべてのコメントが削除されます。",
  "story.delete_title_read_warning_message": "該当するストーリーのすべてのタップ数が削除されます。",
  "story.create_edit_title.title_validation_message": "タイトルは1〜40文字で入力してください。",
  "story.create_edit_title.description_validation_message": "ストーリーの説明は1〜150文字で入力してください。",
  "story.create_edit_title.category_validation_message": "最低でも1つカテゴリを選んでください。",
  "story.create_edit_title.status_validation_message": "ストーリーの説明は必須です。",
  "story.create_edit_title.delete_chapter_confirmation_message": "このエピソードを削除しますか？",
  "story.create_edit_title.delete_chapter_warning_message": "このエピソードはストーリーから非表示になります。",
  "story.create_edit_title_serial_chapter_unpublished_impossible_alert_message": "連載中のエピソードは非公開にできません。",
  "story.create_edit_title_serial_chapter_published_impossible_alert_message": "連載中のエピソードは直接公開できません。",
  "story.create_edit_title_serial_chapter_deleted_impossible_alert_message": "連載中のエピソードは削除することができません。",
  "story.create_edit_title.title_placeholder": "ストーリーのタイトルを入力してください。",
  "story.create_edit_title.description_placeholder": "ストーリーの簡単な説明を入力してください。",
  "story.create_edit_title.chapter_order_tooltip": "エピソードの順序を変更する",
  "story.create_title_info_title": "タイトル",
  "story.create_edit_component_delete_message": "削除されました。",
  "story.create_characters.bubbletap_original_avatar_assets_alert_name": "キャラクターアバター",
  "story.create_characters.edit_image_zoom_button": "ズーム",
  "story.create_characters.edit_image_reset_all_button": "リセット",
  "story.create_characters.edit_image_remove_background_button": "背景を削除",
  "story.create_characters.edit_image_send_button": "設定",
  "story.create_characters.edit_image_cancel_button": "取消",
  "story.create_edit_title_serial_title_delete_impossible_alert_message": "連載中のストーリーは削除できません。",
  "story.create_edit_title_serial_title_completed_impossible_alert_message": "連載中のストーリーは変更できません。",
  "story.create_edit_title_status_change_publishrequest_alert_title": "公開申請をすると、ステータスを変更できません。",
  "story.create_edit_title_status_change_publishrequest_alert_message": "公開申請後は、エピソードの編集や削除はできません。",
  "story.create_edit_title_status_change_publishrequest_alert_error_message": "申請に失敗しました。もう一度お試しください。",
  "story.create_edit_title.list_null_message": "ストーリーを公開して友達とシェアしてみましょう。",
  "preview.controller_play_button": "再生",
  "preview.controller_pause_button": "停止",
  "preview.controller_replay_button": "リプレイ",
  "preview.controller_end_button": "終了",
  "preview.controller_info_scroll_zero": "スクロール数",
  "preview.controller_info_scroll_one": "スクロール数",
  "preview.controller_info_scroll_other": "スクロール数",
  "preview.controller_info_tap_zero": "タップ数",
  "preview.controller_info_tap_one": "タップ数",
  "preview.controller_info_tap_other": "タップ数",
  "preview.controller_info_letter_zero": "文字数",
  "preview.controller_info_letter_one": "文字数",
  "preview.controller_info_letter_other": "文字数",
  "profile.username_placeholder": "使用するユーザーコードを入力してください。",
  "profile.description_placeholder": "紹介文を入力してください。",
  "profile.username_length_validation_message": "ユーザーコードは 6 - 25 文字である必要があります。",
  "profile.username_format_validation_message": "ユーザーコードは英数字のみ使用できます。",
  "profile.image_upload": "プロフィール画像をアップロード",
  "chapter.confirm_publish_chapter_message": "このエピソードを公開しますか？",
  "chapter.confirm_draft_chapter_message": "このエピソードを下書きとして保存しますか？",
  "chapter.info_fail_validation_message": "存在しないエピソードです。",
  "chapter.edit": "エピソードを編集",
  "chapter.edit_background_image": "背景画像",
  "chapter.edit_background_your_image": "画像アップロード",
  "chapter.edit_background_simple_color": "背景色",
  "chapter.edit_text_input_narrative_placeholder": "あらすじを入力してください。",
  "chapter.edit_text_input_character_placeholder": "セリフを入力してください。",
  "chapter.edit_text_input_background_image_button": "背景画像",
  "chapter.edit_text_input_narrative_button": "あらすじ",
  "chapter.edit_text_input_image_button": "画像",
  "chapter.edit_text_input_clear_room_button": "新しいページ",
  "chapter.edit_text_input_narrative_characters_limit_toast": "あらすじは最大10,000文字までです",
  "chapter.edit_text_input_dialogue_characters_limit_toast": "セリフは最大10,000文字までです",
  "chapter.edit_text_input_newpage_limit_message": "新しいページを連続で作成することはできません",
  "chapter.edit_text_input_newpage_warning_alert_message": "新しいページは最初のバブルを使用できません。",
  "chapter.edit_text_input_between_newpage_contents_limit_message": "該当するバブルを削除するには、まず前または後の新しいページを削除してください。",
  "chapter.edit_page_clear_room_tap": "新しいページで開始",
  "chapter.edit_page_current_location_line": "作成中の位置",
  "chapter.edit_page_delete_message": "削除が完了しました",
  "chapter.edit_page_background_color_tap": "背景色",
  "chapter.edit_preview_tooltip": "プレビュー",
  "chapter.edit_save_tooltip": "保存するには、タイトルとエピソード本文の1行目を入力してください",
  "chapter.edit_save_publish_chapter_warning_alert_message": "公開済みのエピソードは編集できません",
  "chapter.edit_chapter_name_text": "エピソードタイトル",
  "chapter.edit_chapter_title_placeholder": "エピソードのタイトルを入力してください",
  "chapter.edit_create_chapter": "エピソードを作成",
  "chapter.edit_back": "戻る",
  "chapter.edit_chapter_title": "エピソードのタイトルを入力してください",
  "chapter.edit_text_edit_text": "テキストを編集",
  "chapter.edit_text_change_monologue": "独り言に切り替え",
  "chapter.edit_text_change_dialogue": "セリフに切り替え",
  "chapter.edit_assets_background_color": "背景色",
  "chapter.edit_assets_background_title": "背景画像",
  "chapter.edit_assets_background_category_your_image": "マイ画像",
  "chapter.edit_assets_background_category_simple_color": "背景色",
  "chapter.edit_assets_background_category_bubbletap_original": "BubbleTapオリジナル背景",
  "chapter.edit_assets_animated_overlay_image": "オーバーレイ",
  "chapter.edit_text_auto_separation": "チャットの自動区切り",
  "chapter.edit_text_auto_separation_enter": "Enterキーで<br/>チャットを区切りましょう！",
  "chapter.edit_text_convo_type": "チャットタイプを変更",
  "chapter.edit_cut": "切り取り",
  "chapter.edit_paste": "貼り付け",
  "chapter.edit_searchby_char": "キャラクター名で検索してください",
  "chapter.edit_assets_bubbletap_original_transition_action_sheet": "切替方式の変更",
  "chapter.edit_assets_bubbletap_original_transition_screen_name": "画面の切替方式を設定してください",
  "chapter.edit_assets_bubbletap_original_transition_image_button": "ゆるやかな画面切替（画像タイプ）",
  "chapter.edit_assets_bubbletap_original_transition_text_button": "速い画面切替（テキストタイプ）",
  "chapter.list_reading_mode_screen_name": "お好みの閲覧モードを設定してください",
  "chapter.list_reading_tap_mode_button": "タップモード",
  "chapter.list_reading_scroll_mode_button": "スクロールモード",
  "chapter.list_reading_tap_mode_alert_title": "タップモードに設定しました",
  "chapter.list_reading_tap_mode_alert_message": "設定を変更するには、<br/><strong>マイページ ＞ 設定 ＞ 閲覧モード</strong>から変更することができます。",
  "chapter.list_reading_scroll_mode_alert_title": "スクロールモードに設定しました",
  "chapter.list_reading_scroll_mode_alert_message": "設定を変更したい場合は、<strong>マイページ ＞ 設定 ＞ 閲覧モード</strong>から<br/>変更できます。",
  "chapter.list_non_login_user_reading_mode_setting_alert_message": "設定を変更したい場合は、ログイン後<br/><strong>マイページ ＞ 設定 ＞ 閲覧モード</strong>から変更できます。",
  "chapter.list_share_fail_message": "アプリが見つかりませんでした。",
  "chapter.edit_assets_bubbletap_original_soundeffect_action_sheet": "効果音追加",
  "chapter.edit_assets_bubbletap_original_soundeffect_screen_name": "効果音",
  "chapter.edit_assets_bubbletap_original_soundeffect_main_category1": "バブルタップ効果音",
  "chapter.edit_assets_bubbletap_original_soundeffect_main_category2": "お気に入り",
  "chapter.edit_assets_bubbletap_original_soundeffect_category1": "自然",
  "chapter.edit_assets_bubbletap_original_soundeffect_category2": "オブジェクト",
  "chapter.edit_assets_bubbletap_original_soundeffect_category3": "動物",
  "chapter.edit_assets_bubbletap_original_soundeffect_category4": "空間的背景",
  "chapter.edit_assets_bubbletap_original_soundeffect_category5": "人",
  "chapter.edit_assets_bubbletap_original_soundeffect_category6": "ジャンル",
  "chapter.edit_assets_bubbletap_original_soundeffect_category7": "その他",
  "chapter.edit_assets_bubbletap_original_soundeffect_categories_screen_name": "効果音",
  "chapter.edit_assets_bubbletap_original_soundeffect_edit_action_sheet": "効果音除去",
  "chapter.edit_assets_bubbletap_original_soundeffect_play_failed_toast": "オーディオの再生に失敗しました。",
  "chapter.list_free_label": "無料",
  "chapter.list_owned_label": "購入",
  "chapter.list_rented_label": "レンタル",
  "chapter.list_rented_expire_label": "レンタル終了",
  "chapter.list_share_title": "共有する",
  "chapter.list_share_kakaotalk_label": "カカオトーク",
  "chapter.list_share_kakaotalk_message": "今すぐ見に行く！",
  "chapter.list_share_instagram_label": "Instagram",
  "chapter.list_share_link_label": "リンクコピー",
  "chapter.list_share_link_message": "リンクがコピーされました。",
  "chapter.list_rented_label_time1": "{{int_rentDay}}日 {{int_rentHour}}時間",
  "chapter.list_rented_label_time2": "{{int_rentDay}}日",
  "chapter.list_rented_label_time3": "{{int_rentHour}}時間{{int_rentMinute}}分",
  "chapter.list_rented_label_time4": "{{int_rentHour}}時間",
  "chapter.list_rented_label_time5": "{{int_rentMinute}}分",
  "chapter.list_charge_status": "無料で閲覧可能",
  "chapter.list_charge_time_day_description_zero": "{{int_rentDay}}日ごとに無料",
  "chapter.list_charge_time_day_description_one": "{{int_rentDay}}日ごとに無料",
  "chapter.list_charge_time_day_description_other": "{{int_rentDay}}日ごとに無料",
  "chapter.list_charge_time_hour_description_zero": "{{int_rentHour}}時間ごとに無料",
  "chapter.list_charge_time_hour_description_one": "{{int_rentHour}}時間ごとに無料",
  "chapter.list_charge_time_hour_description_other": "{{int_rentHour}}時間ごとに無料",
  "chapter.list_charge_time_minute_description_zero": "{{int_rentMinute}}分ごとに無料",
  "chapter.list_charge_time_minute_description_one": "{{int_rentMinute}}分ごとに無料",
  "chapter.list_charge_time_minute_description_other": "{{int_rentMinute}}分ごとに無料",
  "chapter.list_charge_time_count_day_description": "残り {{int_rentDay}}日",
  "chapter.list_charge_time_count_day_hour_description": "残り {{int_rentDay}}日 {{int_rentHour}}時間",
  "chapter.list_charge_time_count_hour_description": "残り {{int_rentHour}}時間",
  "chapter.list_charge_time_count_hour_minute_description": "残り {{int_rentHour}}時間 {{int_rentMinute}}分",
  "chapter.list_charge_time_count_minute_description": "残り {{int_rentMinute}}分",
  "chapter.list_free_count": "{{int_count}}話 無料",
  "chapter.list_charge_info_alert_tittle": "待てば無料",
  "chapter.list_charge_time_day_info_alert_message1_zero": "利用券を使用後{{int_rentDay}}日待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_day_info_alert_message1_one": "利用券を使用後{{int_rentDay}}日待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_day_info_alert_message1_other": "利用券を使用後{{int_rentDay}}日待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_hour_info_alert_message1_zero": "利用券を使用後、{{int_rentHour}}時間待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_hour_info_alert_message1_one": "利用券を使用後、{{int_rentHour}}時間待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_hour_info_alert_message1_other": "利用券を使用後、{{int_rentHour}}時間待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_minute_info_alert_message1_zero": "利用券を使用後、{{int_rentMinute}}分待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_minute_info_alert_message1_one": "利用券を使用後、{{int_rentMinute}}分待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_minute_info_alert_message1_other": "利用券を使用後、{{int_rentMinute}}分待つと、利用券がもう1枚もらえます。",
  "chapter.list_charge_time_info_alert_message2": "この利用券で3日間レンタルできます。",
  "chapter.list_charge_time_info_alert_message3": "最新の{{int_rentRecent}}話は、該当の利用券でご利用いただけません。",
  "chapter.list_purchase_purchased_chapter_button": "購入エピソード",
  "chapter.list_purchase_chapter_collect": "購入する",
  "chapter.list_purchase_chapter_rent": "レンタル",
  "chapter.list_purchase_chapter_free_charge": "無料閲覧",
  "chapter.list_purchase_alert_my_bubble": "保有バブル",
  "chapter.list_purchase_alert_message": "エピソードを購入しますか？",
  "chapter.list_purchase_failed_alert_message": "エピソードの購入に失敗しました。 もう一度お試しください。",
  "chapter.list_purchase_alert_footer_message": "レンタル時間は購入後72時間です。",
  "chapter.edit_autosave_error_toast_message": "自動保存に失敗しました。",
  "chapter.edit_autosave_saving_text": "自動保存中",
  "chapter.edit_autosave_success_text": "自動保存完了",
  "chapter.edit_autosave_last_success_time_text": "最後の保存",
  "chapter.read_config_font_size_change": "文字サイズ",
  "asset_browser.add": "追加",
  "asset_browser.in_use": "使用中",
  "asset_browser.max_num_images_limit_info_text": "最大20個の画像のみ選択できます。",
  "asset_browser.no_asset_in_use_message": "使用中のアセットはありません。",
  "asset_browser.character_image": "キャラクター画像",
  "asset_browser.narrative_image": "あらすじ画像",
  "setting.edit_email_verify_now_button": "メール認証",
  "setting.edit_email_re_verify_button": "再認証",
  "setting.edit_email_password_change_button": "変更",
  "setting.edit_email_verify_message": "メールを認証してください",
  "setting.edit_email_verify_info_text": "パスワードを再設定するには、メール認証を完了してください。",
  "setting.edit_email_verify_text": "メールアドレス入力",
  "setting.edit_email_verify_placeholder": "メールアドレス入力",
  "setting.edit_cancel_button": "キャンセル",
  "setting.edit_email_verify_verify_now_button": "認証する",
  "setting.edit_email_verify_validation_text": "メール形式に合わせて入力してください。",
  "setting.edit_email_verify_success_message": "入力したメールアドレスに<br/>認証メールを送信しました。",
  "setting.edit_email_verify_success_info_text": "24 時間以内にメールを認証してください。",
  "setting.edit_email_verify_fail_current_text": "現在認証したメールアドレスです。",
  "setting.edit_email_verify_fail_use_text": "すでに使用中のメールアドレスです。",
  "setting.edit_ok_button": "確認",
  "setting.edit_email_verify_email_template_message": "メール認証",
  "setting.edit_email_verify_email_template_guide_text": "メールを認証するには、下のボタンをクリックしてください。",
  "setting.edit_email_verify_email_template_info_text": "このメールは 24 時間有効です",
  "setting.edit_email_verify_email_template_click_here_button": "認証する",
  "setting.edit_email_verify_email_template_success_message": "認証完了",
  "setting.edit_email_verify_email_template_success_text": "ありがとうございました！ メール認証が完了しました。",
  "setting.edit_email_verify_email_template_close_window_button": "認証画面を閉じる",
  "setting.edit_email_verify_email_template_fail_message": "この認証メールは有効ではありません。",
  "setting.edit_email_verify_email_template_fail_text": "認証期限が切れました。 もう一度お試しください。",
  "setting.edit_email_verify_email_template_expiration_message": "このメールアドレスはすでに認証されています。",
  "setting.edit_email_verify_email_template_expiration_text": "別のメールアドレスで認証をしてください",
  "setting.edit_email_verify_email_template_move_studio_button": "スタジオに戻る",
  "setting.edit_email_re_verify_message": "メールを再認証してください",
  "setting.edit_email_re_verify_info_text": "認証メールを別のメールアドレスに変更が可能です。 新しいメールアドレスを入力してください",
  "setting.edit_autosave_setup_alert_title_message": "自動保存設定",
  "setting.edit_autosave_setup_alert_description_message": "エピソードが自動保存される時間を<br/>設定できます。",
  "setting.edit_autosave_setup_time_value_one_minute": "1分ごとに保存",
  "setting.edit_autosave_setup_time_value_three_minutes": "3分ごとに保存",
  "setting.edit_autosave_setup_time_value_five_minutes": "5分ごとに保存",
  "setting.edit_autosave_setup_time_value_on": "オン",
  "setting.edit_autosave_setup_time_value_off": "オフ",
  "setting.edit_autosave_setup_time_status_one_minute": "1分",
  "setting.edit_autosave_setup_time_status_three_minutes": "3分",
  "setting.edit_autosave_setup_time_status_five_minutes": "5分",
  "setting.edit_autosave_setup_time_status_minute": "分",
  "setting.edit_reading_tap_mode_title_message": "タップモード",
  "setting.edit_reading_tap_mode_description_message": "コンテンツをタップしながら見ることができます。",
  "setting.edit_reading_scroll_mode_title_message": "スクロールモード",
  "setting.edit_reading_scroll_mode_description_message": "コンテンツをスクロールしながら見ることができます。",
  "setting.edit_password_change_your_password_description": "現在のパスワードと新しいパスワードを入力してください。",
  "setting.edit_password_change_your_password_message": "パスワードを変更してください。",
  "setting.edit_password_input_current_password_placeholder": "現在のパスワード入力",
  "setting.edit_password_input_new_password_placeholder": "新たに設定するパスワードを入力してください。",
  "setting.edit_password_input_re_type_new_password_placeholder": "新しいパスワード再入力",
  "setting.edit_password_change_your_password_validation_text": "パスワードは半角英数字・記号を含む8〜25文字で入力してください。\n\n",
  "setting.edit_password_change_your_password_validation_toast": "パスワードに誤りがあります。",
  "setting.edit_password_change_new_password_validation_toast": "現在使用中のパスワードはご利用いただけません。 別のパスワードを入力してください。",
  "setting.edit_password_change_success_message": "パスワードの変更が完了しました。",
  "setting.edit_password_change_success_text": "新しいパスワードで<br/>ログイン可能です。",
  "setting.edit_password_change_enable_validation_text": "使用可能なパスワードです。",
  "setting.edit_password_change_new_password_again_placeholder": "新しく設定するパスワードをもう一度入力してください",
  "setting.edit_password_change_new_password_match_validation_text": "新しいパスワードが一致しました。",
  "setting.edit_password_change_new_password_not_match_validation_text": "新しいパスワードが一致しません。",
  "setting.edit_setuppassword_title_message": "パスワード設定",
  "setting.edit_setuppassword_description_message": "パスワードは、<br/>ユーザーコードでログインするときに使用します。",
  "setting.edit_setuppassword_new_password_placeholder": "パスワードを入力してください。",
  "setting.edit_setuppassword_new_password_validation_text": "パスワードは半角英数字・記号を含む8〜25文字で入力してください。\n\n",
  "setting.edit_setuppassword_new_password_again_placeholder": "パスワードを再入力してください。",
  "setting.edit_setuppassword_new_password_again_validation_text": "パスワードをもう一度入力してください。",
  "setting.edit_setuppassword_change_button": "設定",
  "setting.edit_setuppassword_alert_title": "パスワードが設定されました。",
  "setting.edit_setuppassword_alert_description": "今後は、このパスワードでログインできます。",
  "register.userinfo_password_not_match_validation_text": "パスワードが一致しません。",
  "register.userinfo_password_match_validation_text": "パスワードが一致しました。",
  "email.template_footer_message": "本メールは送信専用です。お問い合わせの際は、(support@bubbletap.com)までご連絡ください。",
  "email.template_title": "新しいパスワード設定",
  "email.template_password_reset_body_title": "新しいパスワード設定",
  "email.template_password_reset_body_description": "新しいパスワードを設定するには、下のボタンを押して下さい",
  "email.template_password_reset_reset_password_button": "新しいパスワード設定",
  "email.page_password_reset_success_title": "<strong>新しいパスワードが設定されました</strong>。",
  "email.page_password_reset_success_description": "新しいパスワードでログインしてください。",
  "email.page_password_reset_fail_title": "<strong>新しいパスワード設定のためのリンクが無効になりました</strong>。",
  "email.page_password_reset_fail_title_no_strong": "パスワード再設定用のリンクは期限切れです。",
  "email.page_password_reset_fail_description": "別のメールアドレスで再度お試しください。",
  "email.page_password_reset_validation_text": "パスワードは半角英数字を含む8〜25文字で入力してください。",
  "email.page_password_reset_re_type_validation_text": "パスワードは半角英数字を含む8〜25文字で入力してください。",
  "email.page_password_reset_re_type_match_validation_text": "確認のため、同じパスワードをもう一度入力してください。",
  "block.account_title": "お客様のアカウントは停止されています。",
  "block.account_message": "ご不明な点がございましたら、お客様センターまでご連絡ください。",
  "block.account_re_active_date_text": "解除日",
  "block.account_contact_us_button": "お問合せ",
  "block.title_title": "お客様のストーリーは制限されています。現在は公開できません。",
  "block.useraccount_alert_message": "現在、BubbleChatのご利用が制限されています。",
  "block.community_alert_message": "現在、コミュニティ機能のご利用が制限されています。",
  "block.account_unblocked_date_text": "解除予定日",
  "block.reason": "理由",
  "profile.introduction": "紹介文",
  "block.block_button": "ブロック",
  "block.block_alert_title_character": "キャラクターをブロックしますか？",
  "block.block_toast_complete": "ブロックに成功しました。",
  "block.block_toast_failed": "ブロックに失敗しました",
  "block.block_toast_failed2": "これ以上ブロックできません",
  "block.block_list": "ブロックリスト",
  "block.block_list_empty_character": "ブロックしたキャラクターがいません",
  "block.unblock_toast_deleted": "削除されたキャラクターです",
  "block.unblock_button": "ブロック解除",
  "block.unblock_alert_title_character": "キャラクターのブロックを解除しますか？",
  "block.unblock_toast_complete": "ブロックを解除しました",
  "block.unblock_toast_failed": "ブロック解除に失敗しました",
  "banner.body_title": "BubbleTap Studioで、<br/>あなたのストーリーを形にしませんか",
  "banner.body_description": "より多機能で本格的なBubbleTap Studioなら、<br/>もっと楽しくストーリーを作ることができます。",
  "banner.body_button": "Studioを見に行く",
  "footer.rights_message": "© 2025 Bubble Tap CO., LTD.",
  "footer.ceo_text": "CEO",
  "footer.ceo_name_text": "JB Park",
  "footer.address_text": "住所",
  "footer.address_info_text": "5F, 207, Teheran-ro, Gangnam-gu, Seoul, Republic of Korea",
  "footer.company_name_text": "Bubble Tap CO., LTD.",
  "footer.tel_text": "TEL",
  "footer.tel_info_text": "＋82 02-2039-7572",
  "footer.email_text": "Email ",
  "footer.email_info_text": "jp.support@bubbletap.com",
  "footer.registration_number_text": "法人番号",
  "footer.registration_bus_report_num": "通信販売業届出番号",
  "browser.support_alert_title_message": "ブラウザを最新バージョンにアップデートしてください！",
  "browser.support_alert_description_message": "BubbleChat Studioは最新のブラウザに最適化されています。",
  "browser.support_alert_chrome_description_message": "Chromeはバージョン9以上でスムーズに動作します。",
  "browser.support_alert_edge_description_message": "Edgeはバージョン18以上でスムーズに動作します。",
  "browser.support_alert_safari_description_message": "Safariはバージョン14以上でスムーズに動作します。",
  "browser.support_alert_firefox_description_message": "Firefoxはバージョン65以上でスムーズに動作します。",
  "browser.support_alert_ie_description_message": "IEはサポート対象外です。",
  "error.page_title_message": "不正なルートでアクセスされました。",
  "error.page_description_message": "下のボタンから BubbleChat の公式サイトにアクセスできます。",
  "error.page_bubblechat_go_button": "BubbleChat ホームページへ移動する",
  "contest.agree_message": "参加する",
  "contest.agree_confirm_message": "'{{string_contestName}}'に参加中です。",
  "contest.agree_alert_title": "'{{string_contestName}}' 参加のご案内",
  "contest.agree_alert_description": "チェックすると、参加に同意したことになります。",
  "contest.publish_alert_title": "このエピソードは公開できません。",
  "contest.publish_alert_description_first": "各エピソードは{{int_mintext}}文字以上入力する必要があります。",
  "contest.publish_alert_description_second": "現在の文字数:",
  "contest.save_alert_title": "このエピソードは保存できません。",
  "contest.save_alert_description_first": "各エピソードは{{int_mintext}}文字以上入力する必要があります。",
  "contest.save_alert_description_second": "現在の文字数:",
  "contest.delete_alert_title": "このストーリーは削除できません。",
  "contest.delete_alert_description": "ストーリーは下書き状態のときのみ削除できます。",
  "contest.modify_alert_title": "このストーリーは編集できません。",
  "contest.modify_alert_description": "審査期間中は、コンテストに応募したストーリーの編集・削除はできません。",
  "contest.edit_draft_alert_title": "このストーリーは編集できません。",
  "contest.edit_draft_alert_description": "審査期間中は、コンテストに応募したストーリーの編集はできません。",
  "contest.bubbleup.challenge_message": "挑戦する",
  "contest.bubbleup.challenge_description": "誰でも参加可能！",
  "contest.edit_draft_alert_character_title": "このキャラクターは編集できません。",
  "contest.edit_draft_alert_character_description": "審査期間中は、コンテストに応募したストーリーのキャラクターは編集できません。",
  "contest.edit_draft_alert_warning_message": "このストーリーを削除すると、コンテストやイベントの参加が取り消されます。",
  "contest.agree_end_error_alert_tittle": "一時的な問題により参加できません。再度お試しください。",
  "contest.agree_end_error_alert_message": "コンテストまたはイベントが終了したため、参加できません。",
  "contest.title": "コンテスト",
  "profile.edit_username_description": "ユーザーコードを変更",
  "profile.edit_writername_description": "ニックネームを変更",
  "profile.edit_username_description_message": "新しいユーザーコードを入力してください。",
  "profile.edit_writername_description_message": "新しいニックネームを入力してください。",
  "profile.edit_username_duplicate_message": "すでに使用されているユーザーコードです。",
  "profile.category_community_other_post_list_null_message": "最初の投稿をしてみましょう！",
  "profile.following_suggestion": "フォローしてみましょう。",
  "profile.gather_followers": "フォロワーを増やしてみましょう。",
  "profile.category_community_post_list_null_message": "まだ投稿がありません。",
  "profile.sns_category_following_list_null_message": "まだフォローしている人がいません。",
  "profile.sns_category_follower_list_null_message": "まだフォロワーがいません。",
  "notice.legal_content_alert_message": "本サービスのコンテンツは、株式会社BubbleChatが所有する著作物であり、当社のWebスタジオおよびアプリ内でのみご利用いただけます。\n株式会社BubbleChatの許可なく無断で転載・複製することは著作権法により禁止されており、違反した場合は法的措置を取ることがあります。",
  "notice.legal_content_alert_create_story_title_message": "注意事項をお読みください！",
  "notice.legal_content_alert_create_story_main_message": "ユーザーがストーリーやエピソードのタイトル、表紙、本文、キャラクターなどを作成する際、以下の事項に違反した場合は、BubbleChatの運営ポリシーおよび関連法令に基づき処分を受けることがあります。",
  "notice.legal_content_alert_create_story_body_message1": "他の会員をはじめとする第三者の知的財産権を、本人の同意なく違法に共有・掲載した場合",
  "notice.legal_content_alert_create_story_body_message2": "有名人を含む他人の個人情報、プライバシー、肖像、氏名などに関するすべての権利を侵害・侮辱、\nまたは名誉を毀損する作品・表紙・キャラクターなどを作成または配布する場合",
  "notice.legal_content_alert_create_story_body_message3": "自分以外の人物になりすましたり、虚偽の情報を提示するなどして他人を欺く場合",
  "notice.legal_content_alert_create_story_body_message4": "過度な暴言や卑俗な表現を繰り返し使用し、不快感・嫌悪感・恐怖を与える場合",
  "notice.legal_content_alert_create_story_body_message5": "他人に残虐性や嫌悪感を引き起こすような暴力的・刺激的な内容を作成または拡散する場合",
  "notice.legal_content_alert_create_story_body_message6": "性的で露骨または過激な描写を含み、他人に羞恥心や不快感を与えたり、\n歪んだ性的認識を助長するようなわいせつな内容を作成または拡散する場合",
  "notice.legal_content_alert_create_story_body_message7": "他者への明確な身体的脅迫や、自傷・自殺を助長・推奨する内容を含む場合",
  "notice.legal_content_alert_create_story_body_message8": "特定の個人または団体に対する悪意ある差別や偏見を助長する場合",
  "notice.legal_content_alert_create_story_body_message9": "法律で禁止されている行為、またはそれらを教唆・幇助する場合",
  "notice.legal_content_alert_create_story_body_message10": "関連法規により宣伝・広告・販売が禁止されている物品やサービスを取り扱う場合",
  "notice.legal_content_alert_create_story_body_message11": "公共の安全に対し直接的かつ重大な脅威を与える内容を作成・拡散する場合",
  "notice.legal_content_alert_create_story_body_message12": "なお、BubbleChat運営チームはこれらの注意事項に違反した投稿について、事前通知なく削除やアカウント停止の措置を取ることがあります。",
  "notice.legal_content_alert_create_story_body_message13": "また、生成されたストーリーのテキストや画像などの要素を、\nマーケティング活動に利用する場合があります。",
  "notice.legal_content_alert_create_story_tail_message": "注意事項に違反した法的問題のすべての責任は<br/>ストーリー作成者にあります。",
  "notice.legal_content_alert_create_story_button": "同意のうえ、ストーリーを作成する",
  "ai.create_edit_title.cover_name": "AIサービス",
  "ai.create_edit_title.name": "AI画像",
  "ai.create_edit_title.cover_message": "BubbleChat AIで、自分だけのオリジナル表紙を作ってみましょう。",
  "ai.create_screen_title.image_similarity_name": "類似度",
  "ai.create_screen_title.image_similarity_message": "類似度が高いほど、元の画像の特徴が強く反映されます！",
  "ai.create_screen_title.image_style_name": "スタイル",
  "ai.create_screen_title.image_view_all_name": "すべて表示",
  "ai.create_screen_title.image_prompt_name": "プロンプト",
  "ai.create_screen_title.image_prompt_example_name": "プロンプト例",
  "ai.create_screen_title.image_prompt_example_description1": "この女性の背景を宇宙空間に変えて",
  "ai.create_screen_title.image_prompt_example_description2": "宇宙にいる１人の女性",
  "ai.create_screen_title.image_prompt_example_description3": "80代の老人のように高齢者風に作成し、全身姿で作って",
  "ai.create_screen_title.image_prompt_example_description4": "80代の老人、しわ、全身",
  "ai.create_screen_title.image_prompt_example_description5": "少年、無表情、金髪、色白、白Tシャツ、デニム、森の中",
  "ai.create_screen_title.image_prompt_example_description6": "イケメン男性、20代、茶髪、緑の目、水色のシャツ、白T、黒ズボン、\nやさしい笑顔、雨の日、道で傘を持っている男",
  "ai.create_screen_title.image_prompt_example_description7": "ビーチでサンベッドに寝転び、カクテルを手に日光浴をしている男性、\nヤシの木、カモメ",
  "ai.create_screen_title.image_prompt_example_description8": "シルエットスタイル：夜の枝にとまるフクロウのシルエット、\n映画フィルム風、細かい霧の照明、バックライト、4K UHDの傑作風",
  "ai.create_screen_title.image_prompt_description": "ご希望の画像の説明を入力してください。",
  "ai.create_screen_title.original_image_button": "そのまま使用",
  "ai.create_screen_title.random_image_button": "ランダムに画像を作成",
  "ai.create_screen_title.ai_image_button": "AIで画像を生成",
  "ai.create_screen_title.return_message": "生成した画像を使用せずに終了しますか？",
  "ai.create_studio_background_color_edit_name": "背景色編集",
  "ai.create_studio_background_upload_fail_message": "画像のアップロードに失敗しました。",
  "ai.create_studio_background_example_description1": "青空と広々とした海岸",
  "ai.create_studio_background_example_description2": "全体的に青い空の背景",
  "ai.create_studio_background_example_description3": "上は灰色の天井、下は教室の机と椅子",
  "ai.create_studio_background_example_description4": "青空と山、昔ながらの韓屋路地",
  "ai.create_studio_background_example_description5": "雨空、雰囲気のある照明が照らされる都市",
  "ai.create_studio_background_example_description6": "パステル調の倉庫の内部",
  "ai.create_studio_background_example_description7": "星が瞬く夜空の下にある屋外プール",
  "ai.create_studio_background_example_description8": "画像上部に白い余白, 下部に家の間の路地",
  "ai.loading_screen_advertising_message1": "指先で楽しむストーリー",
  "ai.loading_screen_advertising_message2": "ubbleChatで自分だけのストーリーを簡単に作って楽しんでみましょう！",
  "ai.loading_screen_alert_description": "現在の待機人数",
  "ai.loading_screen_alert_message": "AI画像生成中",
  "ai.loading_screen_alert_message2": "サービス接続待機中です。",
  "ai.result_screen_alert_message": "AI画像の生成が完了しました！",
  "ai.result_screen_alert_prompt_description1": "プロンプトを追加してみましょう！",
  "ai.result_screen_alert_prompt_description2": "プロンプトを変更してみましょう！",
  "ai.result_screen_title.ai_image_button1": "再生成",
  "ai.result_screen_title.ai_image_button2": "使用する",
  "ai.result.fail_create_image_message": "AI画像の生成に失敗しました",
  "ai.button_background": "背景",
  "notification.list_title": "通知",
  "notification.my_news_title": "マイ通知",
  "notification.freebie_reads_title": "待てば無料",
  "notification.events_title": "イベント",
  "notification.bubble_title": "財貨",
  "notification.notice_title": "お知らせ",
  "notification.list_unread_notification": "未読のお知らせ",
  "notification.list_all_read": "すべて読む",
  "notification.delete_90days_message": "通知はありません。",
  "notification.delete_90days_message_part2": "通知は90日後に自動で削除されます。",
  "notification.notice_history_headline_description": "通知の詳細は、BubbleChatアプリでご確認いただけます。",
  "tag.title": "タグ",
  "tag.selection": "タグを1〜10個選んでください。",
  "tag.selection_notification": "1つ以上のタグを選んでください。",
  "tag.suggestion_button": "タグを提案する",
  "tag.suggestion_title": "タグを提案する",
  "tag.suggestion_description": "追加したいタグがあればご提案ください。<br/>社内で検討後、追加される可能性があります！",
  "tag.suggestion_placeholder": "タグ名を入力してリクエストする",
  "tag.suggestion_submission_button": "提案",
  "tag.selection_untap": "タグを選んで、読みたいストーリーを見つけよう！",
  "tag.suggestion_no_match": "該当するタグのストーリーが見つかりません。",
  "search.category_story_tab_msg": "読みたいストーリーを検索",
  "search.category_profile_tab_msg": "探したいニックネームを検索",
  "search.category_title_list_null_message": "該当するストーリーは見つかりませんでした",
  "search.category_profile_null_message": "該当するニックネームは見つかりませんでした",
  "search.asset_none": "お探しのアセットは見つかりませんでした",
  "search.story": "読みたいストーリーを見つけよう！",
  "topup.purchase_receive_bonus": "イベントに参加して、ボーナスを受け取ろう！",
  "report.result_title": "通報を受け付けました",
  "report.result_description": "通報の内容は慎重に確認し、<br/>対応いたします。",
  "report.error_occurred": "通報の送信に失敗しました。",
  "report.result_fail_description": "お手数ですが<br/>しばらくしてからもう一度お試しください。",
  "report.type.chat_sexual_content": "性的コンテンツ",
  "report.type.chat_violent_content": "暴力的なコンテンツ",
  "report.type.chat_hate_discrimination": "ヘイトスピーチおよび差別",
  "report.type.chat_privacy_violation": "プライバシーの侵害",
  "report.type.chat_other": "その他",
  "chapter.read_end_comment_list_null_message": "コメントしてみましょう。",
  "chapter.list_null_message": "まだ公開したストーリーがありません。",
  "library.category_favorites_asset_add_msg": "気に入ったアセットを<br/>お気に入りに登録してみてください。",
  "library.category_favorites_list_null_message": "気になるストーリーはブックマークしてみましょう",
  "library.category_purchased_story_list_null_message": "ストーリーを購入してみましょう",
  "network.internet_no_connection_title": "インターネット接続がありません。",
  "network.internet_no_connection_message": "ネットワークに接続されていません。<br/>再接続をお試しください。",
  "setting.edit_delete_account_button": "アカウント削除",
  "setting.edit_delete_account_screen_name": "アカウント削除",
  "setting.edit_delete_account_screen_agree_alert_set_password_title": "パスワードを設定してください。",
  "setting.edit_delete_account_screen_agree_alert_set_password_description": "まだパスワードが設定されていません。 パスワードを先に設定してください。",
  "setting.edit_delete_account_screen_title": "本当にアカウントを削除しますか？",
  "setting.edit_delete_account_screen_description": "アカウントを削除すると、Bubblechatのコンテンツにアクセスできなくなります。",
  "setting.edit_delete_account_screen_agree_message": "以下の内容を読み、同意しました",
  "setting.edit_delete_account_screen_agree_story_message": "作成したすべてのストーリーは削除され、復元できません。<br/>また、購入したストーリーをはじめ、すべての有料及び無料コンテンツもすべて削除され、復元することはできません。",
  "setting.edit_delete_account_screen_agree_post_message": "このアカウントによって作成されたすべてのコンテンツと投稿は失われます。<br/>第三者によって共有・再配布されたコンテンツは削除されません。",
  "setting.edit_delete_account_screen_agree_revenue_message": "このアカウントに関連するすべての販売記録は失われ、復元することはできません。 また、収益の残高を出金申請することはできません。",
  "setting.edit_delete_account_screen_agree_delete_message": "関連法令に基づき、個人情報は定められた期間保管された後、削除されます。",
  "setting.edit_delete_account_screen_agree_verification_message": "本人確認済みアカウントを削除した場合、7日間は再認証ができません。",
  "setting.edit_delete_account_screen_agree_confirm_password_message": "本人確認のためアカウントのパスワードを入力して下さい。",
  "setting.edit_delete_account_screen_agree_alert_agree_title": "すべての内容に同意して下さい。",
  "setting.edit_delete_account_screen_agree_alert_agree_description": "以下の内容に同意することで、アカウントを削除することができます。",
  "setting.edit_delete_account_screen_agree_alert_password_title": "パスワードが正しくありません。",
  "setting.edit_delete_account_screen_agree_alert_password_description": "現在のパスワード入力",
  "setting.edit_delete_account_screen_agree_alert_delete_account_title": "アカウントの削除が完了しました。",
  "setting.edit_delete_account_screen_agree_alert_delete_account_description": "BubbleChatはいつでも皆さんのストーリーを待ってます。",
  "identity.verification": "本人認証",
  "identity.verification.adult": "成人認証",
  "identity.verification_request": "本人認証をしてください。",
  "identity.verification_completed": "本人認証が完了しました。",
  "identity.reverification_completed_title": "再認証が完了しました",
  "identity.reverification_completed_description": "これで成人向けコンテンツを正常にご利用いただけます",
  "identity.verification_explanation1": "本人認証は、使用しているアカウントが本人のものであることを認証するための手続きです。",
  "identity.verification_explanation2": "同一名義で認証できるアカウントは最大2つまでです。",
  "identity.verification_explanation3": "本人確認完了後は、登録情報の取り消しや名義の変更はできません。",
  "identity.verification_explanation4": "BubbleUpに選出された場合、次のステップに進むには本人確認の完了が必須となります。",
  "identity.verification_notify1": "<link1>個人情報の取り扱いおよび利用</link1>に同意します。",
  "identity.verification_notify2": "他人名義の使用、または本人ではない個人情報を使用した場合、法的責任を負うことに同意します。",
  "identity.verification_toverify": "認証する",
  "identity.verification_expired": "成人認証満了",
  "identity.verification_success": "本人認証成功",
  "identity.verification_completed2": "認証完了",
  "identity.verification_complete_date": "本人認証完了日",
  "identity.verification_failed": "本人認証失敗",
  "identity.verification_cancelled": "ユーザーが本人認証をキャンセルしました。",
  "identity.verification_failed_reason_unknown": "不明な理由により失敗しました。",
  "identity.verification_fail_message": "本人認証に失敗しました。",
  "identity.verification_success_message": "本人認証が完了しました。",
  "charging_stn.free_tap": "無料チャージスポット",
  "charging_stn.paid_tap": "有料チャージスポット",
  "charging_stn.free_msg_choose_button": "お気に入りのボタンを押す",
  "charging_stn.free_msg_get_bubbles": "無料バブルを獲得しましょう",
  "charging_stn.top_title": "バブルチャージスポット",
  "charging_stn.top_title_a": "バブル無料チャージスポット",
  "charging_stn.button_bubble": "バブルチャージスポット",
  "charging_stn.button_preparing": "準備中",
  "charging_stn.info_msg": "バブルチャージスポットへのご案内",
  "charging_stn.info_msg_expiration": "チャージスポットで支給された広告リワードの有効期限は 7 日です。",
  "charging_stn.info_msg_refund": "チャージスポットで支給された広告リワードは払い戻しできません。",
  "charging_stn.info_msg_charge_time": "広告の再生後、チャージが反映されるまで最大3分ほどかかる場合があります。",
  "charging_stn.info_msg_inquiry": "チャージができない場合は、各バブルチャージスポットのお問い合わせフォームからご連絡ください。確認後に反映させていただきます。",
  "charging_stn.free_button": "スポット{{int_number}}号",
  "payment.page_bubble_zero": "保有バブル",
  "payment.page_bubble_one": "保有バブル",
  "payment.page_bubble_other": "保有バブル",
  "payment.page_paid_bubble_zero": "有料バブル",
  "payment.page_paid_bubble_one": "有料バブル",
  "payment.page_paid_bubble_other": "有料バブル",
  "payment.page_bonus_bubble_zero": "ボーナスバブル",
  "payment.page_bonus_bubble_one": "ボーナスバブル",
  "payment.page_bonus_bubble_other": "ボーナスバブル",
  "payment.page_reward_bubble_zero": "バブル支給",
  "payment.page_reward_bubble_one": "バブル支給",
  "payment.page_reward_bubble_other": "バブル支給",
  "payment.page_purchase_tab": "チャージする",
  "payment.page_spent_tab": "有料購入",
  "payment.page_bonus_tab": "ボーナス",
  "payment.page_list_bubble_zero": "バブル",
  "payment.page_list_bubble_one": "バブル",
  "payment.page_list_bubble_other": "バブル",
  "payment.history_rewards": "リワード",
  "payment.history_awarded_bonus": "付与されたボーナス",
  "payment.history_expired_bonus": "有効期限切れ",
  "payment.history_ad_reward": "広告リワード支給",
  "payment.history_adj": "調整",
  "payment.history_purchased_ep": "エピソード購入",
  "payment.history_rented_ep": "エピソードレンタル",
  "payment.history_in_app_purchase": "アプリ内課金",
  "payment.history_topup_bubble": "バブル購入",
  "payment.history_refunded": "返金",
  "payment.history_receive_bonus": "イベントに参加してボーナスをゲットしましょう",
  "payment.history_purchase_shampoo_title": "購入",
  "payment.history_purchase_shampoo_detail": "シャンプー決済",
  "payment.history_refund_shampoo": "返金",
  "payment.history_refund_for_censored_image": "表示制限画像の払い戻し",
  "payment.status_progress": "決済を処理中です。",
  "payment.status_failed": "決済に失敗しました。詳細については、<link1>お客様センター</link1>にお問い合わせください。",
  "payment.status_invalid_info": " 入力されたカード情報が無効です。<br/>もう一度お試しください。",
  "payment.status_completed": "決済が完了しました。",
  "payment.status_successful": "決済に成功しました！",
  "payment.unavailable_paid_episodes": "有料エピソードはレンタルおよび購入できません。",
  "chat.home_home_title": "ホーム",
  "chat.home_characters_title": "キャラクター",
  "chat.home_characters_count_zero": "キャラクター",
  "chat.home_characters_count_one": "キャラクター",
  "chat.home_characters_count_other": "キャラクター",
  "chat.home_universes_title": "世界観",
  "chat.home_universes_count_zero": "世界観",
  "chat.home_universes_count_one": "世界観",
  "chat.home_universes_count_other": "世界観",
  "chat.home_scenes_title": "シーン",
  "chat.home_scenes_count_zero": "シーン",
  "chat.home_scenes_count_one": "シーン",
  "chat.home_scenes_count_other": "シーン",
  "chat.home_nsfw_toggle": "スリルモード",
  "chat.home_nsfw_toggle_modal_title": "スリルモードは成人向けコンテンツが含まれます。",
  "chat.home_nsfw_toggle_modal_description": "18歳未満の方はご利用いただけません。<br/>あなたは18歳以上ですか？",
  "chat.home_nsfw_toggle_modal_confirm": "はい、18歳以上です",
  "chat.home_nsfw_toggle_modal_cancel": "いいえ、18歳未満です",
  "chat.home_nsfw_toggle_reject_country_modal_title": "このサービスはお住まいの地域からはご利用になれません。",
  "chat.home_first_title": "あなただけのキャラクターと、あなただけの世界で",
  "chat.home_first_select_character": "どんなキャラクターとお話ししたいですか？",
  "chat.home_first_select_character_female": "女性キャラクター",
  "chat.home_first_select_character_male": "男性キャラクター",
  "chat.home_first_start_chat": "会話を始める",
  "chat.home_first_failed_character_list_message": "キャラクター一覧を取得できませんでした。",
  "chat.home_first_failed_character_list_refresh_message": "もう一度読み込んでください。",
  "chat.home_first_failed_character_list_refresh_button": "再読み込み",
  "chat.home_nsfw_toggle_mobile": "スリル",
  "chat.home_first_shampoo_empty": "シャンプーがすべてなくなりました",
  "chat.home_first_verification_super_shampoo": "今ご本人様認証されましたら、スーパーシャンプーに直ちにアップグレードさせていただきます。 24時間の間、思う存分会話することができるスーパーシャンプーを体験してみてください！",
  "chat.home_first_verification_super_shampoo_description": "*通常のシャンプーの10倍の容量で超たっぷり！<br/>*シャンプーが残っている間は、チャットが無料。<br/>*シャンプーのチャージには、最大24時間かかります。",
  "chat.home_first_verification_no_thanks": "大丈夫です",
  "chat.home_first_verification_button": "本人認証",
  "chat.home_first_upgrade_super_shampoo": "スーパーシャンプーにアップグレードしてみましょう！",
  "chat.home_first_shampoo_bubbles_empty": "通常シャンプーとバブルをすべて使い切りました。",
  "chat.home_first_normal_shampoo_empty": "通常シャンプーをすべて使い切りました。",
  "chat.home_first_get_super_shampoo": "スーパーシャンプーを受け取る",
  "chat.home_first_no_show_again": "今後この案内を表示しない",
  "chat.home_first_verification_super_shampoo_upgrade": "初めての本人認証時、より多くの無料会話ができる'スーパーシャンプー'にアップグレードいたします！",
  "chat.home_first_sign_in": "ログインして<strong>シャンプー</strong>で毎日<br/><strong>無料チャット</strong>楽しんでみてください！",
  "chat.home_first_start_kakao": "<strong>Kakao</strong>で始める",
  "chat.home_first_start_google": "<strong>Google</strong>で始める",
  "chat.home_first_start_apple": "<strong>Apple</strong>で始める",
  "chat.home_first_welcome_title": "ようこそ！",
  "chat.home_first_welcome_sub_title": "ご加入いただいた記念にスーパーシャンプーを付与しました。 様々なキャラクターとたっぷり会話をお楽しみください。",
  "chat.home_first_welcome_description": "10倍の無料チャットを楽しみたい方は、本人認証をしてスーパーシャンプーを受け取ってください。",
  "chat.home_first_welcome_regular": "通常のシャンプーを使う",
  "chat.home_first_welcome_super": "スーパーシャンプーを受けとる",
  "chat.home_first_wait_title": "ちょっと待って！まだチャットが楽しめます。",
  "chat.home_first_wait_description": "10秒で本人認証して、スーパーシャンプーで無料チャットを続けましょう。",
  "chat.home_first_wait_topup": "チャージしに行く",
  "chat.home_first_wait_verify": "本人認証",
  "chat.home_first_supershampoo_title": "スーパーシャンプーにアップグレードされました！",
  "chat.home_first_supershampoo_description": "これで、24 時間10 倍長く会話できます。<br/>スーパーシャンプーは[マイページ]でご確認ください。",
  "chat.home_first_supershampoo_done": "確認",
  "chat.home_more_button": "もっと見る",
  "chat.home_sidebar_create": "作成",
  "chat.home_sidebar_reward": "リワード",
  "chat.home_recent_chats": "最近のチャット",
  "chat.title_chat_list": "チャット一覧",
  "chat.home_sidebar_chat_list": "チャット一覧",
  "chat.home_sidebar_favorites": "お気に入り",
  "chat.home_sidebar_likes": "いいね",
  "chat.home_sidebar_charging_station": "チャージスポット",
  "chat.home_sidebar_guide": "ガイド",
  "chat.home_sidebar_bg_fx": "背景効果",
  "chat.home_sidebar_bubbletap": "BubbleTap",
  "chat.home_sidebar_download": "ダウンロード",
  "chat.home_sidebar_display": "ディスプレイ",
  "chat.home_sidebar_community": "コミュニティ",
  "chat.home_sidebar_discord": "Discord",
  "chat.home_sidebar_bubble_apartment": "バブルのアパート",
  "chat.home_sidebar_facebook": "Facebook",
  "chat.home_sidebar_x": "X公式アカウント",
  "chat.home_sidebar_kakaotalk": "カカオトーク",
  "chat.home_sidebar_threads": "Threads",
  "chat.home_sidebar_instagram": "Instagram",
  "chat.home_sidebar_pinterest": "Pinterest",
  "chat.tap_order_recent": "最新順",
  "chat.tap_order_liked": "いいねが多い順",
  "chat.tap_order_played": "プレイが多い順",
  "chat.tap_asset_sort_all": "週間",
  "chat.tap_asset_sort_week": "全体",
  "chat.tap_asset_sort_month": "月間",
  "chat.tap_asset_tap_rising": "急上昇",
  "chat.tap_asset_tap_follow": "フォロー中",
  "chat.tap_asset_tap_follow_empty": "フォロー中のクリエイターがいません。",
  "chat.tap_asset_tap_follow_featured_creators": "おすすめクリエイター",
  "chat.tap_asset_tap_follow_featured_creators_failed": "おすすめクリエイターの読み込みに失敗しました<br/>しばらくしてから再度お試しください",
  "chat.tap_asset_tap_now": "リアルタイム",
  "chat.tap_asset_more_options_button": "追加設定",
  "chat.tap_asset_more_options_modal_title": "フィルター",
  "chat.tap_asset_more_options_modal_sort": "並び替え",
  "chat.tap_asset_more_options_modal_gender": "キャラクターの性別",
  "chat.tap_asset_modal_all_characters": "すべてのキャラクター",
  "chat.tap_asset_modal_male_characters": "男性キャラクター",
  "chat.tap_asset_modal_female_characters": "女性キャラクター",
  "chat.tap_asset_modal_other_characters": "その他キャラクター",
  "chat.tap_asset_modal_type": "タイプ",
  "chat.tap_asset_modal_random": "ランダム",
  "chat.tap_asset_more_options_modal_latest": "最新順",
  "chat.tap_asset_more_options_modal_multi_images": "マルチイメージ",
  "chat.tap_asset_more_options_modal_most": "多い順",
  "chat.tap_asset_more_options_modal_least": "少ない順",
  "chat.tap_asset_more_options_modal_none": "なし",
  "chat.tap_asset_more_options_modal_most_commented": "コメントが多い順",
  "chat.tap_asset_more_options_modal_sort_none": "選択なし",
  "chat.tap_asset_empty": "条件に一致する結果がありません。",
  "chat.home_login": "ログイン",
  "chat.home_terms_of_service": "利用規約",
  "chat.home_privacy_policy": "プライバシーポリシー",
  "chat.home_operational_policy": "運営ポリシー",
  "chat.home_juvenile_protection_policy": "青少年保護ポリシー",
  "chat.home_app_downloads_appstore": "App StoreでBubbleChatをダウンロード",
  "chat.home_app_downloads_googleplay": "Google PlayでBubbleChatをダウンロード",
  "chat.home_notification_list_unread": "未確認の通知",
  "chat.home_notification_list_read_all": "すべて既読",
  "chat.home_notification_list_view_more": "詳細を見る",
  "chat.home_notification_setting": "通知設定",
  "chat.home_notification_setting_agree_date": "同意日",
  "update.setting_comment_label": "コメント通知",
  "update.setting_comment_description": "あなたの作品に新しいコメントをされると通知を受け取れます。",
  "update.setting_reply_label": "返信通知",
  "update.setting_reply_description": "あなたのコメントに新しい返信をされると通知を受け取れます。",
  "update.setting_like_label": "いいね通知",
  "update.setting_like_description": "あなたの作品、コメント、返信にいいねがされると通知を受け取れます。",
  "update.setting_follow_label": "フォロー通知",
  "update.setting_follow_description": "フォローされると通知を受け取れます。",
  "update.setting_event_label": "イベント通知",
  "update.setting_event_description": "イベントに関する通知を受け取れます。",
  "update.setting_nighttime_event_label": "夜間イベント通知",
  "update.setting_nighttime_event_description": "21時から翌8時までの間にイベント関連の通知を受け取れます。",
  "update.setting_depletion_label": "バブル消費通知",
  "update.setting_depletion_description": "バブルが消費されたときに通知を受け取れます。",
  "update.setting_personal_label": "個人重要通知",
  "update.setting_personal_description": "個人に関する重要な通知をお送りします。",
  "update.setting_official_label": "BubbleChat重要通知",
  "update.setting_official_description": "BubbleChatからのお知らせをお届けします。",
  "chat.list_empty": "気になるキャラクターとチャットを始めてみましょう。",
  "chat.list_menu_view_details": "詳細を見る",
  "chat.list_menu_delete": "削除する",
  "chat.list_menu_delete_alert_cancel": "キャンセル",
  "chat.list_menu_delete_alert_delete": "削除する",
  "chat.list_modal_character_title": "キャラクター",
  "chat.list_modal_character_description": "キャラクターの説明",
  "chat.list_modal_character_information": "詳細情報",
  "chat.list_modal_character_information_gender": "性別",
  "chat.list_modal_character_information_age": "年齢",
  "chat.list_modal_character_information_age_help_text": "*20歳未満のキャラクターは、スリルモードでは作成できません。",
  "chat.list_modal_character_information_job": "職業",
  "chat.list_modal_character_information_character": "性格",
  "chat.list_modal_character_information_speaking_style": "話し方",
  "chat.list_modal_character_information_interests": "趣味",
  "chat.list_modal_character_information_details": "追加説明",
  "chat.list_modal_character_information_details_private_exist": "非公開の追加説明があります。",
  "chat.list_modal_first_sentence": "最初のひとこと",
  "chat.list_modal_universe": "世界観",
  "chat.list_modal_scene": "シーン",
  "chat.list_modal_persona_title": "キャラ設定",
  "chat.list_modal_persona_information": "詳細情報",
  "chat.list_modal_persona_gender": "性別",
  "chat.list_modal_persona_age": "年齢",
  "chat.list_modal_persona_job": "職業",
  "chat.list_modal_persona_character": "性格",
  "chat.list_modal_persona_speaking_style": "話し方",
  "chat.list_modal_persona_interests": "趣味",
  "chat.list_modal_persona_details": "詳細説明",
  "chat.list_modal_universe_title": "世界観",
  "chat.list_modal_universe_relationship": "キャラクターとの関係",
  "chat.list_modal_universe_introduction": "世界観説明",
  "chat.list_modal_universe_details": "追加説明",
  "chat.list_modal_universe_private_relationship": "非公開の関係設定があります。",
  "chat.list_modal_universe_private_details": "非公開の追加説明があります。",
  "chat.list_modal_scene_title": "シーン",
  "chat.list_modal_scene_details": "追加説明",
  "chat.list_modal_scene_private_details": "非公開の追加説明があります。",
  "chat.list_modal_edit_chat_name_title": "チャットルーム名",
  "chat.list_modal_edit_chat_name_placeholder": "チャットルームの名前を入力してください。",
  "chat.list_edit_chat_selected": "{{int_numbers}}個選択しました",
  "chat.list_edit_delete_button": "チャットルーム削除",
  "chat.list_edit_select": "項目選択",
  "chat.list_edit_delete": "削除",
  "chat.list_edit_delete_all": "全削除",
  "chat.list_edit_select_all": "全選択",
  "chat.list_edit_deselect_all": "全解除",
  "chat.list_edit_chats": "チャットルーム編集",
  "chat.list_edit_delete_failed": "削除に失敗しました。 もう一度お試しください。",
  "chat.list_edit_edit_failed": "修正中にエラーが発生しました。 もう一度お試しください。",
  "chat.information_character_title": "キャラクター",
  "chat.information_character_none": "選択されたキャラクターがありません",
  "chat.information_asset_information": "情報",
  "chat.information_asset_information_nsfw": "スリル",
  "chat.information_unit_thousand": "千",
  "chat.information_unit_ten_thousand": "万",
  "chat.information_unit_hundred_million": "億",
  "chat.information_asset_information_first_release": "初公開日",
  "chat.information_character_deleted_account": "退会したユーザー",
  "chat.information_character_deleted_account_toast": "退会したユーザーです。",
  "chat.information_start_chat": "会話を始める",
  "chat.information_start_chat_guest": "無料で無制限チャット",
  "chat.information_resume_chat": "チャットを続ける",
  "chat.information_custom_chat": "カスタムチャット",
  "chat.information_like": "いいね",
  "chat.information_like_fail_message": "いいねに失敗しました。",
  "chat.information_unlike_fail_message": "いいね取り消しに失敗しました。",
  "chat.information_favorite": "お気に入り",
  "chat.information_favorite_fail_message": "お気に入りに失敗しました。",
  "chat.information_unfavorite_fail_message": "お気に入り取り消しに失敗しました。",
  "chat.information_persona": "現在選択されているキャラ設定",
  "chat.information_persona_active": "使用中",
  "chat.information_persona_add": "キャラ設定追加",
  "chat.information_character_introduction": "キャラクター説明",
  "chat.information_information": "詳細情報",
  "chat.information_character_gender": "性別",
  "chat.information_character_age": "年齢",
  "chat.information_character_job": "職業",
  "chat.information_character_character": "性格",
  "chat.information_character_speaking_style": "話し方",
  "chat.information_character_interests": "興味関心",
  "chat.information_details": "追加説明",
  "chat.information_details_user": "自分",
  "chat.information_details_private_only": "非公開の追加説明です",
  "chat.information_details_private_exist": "非公開の追加説明があります",
  "chat.information_first_sentence": "最初のひとこと",
  "chat.information_universe": "世界観",
  "chat.information_universe_none": "選択された世界観がありません",
  "chat.information_more": "もっと見る",
  "chat.information_scene": "シーン",
  "chat.information_scene_none": "選択されたシーンがりません",
  "chat.custom_selected_universe": "選択した世界観",
  "chat.custom_selected_scene": "選択したシーン",
  "chat.information_delete": "削除する",
  "chat.information_edit": "修正する",
  "chat.information_delete_alert_message_universe": "削除すると、その世界観が基本設定されたすべてのキャラクターから除外されます。<br/>それでも削除しますか？",
  "chat.information_delete_alert_message_scene": "削除すると、そのシーンが基本設定されたすべてのキャラクターから除外されます。<br/>それでも削除しますか？",
  "chat.information_delete_alert_message_failed": "削除に失敗しました。 もう一度お試しください。",
  "chat.information_delete_alert_cancel": "キャンセル",
  "chat.information_delete_alert_delete": "削除",
  "chat.information_reviews_submit_button": "コメントする",
  "chat.information_reviews_placeholder": "コメントしてください。",
  "chat.information_reviews_empty": "まだ作成されたコメントがありません。",
  "chat.information_reviews_few_seconds": "数秒前",
  "chat.information_reviews_seconds": "{{int_seconds}}秒前",
  "chat.information_reviews_minutes": "{{int_minutes}}分前",
  "chat.information_reviews_hours": "{{int_hours}}時間前",
  "chat.information_reviews_view_translation": "翻訳を見る",
  "chat.information_reviews_view_original": "原文を見る",
  "chat.information_reviews_view_translation_unsupported_language_toast": "未対応の言語です。",
  "chat.information_reviews_delete failed": "削除に失敗しました。",
  "chat.information_reviews_deleted_user_username": "退会したユーザー",
  "chat.information_reviews_deleted_user_review": "退会したユーザーのコメントです。",
  "chat.information_reviews_deleted_review": "削除されたコメントです。",
  "chat.information_replies": "返信",
  "chat.information_sort_recent": "最新順",
  "chat.information_sort_liked": "人気順",
  "chat.information_new_comment": "新しいコメントがあります。",
  "chat.information_new_reply": "あなたのコメントに新しい返事があります。",
  "chat.information_write_comment": "コメントをしてください。",
  "chat.information_write_reply": "返信する",
  "chat.information_reply_delete_fail_message": "返信を削除できません。",
  "chat.information_delete_comment_alert": "本当にコメントを削除しますか？",
  "chat.information_delete_reply_alert": "本当に返信を削除しますか？",
  "chat.information_comment_characters_limit_message": "コメントは最大1,000文字まで入力できます。",
  "chat.information_reply_characters_limit_message": "返信は最大1,000文字まで入力できます。",
  "chat.information_comment_character": "{{string_characterName}} キャラクターにコメントがあります。",
  "chat.information_comment_universe": "{{string_universeName}}の世界観にコメントがあります。",
  "chat.information_comment_scene": "{{string_sceneName}}シーンにコメントがあります。",
  "chat.information_comment_edit_placeholder": "内容を入力してください。",
  "chat.information_reply_edit_placeholder": "内容を入力してください。",
  "chat.information_comment_edit": "修整",
  "chat.information_comment_delete": "削除",
  "chat.information_comment_edit_done": "修整",
  "chat.information_comment_edit_cancel": "キャンセル",
  "chat.information_comment_view_all_comment": "コメント全体を見る",
  "chat.information_comment_pin_failed": "コメントの固定に失敗しました。",
  "chat.information_comment_unpin_failed": "コメントの固定解除に失敗しました。",
  "chat.information_comment_post_failed": "コメントの作成に失敗しました。",
  "chat.information_comment_edit_failed": "コメントの編集に失敗しました。",
  "chat.information_comment_delete_success": "コメントが削除されました。",
  "chat.information_comment_delete_failed": "コメントの削除に失敗しました。",
  "chat.information_comment_like_failed": "コメントのいいねに失敗しました。",
  "chat.information_comment_report_success": "通報が完了しました。",
  "chat.information_comment_report_failed": "通報に失敗しました。",
  "chat.information_reply_post_failed": "返信の作成に失敗しました。",
  "chat.information_reply_edit_failed": "返信の修正に失敗しました。",
  "chat.information_reply_delete_success": "返信が削除されました。",
  "chat.information_reply_delete_failed": "返信の削除に失敗しました。",
  "chat.information_reply_like_failed": "返信のいいねに失敗しました。",
  "chat.information_reply_report_success": "通報が完了しました。",
  "chat.information_reply_report_failed": "通報に失敗しました。",
  "chat.information_comment_reply_deleted_comment": "削除されたコメントには返信できません。",
  "chat.information_comment_pin_deleted_comment": "削除されたコメントは固定または解除できません。",
  "chat.information_reviews_report": "通報する",
  "chat.information_reviews_report_modal_title": "コメントを通報する",
  "chat.information_reply_report_modal_title": "返信を通報する",
  "chat.information_reply_deleted_user": "退会したユーザーの返信です。",
  "chat.information_reply_deleted": "削除された返信です。",
  "chat.information_leave_reply": "返信してみましょう。",
  "chat.information_comment_button_submit_only": "送信",
  "chat.information_comment_show_more": "もっと見る",
  "chat.information_comment_show_less": "表示を減らす",
  "chat.information_comment_show_more2": "開く",
  "chat.information_reviews_report_modal_description": "通報理由を教えてください。",
  "chat.information_reviews_report_modal_dropdown": "通報理由選択",
  "chat.information_reviews_report_modal_misconduct": "不適切な活動",
  "chat.information_reviews_report_modal_unapproved": "無許可広告",
  "chat.information_reviews_report_modal_personal": "個人情報流出",
  "chat.information_reviews_report_modal_promo": "広告",
  "chat.information_reviews_report_modal_other": "その他",
  "chat.information_reviews_report_modal_placeholder": "通報事由作成",
  "chat.information_reviews_report_modal_cancel": "キャンセル",
  "chat.information_reviews_report_modal_submit": "送信",
  "chat.information_character_report_modal_title": "キャラクターを通報する",
  "chat.information_universe_report_modal_title": "世界観を通報する",
  "chat.information_scene_report_modal_title": "シーンを通報する",
  "chat.information_asset_report_modal_copyright_title": "盗作/著作権侵害",
  "chat.information_asset_report_modal_copyright_description": "盗作または著作権侵害の報告は、証拠資料および書類に従って処理されます。",
  "chat.information_universe_introduction": "世界観説明",
  "chat.information_universe_relationship": "キャラクターとの関係",
  "chat.information_relationship_private_only": "非公開の関係設定です。",
  "chat.information_relationship_private_exist": "非公開関係設定があります。",
  "chat.information_scene_introduction": "紹介文",
  "chat.information_scene_place": "場所",
  "chat.information_scene_time": "時間帯",
  "chat.information_character_load_fail_message": "キャラクター情報の読み込みに失敗しました。",
  "chat.information_universe_load_fail_message": "世界観情報の読み込みに失敗しました。",
  "chat.information_scene_load_fail_message": "シーン情報の読み込みに失敗しました。",
  "chat.information_private_fail_message_character": "存在しないキャラクターです。",
  "chat.information_private_fail_message_universe": "存在しない世界観です。",
  "chat.information_private_fail_message_scene": "存在しないシーンです。",
  "chat.information_no_chat_nsfw_characters": "20歳以下のキャラクターとはスリルモードで会話ができません。",
  "chat.information_character_details_private_only": "非公開の人物説明です",
  "chat.information_character_details_private_exist": "非公開の人物説明があります",
  "chat.information_background_details_private_only": "非公開の背景説明です",
  "chat.information_background_details_private_exist": "非公開の背景説明があります",
  "chat.information_lorebook_private_only": "非公開の設定集です",
  "chat.information_lorebook_private_exist": "非公開設定集が存在します",
  "chat.information_weekly_character": "週間人気キャラクター",
  "chat.information_weekly_universe": "週間人気世界観",
  "chat.information_weekly_scene": "週間人気シーン",
  "chat.custom_title": "カスタムチャット",
  "chat.custom_help_text_title": "自分だけのチャットを作成してみましょう！",
  "chat.custom_help_text_description": "お好みの組み合わせでカスタムしてチャットを始めることができます",
  "chat.custom_character": "キャラクター",
  "chat.custom_universe": "世界観",
  "chat.custom_optional": "選択",
  "chat.custom_scene": "シーン",
  "chat.custom_add": "追加する",
  "chat.custom_change": "変更する",
  "chat.custom_create": "作成する",
  "chat.custom_first_sentence": "最初のひとこと",
  "chat.custom_first_sentence_placeholder": "{{string_characterName}}の最初のひとことを入力してください。",
  "chat.custom_first_sentence_edit_modal_title": "最初のひとことを修正",
  "chat.custom_first_sentence_edit_modal_description": "キャラクターの最初のひとことを修正できます！",
  "chat.custom_first_sentence_edit_modal_placeholder": "{{string_characterName}}の最初のひとことを入力してください。",
  "chat.custom_first_sentence_edit_modal_cancel": "キャンセル",
  "chat.custom_first_sentence_edit_modal_save": "修正",
  "chat.custom_start_chat": "チャットを始める",
  "chat.custom_character_modal_title": "キャラクター選択",
  "chat.custom_modal_done": "選択完了",
  "chat.custom_modal_tag_placeholder": "タグを検索してみてください",
  "chat.custom_modal_tap_recents": "最近のプレイ",
  "chat.custom_modal_tap_favorites": "お気に入り",
  "chat.custom_character_modal_tap_my": "自分のキャラクター",
  "chat.custom_universe_modal_title": "世界観の選択",
  "chat.custom_universe_modal_tap_my": "私の世界観",
  "chat.custom_scene_modal_title": "シーン選択",
  "chat.custom_scene_modal_tap_my": "自分のシーン",
  "chat.custom_select_character": "キャラクターを選択してください",
  "chat.custom_select_universe": "世界観を選択してください",
  "chat.custom_select_scene": "シーンを選択してください",
  "chat.custom_retry": "再試行",
  "chat.custom_back_home": "ホームに戻る",
  "chat.custom_find_character_failed": "お探しのキャラクターが見つかりませんか？",
  "chat.custom_go_create_character": "自分のキャラクターを作りに行く",
  "chat.custom_report_once": "通報は一度だけできます。",
  "chat.custom_private_universe_selected": "非公開の世界観が選択されています。 別の世界観を選んでください。",
  "chat.custom_private_scene_selected": "非公開のシーンが選択されています。他のシーンを選んでください。",
  "chat.custom_nsfw_age_verification": "スリルモードのキャラクター/世界観/シーンは成人認証後にご利用いただけます。",
  "chat.custom_no_exist_assets": "存在しないキャラクター/世界観/シーンが含まれています。 もう一度お試しください。",
  "chat.custom_create_chat_failed": "チャットルームの作成に失敗しました。 もう一度お試しください。",
  "chat.custom_search_characters": "キャラクターを検索してみてください",
  "chat.custom_search_universes": "世界観を検索してみてください",
  "chat.custom_search_scenes": "シーンを検索してみてください",
  "chat.custom_search_no_results": "検索結果がありません",
  "chat.custom_select_modal_asset_same_language": "同じ言語設定で制作された世界観とシーンのみデフォルトに設定できます。",
  "chat.character.list_empty": "キャラクターが見つかりません",
  "chat.universe.list_empty": "世界観が見つかりません",
  "chat.scene.list_empty": "シーンが見つかりません",
  "chat.popup_settings_title": "チャットルーム設定",
  "chat.popup_name_title": "名前",
  "chat.popup_name_placeholder": "名前を入力してください",
  "chat.popup_chat_mode_title": "スタイル",
  "chat.popup_chat_mode_chat": "チャット形式",
  "chat.popup_chat_mode_story": "小説形式",
  "chat.popup_model_title": "AIモデル",
  "chat.popup_model_estimated_cost": "想定価格",
  "chat.popup_model_estimated_cost_failed": "応答失敗",
  "chat.popup_model_estimated_cost_description": "入力したプロンプト量、累積会話量、回答の長さによってコストが変動する場合があります。",
  "chat.popup_model_diamond": "ダイヤ",
  "chat.popup_model_dia_description": "創造性と理解力に優れた高品質モデル",
  "chat.popup_model_price_bubble": "バブル",
  "chat.popup_model_emerald": "エメラルド",
  "chat.popup_model_emerald_description": "バランスの取れた表現力を持つ安定型モデル",
  "chat.popup_model_ruby": "ルビー",
  "chat.popup_model_ruby_description": "コスパ重視＆高速モデル",
  "chat.popup_model_best": "おすすめ",
  "chat.popup_nsfw_toggle_title": "スリルモード",
  "chat.popup_nsfw_toggle_description_nsfw_enable": "スリルモードを有効にすると、より刺激的な会話ができます。",
  "chat.popup_nsfw_toggle_description_nsfw_disable": "18歳未満のキャラクターとはスリルモードでチャットができません。",
  "chat.popup_done": "確認",
  "chat.popup_label_new": "New",
  "chat.popup_label_beta": "Beta",
  "chat.popup_label_value": "コスパ",
  "chat.popup_label_sale": "割引中",
  "chat.popup_label_date": "~{{int_date}}まで",
  "chat.popup_chat_ai_model_signature": "代表作",
  "chat.popup_chat_ai_model_basic": "一般",
  "chat.conversation_ai_model_basic_failed_message": "メッセージの受信に失敗しました。 バブルは差し引かれていません。",
  "chat.conversation_ai_model_basic_switch_failed": "AIモデルの変更に失敗しました。",
  "chat.popup_character_switched_nsfw_alert": "該当キャラクターがスリルモードに変更されました。",
  "chat.popup_character_switched_nsfw_alert_description": "年齢確認後にチャットができます。",
  "chat.popup_nsfw_asset_normal_mode_failed_message": "スリルモードのキャラクター／世界観／シーンは、一般モードでは会話できません。",
  "chat.conversation_menu": "チャットルーム管理",
  "chat.conversation_username": "名前",
  "chat.conversation_menu_gallery": "ギャラリー",
  "chat.conversation_menu_display_images": "画像を見る",
  "chat.conversation_menu_gallery_unlock_button": "アンロックする",
  "chat.conversation_menu_gallery_unlock_image": "チャットを通じて画像を獲得してみましょう。",
  "chat.conversation_menu_gallery_no_images": "ギャラリーに画像がありません。",
  "chat.conversation_menu_settings": "チャットルーム設定",
  "chat.conversation_menu_oldbie_shampoo": "シャンプー",
  "chat.conversation_menu_newbie_shampoo": "スーパーシャンプー",
  "chat.conversation_menu_hyper_shampoo": "ハイパーシャンプー",
  "chat.conversation_menu_shampoo_loading": "リフィル中",
  "chat.conversation_menu_shampoo_error": "リフィル失敗",
  "chat.popup_new_user_title": "ご登録ありがとうございます！",
  "chat.popup_new_user_description": "登録記念として無料会話ができる'シャンプー'を差し上げます!",
  "chat.popup_newbie_shampoo_title": "スーパーシャンプーにアップグレード完了！",
  "chat.popup_newbie_shampoo_description": "これから 24 時間、スーパー シャンプーを使用して、より多くの無料会話を楽しむことができます。",
  "chat.popup_same_identity_under_seven_days_description": "本人認証したアカウントを退会後7日以内には同一名義での本人認証ができません。",
  "chat.popup_same_identity_over_seven_days_description": "既存のユーザーのため、通常のシャンプーを使用して無料チャットが可能です。",
  "chat.popup_newbie_shampoo_history_exist_description": "このアカウントで、すでにスーパーシャンプーの特典を受けているため、通常のシャンプーを使って無料会話ができます。",
  "chat.popup_newbie_to_oldbie_title": "スーパーシャンプーの利用が終了しました。",
  "chat.popup_newbie_to_oldbie_description": "今後は通常のシャンプーを使って無料会話ができます。",
  "chat.popup_newbie_to_oldbie_description_purchase": "今すぐ追加購入されますか？",
  "chat.popup_shampoo_limit_message": "シャンプーを使い切りました。<br/>今後はバブルを使って会話できます。",
  "chat.conversation_menu_charging_station": "バブルをチャージする",
  "chat.popup_persona_in_use": "使用中のキャラ設定モード",
  "chat.popup_persona_notes": "メモ",
  "chat.popup_persona_notes_placeholder": "キャラ設定について簡単にメモしてください",
  "chat.popup_persona_pass_message": "今すぐシャンプーをアップグレードし、拡張されたキャラ設定をご利用してみてください。",
  "chat.popup_persona_pass_alert_message": "現在の利用券の文字数制限を超えたキャラ設定です。<br/>利用券を購入するか、キャラ設定の文字数を調整してください。",
  "chat.popup_persona_content_empty": "",
  "chat.popup_persona_deleted_title": "削除されたキャラ設定を使用中です。",
  "chat.popup_persona_deleted_description": "キャラ設定を変更すると、元に戻すことができません。 <br/>キャラ設定を変更しますか？",
  "chat.popup_usernote_title": "ユーザーノート",
  "chat.popup_usernote_in_use": "使用中のユーザーノート",
  "chat.popup_usernote_pass_message": "今すぐシャンプーをアップグレードして、拡張されたユーザーノートをご利用してみてください。",
  "chat.popup_usernote_pass_alert_message": "現在の利用券の文字数制限を超えたユーザーノートです。<br/>利用券をご購入いただくか、ユーザーノートの文字数を調整してください。",
  "chat.popup_usernote_content_title": "内容",
  "chat.popup_usernote_content_placeholder": "キャラクターが覚えてほしい内容を入力してください",
  "chat.popup_usernote_toggle": "チャットに適用する",
  "chat.popup_usernote_save": "保存",
  "chat.popup_usernote_save_fail_message": "保存に失敗しました。",
  "chat.popup_usernote_fail_message": "ユーザー ノートの読み込みに失敗しました。",
  "chat.popup_usernote_copied_toast": "ユーザーノートの内容がコピーされました。",
  "chat.popup_usernote_copied_failed_toast": "ユーザーノートのコピーに失敗しました。<br/>もう一度お試しください",
  "chat.popup_edit_user_message_title": "自分が送ったメッセージ",
  "chat.popup_edit_character_message_title": "キャラクターからのメッセージ",
  "chat.popup_edit_edit_button": "修正",
  "chat.popup_edit_placeholder": "内容を入力してください。",
  "chat.popup_edit_deleted_message": "削除されたメッセージです。",
  "chat.popup_rpm_limit_description_one": "メッセージの送信に失敗しました。 {{int_seconds}}秒後にもう一度お試しください。",
  "chat.popup_rpm_limit_description_other": "メッセージの送信に失敗しました。 {{int_seconds}}秒後にもう一度お試しください。",
  "chat.popup_exit_title": "チャットルームから退出しますか？",
  "chat.popup_exit_description": "選択中のキャラクターとのすべてのチャットが削除されます",
  "chat.bottom_exit_title": "チャットルームを退出する",
  "chat.popup_purchase_title": "バブルが不足していて、会話を続けることができません。",
  "chat.popup_purchase_description": "バブルをチャージした後、キャラクターと引き続き会話してみてください。",
  "chat.popup_purchase_event_per_chat": "1チャットあたり",
  "chat.popup_purchase_button": "チャージしに行く",
  "chat.conversation_send_message_placeholder": "状況説明は * * 間に",
  "chat.conversation_shampoo_refill_alert_toast": "シャンプーが{{int_number}}%です！",
  "chat.conversation_shampoo_refill_alert_toast_button": "シャンプーのリフィル",
  "chat.conversation_current_shampoo_refill_message_modal": "現在のシャンプー残量",
  "chat.conversation_current_shampoo_refill_description1_modal": "あっ！シャンプーが切れちゃいました！🫣",
  "chat.conversation_current_shampoo_refill_description2_modal": "今リフィルすればスムーズに続けられます。",
  "chat.conversation_current_super_shampoo_refill_description3_modal": "スーパ―シャンプーの期間延長はなく、その場で残量のみを即時チャージする商品です。",
  "chat.conversation_current_hyper_shampoo_refill_description3_modal": "ハイパーシャンプーの期間延長なしに、即時チャージのみ行われる商品です。",
  "chat.conversation_current_shampoo_refill_description5_modal": "現在の利用券の最大文字数を超えました。",
  "chat.conversation_current_shampoo_refill_description6_modal": "現在の利用券では最大<strong>{{string_textCount}}文字</strong>までしか適用されません。<br/>利用券をご購入いただくか、ユーザーノートの文字数を調整してください。",
  "chat.conversation_current_shampoo_refill_description7_modal": "現在の利用券では最大<strong>{{string_textCount}}文字</strong>までしか適用されません。<br/>利用券をご購入いただくか、キャラ設定の文字数を調整してください。",
  "chat.conversation_current_shampoo_refill_description8_modal": "シャンプーがなくなり、使用可能な文字数が少なくなりました。",
  "chat.conversation_current_shampoo_refill_description9_modal": "現在の状態では最大{{string_textCount}}文字までしか適用されません。<br/>シャンプーをリフィルするか、ユーザーノートの文字数を調整してください。",
  "chat.conversation_current_shampoo_refill_description10_modal": "現在の状態では最大{{string_textCount}}文字までしか適用されません。<br/>シャンプーをリフィルしていただくか、キャラ設定の文字数を調整してください。",
  "chat.conversation_current_shampoo_refill_description11_modal": "使用中のキャラ設定とユーザーノートが正常に反映されないことがあります。",
  "chat.conversation_expired_ai_model_change_modal": "このモデルのサービスは終了しました。<br/>別のモデルを選択してください。",
  "chat.conversation_ai_model_change_modal": "チャットルームで使用中のモデルの<br/>サービスが終了しました。",
  "chat.conversation_ai_model_change_description_modal": "右上のアイコンをクリックして、<br/>「使用中のAIモデル」を変更してください。",
  "chat.conversation_ai_model_change_alert_toast": "サービスが終了したモデルです。<br/>「使用中のAIモデル」を変更してください。",
  "chat.conversation_ai_model_pass_modal_title": "シャンプーのアップグレードが必要です",
  "chat.conversation_ai_model_pass_modal_description1": "現在の利用券では、選択したモデルを使用することはできません",
  "chat.conversation_ai_model_pass_modal_description2": "利用券を購入し、より多様なモデルで会話を交わしてみてください",
  "chat.conversation_ai_model_pass_modal_back_button": "戻る",
  "chat.conversation_ai_model_change_modal2_title": "現在の利用券の状態で利用できないモデルです",
  "chat.conversation_ai_model_change_modal2_description": "右上のアイコンをクリックし、 '使用中のAIモデル'を変更してください",
  "chat.conversation_ai_model_change_alert_toast2": "現在の利用券では、選択したモデルを使用することはできません",
  "chat.conversation_image_unlock_popup_message": "新しい画像を獲得しました！",
  "chat.conversation_delete_alert_message": "本当にメッセージを削除しますか？",
  "chat.conversation_delete_alert_message_cancel": "キャンセル",
  "chat.conversation_delete_alert_message_delete": "削除",
  "chat.conversation_delete_message": "メッセージが削除されました。",
  "chat.conversation_text_input_limit_message": "メッセージは最大2000文字まで入力できます。",
  "chat.conversation_send_message_fail_message": "メッセージの送信に失敗しました。",
  "chat.conversation_edit_message_fail_message": "メッセージの修正に失敗しました。",
  "chat.conversation_delete_message_fail_message": "メッセージの削除に失敗しました。",
  "chat.conversation_send_message_fallback_message": "メッセージの受信に失敗しました。<br/>チャットルームに入り直してください。",
  "chat.conversation_edit_message_latest_message": "最新のメッセージのみ修正できます。",
  "chat.conversation_delete_message_latest_message": "最新のメッセージのみ削除できます。",
  "chat.conversation_reroll_message_latest_message": "最新のメッセージのみリロールできます。",
  "chat.conversation_new_chat_deleted_character": "削除されたキャラクターが含まれているため、チャットができません。",
  "chat.conversation_new_chat_deleted_universe": "削除された世界観が含まれているため、チャットをすることはできません。",
  "chat.conversation_new_chat_deleted_scene": "削除されたシーンが含まれているため、チャットをすることはできません。",
  "chat.conversation_load_fail_message": "チャットの読み込みに失敗しました。",
  "chat.conversation_action": "状況説明",
  "chat.conversation_image_alert_deleted": "削除された画像です。",
  "chat.conversation_image_alert_failed_pin": "画像の固定に失敗しました。",
  "chat.conversation_select_model": "モデルを選択してください",
  "chat.conversation_chat_title": "チャット",
  "chat.conversation_alert_animated_image": "このブラウザではアニメーション画像の再生に対応していません。",
  "chat.conversation_alert_load_persona_failed": "キャラ設定情報の読み込みに失敗しました。",
  "chat.conversation_select_persona": "キャラ設定を選択してください",
  "chat.conversation_failed_load_message": "メッセージの読み込みに失敗しました。",
  "chat.conversation_copied_toast": "コピーしました",
  "chat.conversation_sidebar_ai_model": "使用中のAIモデル",
  "chat.conversation_sidebar_my_persona": "私のキャラ設定",
  "chat.conversation_sidebar_character": "キャラクター",
  "chat.conversation_sidebar_universe": "世界観",
  "chat.conversation_sidebar_scene": "シーン",
  "chat.conversation_sidebar_bubbles": "バブル",
  "chat.conversation_sidebar_free_charging_station": "無料チャージスポット",
  "chat.conversation_sidebar_next_refill": "次回リフィル",
  "chat.conversation_sidebar_full_refill": "すべてリフィル",
  "chat.conversation_sidebar_memory": "メモリー",
  "chat.conversation_sidebar_settings": "環境設定",
  "chat.conversation_sidebar_output_settings": "出力設定",
  "chat.conversation_modal_shampoo_refill_regular_description": "10倍のスピードでリフィル、10倍の容量！今すぐスパーシャンプーにアップグレードしよう！",
  "chat.conversation_modal_shampoo_refill_title": "リフィルまでの残り時間",
  "chat.conversation_modal_shampoo_refill_count": "残りの時間",
  "chat.conversation_modal_shampoo_refill_count_day": "{{int_numbers}}日",
  "chat.conversation_modal_shampoo_refill_count_hour": "{{int_numbers}}時間",
  "chat.conversation_modal_shampoo_refill_count_minute": "{{int_numbers}}分",
  "chat.conversation_modal_shampoo_refill_count_second": "{{int_numbers}}秒",
  "chat.conversation_modal_tag_first_buy": "1回限り",
  "chat.conversation_modal_tag_n_buy": "{{int_numbers}}回限り",
  "chat.conversation_modal_topup_button": "チャージスポットへ移動",
  "chat.conversation_modal_Hold_on": "ちょっと待ってください！",
  "chat.conversation_sidebar_long_term_memory": "長期記憶",
  "chat.conversation_long_term_memory_title": "長期記憶",
  "chat.conversation_long_term_memory_auto_summary": "自動要約",
  "chat.conversation_long_term_memory_content_label": "内容",
  "chat.conversation_long_term_memory_content_placeholder": "キャラクターに覚えておいてほしい内容を入力してください。",
  "chat.conversation_long_term_memory_history_button": "履歴",
  "chat.conversation_long_term_memory_ok_button": "確認",
  "chat.conversation_long_term_memory_history_title": "過去の記憶を確認して読み込めます",
  "chat.conversation_long_term_memory_history_latest": "新着順",
  "chat.conversation_long_term_memory_history_earliest": "古い順",
  "chat.conversation_long_term_memory_history_back": "退出",
  "chat.conversation_long_term_memory_history_save": "保存",
  "chat.conversation_long_term_memory_history_empty": "保存された記憶の履歴はありません。",
  "chat.conversation_long_term_memory_edit_content": "内容",
  "chat.conversation_long_term_memory_failed_delete": "削除が完了しませんでした。しばらくしてからもう一度お試しください。",
  "chat.conversation_long_term_memory_delete": "削除",
  "chat.conversation_long_term_memory_cancel": "キャンセル",
  "chat.conversation_long_term_memory_edit_title": "長期記憶の編集",
  "chat.conversation_long_term_memory_failed_save": "保存に失敗しました。",
  "chat.conversation_long_term_memory_select_history": "項目を選択",
  "chat.conversation_long_term_memory_setting": "設定",
  "chat.conversation_long_term_memory_next_summary_in": "次の要約まで",
  "chat.conversation_long_term_memory_turn_zero": "ターン",
  "chat.conversation_long_term_memory_turn_one": "ターン",
  "chat.conversation_long_term_memory_turn_other": "ターン",
  "chat.conversation_long_term_memory_summary_settings": "要約設定",
  "chat.conversation_long_term_memory_summary_frequency": "要約周期",
  "chat.conversation_long_term_memory_character_limit": "文字数制限",
  "chat.conversation_long_term_memory_characters": "字",
  "chat.conversation_long_term_memory_character_limit_description": "要約された内容が文字数制限に達すると、すべての記憶が圧縮して保存され、履歴が作成されます。",
  "chat.conversation_long_term_memory_summary_prompt_title": "要約プロンプト",
  "chat.conversation_long_term_memory_character_auto_button": "自動",
  "chat.conversation_long_term_memory_character_custom_button": "直接入力",
  "chat.conversation_long_term_memory_character_custom_description": "*設定された内容は、すべてのチャットルームに一括して適用されます",
  "chat.conversation_long_term_memory_auto_summary_toast": "要約内容は累積で保存され、一定の文字数に達すると自動的に圧縮されます",
  "chat.conversation_long_term_memory_replace_history_alert": "現在の内容が選択した履歴に置き換わります。適用してもよろしいですか？",
  "chat.conversation_long_term_memory_apply_button": "適用",
  "chat.conversation_long_term_memory_unsaved_alert_message": "保存されていない変更があります。このまま移動しますか？",
  "chat.conversation_long_term_memory_apply_failed_toast": "適用中に問題が発生しました。もう一度お試しください。",
  "chat.conversation_output_environment_title": "出力設定",
  "chat.conversation_output_environment_control_memory_title": "記憶力の調整",
  "chat.conversation_output_environment_control_max_output_title": "最大出力量の調整",
  "chat.conversation_output_environment_description1": "記憶力を高く設定するほど、消費されるリソース量が増加します",
  "chat.conversation_output_environment_description2": "記憶力の設定が長期記憶の要約周期より短い場合、重要な会話を忘れてしまう可能性があります。同じか、それ以上の長さに設定することをおすすめします",
  "chat.conversation_output_environment_description3": "出力量を増やすほど、消費されるリソース量が増加します",
  "chat.conversation_output_environment_description4": "変更した設定は、次の出力から適用されます",
  "chat.conversation_output_environment_description5": "設定内容は、すべてのチャットルームに一括で適用されます",
  "chat.conversation_output_environment_save_modal_title": "変更内容を保存しますか？",
  "chat.conversation_output_environment_save_modal_description": "設定内容は、すべてのチャットルームに一括で適用されます",
  "chat.conversation_chat_settings_image_display": "画像ビューア",
  "chat.conversation_chat_settings_image_display_text": "テキスト",
  "chat.conversation_image_unlock_locked_image": "非公開画像です",
  "chat.conversation_image_unlock_with_bubbles": "バブルでアンロックする",
  "chat.conversation_image_unlock_no_with_bubbles": "バブルではアンロックできません",
  "chat.conversation_image_unlock_image_title": "画像をアンロック",
  "chat.conversation_image_unlock_your_bubbles": "保有バブル",
  "chat.conversation_image_unlock_unlocked_image": "アンロック済みの画像",
  "chat.conversation_image_unlock_unlockable_image": "アンロック可能",
  "chat.conversation_image_unlock_no_bubble_unlock": "アンロック不可",
  "chat.conversation_image_unlock_selected_image": "選択した画像",
  "chat.conversation_image_unlock_all_unlockable_image": "アンロック可能なすべての画像",
  "chat.conversation_image_unlock_refund_bubble_description": "画像のアンロックに使用されたバブルは返金できません。",
  "chat.conversation_image_unlock_not_enough_bubbles": "バブルが不足しているため<br/>画像をアンロックできません。",
  "chat.conversation_image_unlock_top_up_bubbles": "バブルををチャージして、画像をアンロックしましょう。",
  "chat.conversation_image_unlock_current_bubbles": "現在のバブル",
  "chat.conversation_image_unlock_required_bubbles": "アンロックに必要なバブル",
  "chat.conversation_image_unlock_missing_bubbles": "不足しているバブル",
  "chat.conversation_image_unlock_cancel_button": "閉じる",
  "chat.conversation_image_unlock_top_up_button": "チャージしに行く",
  "chat.conversation_image_unlock_failed": "画像のアンロックに失敗しました。",
  "chat.conversation_image_unlock_failed_description": "もう一度お試しください。",
  "chat.conversation_image_unlock_failed_button": "確認",
  "chat.conversation_image_unlock_already_unlocked": "すでにアンロック済みの画像です。",
  "chat.conversation_image_unlock_already_unlocked_button": "確認",
  "chat.conversation_streaming_mode_off_alert_toast": "現在の会話は従来のチャットモードで提供されています。<br/>タイピングモードは復旧作業中です。",
  "chat.conversation_streaming_mode_on_alert_toast": "タイピングモードが再びご利用いただけるようになりました。",
  "chat.conversation_markdown_mode_on_alert_toast": "マークダウンの使用が有効になりました。",
  "chat.conversation_markdown_mode_off_alert_toast": "マークダウンが無効になっており、回復中です。",
  "chat.conversation_message_send_error_alert_toast": "メッセージの受信に失敗しました。<br/>バブルは消費されておりませんのでご安心ください。",
  "chat.conversation_streaming_message_error_alert_toast": "リクエストの処理中に問題が発生しました。<br/>しばらく時間をおいてから再度お試しください。",
  "chat.conversation_prohibited_content_error_toast": "AIモデルが該当メッセージへの回答生成を拒否しました。バブル/シャンプーは消費されませんでした。",
  "chat.conversation_prohibited_content_no_charge_toast": "AIコンテンツフィルターのため、メッセージの受信に失敗しました。 バブル/シャンプーは差し引かれません",
  "chat.conversation_chat_new_conversation_button": "新しくチャットする",
  "chat.conversation_chat_new_conversation_modal_select_title": "最初のひとことを選択",
  "chat.conversation_chat_new_conversation_modal_start_conversation_button": "会話を始める",
  "chat.conversation_chat_copy_button": "チャットルームをコピー",
  "chat.conversation_chat_copied_toast": "チャットルームが最近の会話リストにコピーされました",
  "chat.conversation_chat_copied_failed_toast": "チャットルームのコピーに失敗しました",
  "chat.conversation_reconnect_toast": "新しい応答が表示されない場合は、ネットワーク接続を確認して再度入室してください。",
  "chat.conversation_limit_toast": "シャンプーがすべて使用され、ユーザーノートとキャラ設定の適用範囲が制限されることがあります",
  "chat.conversation_usernote_limit_toast": "シャンプーがすべて消費されると、ユーザーノートの適用範囲が制限されます。（最大500文字）",
  "chat.conversation_persona_limit_toast": "シャンプーがすべて消費されると、キャラ設定の適用範囲が制限されます。 (最大 250文字)",
  "chat.conversation_bookmark": "ブックマーク",
  "chat.conversation_bookmark_number": "ブックマーク {{int_numbers}}",
  "chat.conversation_bookmark_button": "チャットに移動する",
  "chat.conversation_bookmark_add_title": "ブックマーク追加",
  "chat.conversation_bookmark_edit_title": "ブックマーク修正",
  "chat.conversation_bookmark_note": "メモ",
  "chat.conversation_bookmark_note_placeholder": "ご自由に入力してください",
  "chat.conversation_bookmark_note_description": "*作成された内容は、チャットに影響を与えません",
  "chat.conversation_bookmark_empty": "保存されたブックマークがありません",
  "chat.conversation_bookmark_no_content": "リロールまたは削除により存在しない内容です",
  "chat.conversation_bookmark_delete_success": "ブックマークが削除されました",
  "chat.conversation_bookmark_delete_failed": "ブックマークの削除に失敗しました",
  "chat.conversation_bookmark_edit_success": "ブックマークが修正されました",
  "chat.conversation_bookmark_edit_failed": "ブックマークの修正に失敗しました",
  "chat.conversation_export_as_txt": "テキストで保存",
  "chat.conversation_export_as_txt_modal_description": "会話内容すべてをテキストファイルとして保存しますか？",
  "chat.conversation_sidebar_extra_settings": "追加設定",
  "chat.conversation_extra_settings_mask_my_name": "名前を非表示",
  "chat.conversation_mask_my_name_user": "ユーザー",
  "chat.custom_modal_preview_character_dialogue": "キャラクターのセリフです",
  "chat.custom_modal_preview_character_dialogue_mask_on": "あなたのことを「User」と呼んでいます。",
  "chat.custom_modal_preview_character_dialogue_mask_off": "あなたのことを「{{user}}」と呼んでいます。",
  "chat.custom_modal_preview_character_narration": "キャラクター状況説明です",
  "chat.custom_modal_preview_user_dialogue": "ユーザーのセリフです",
  "chat.custom_modal_preview_user_narration": "ユーザーの状況説明です",
  "chat.custom_modal_viewer_settings": "表示設定",
  "chat.custom_modal_viewer": "表示",
  "chat.custom_modal_viewer_background": "背景",
  "chat.custom_modal_transparency": "透明度",
  "chat.custom_modal_text_settings": "テキスト設定",
  "chat.custom_modal_text_size": "サイズ",
  "chat.custom_modal_color_settings": "カラー設定",
  "chat.custom_modal_color_settings_reset_button": "リセット",
  "chat.custom_modal_preset_button": "プリセット",
  "chat.custom_modal_custom_button": "カスタム",
  "chat.custom_modal_theme_dark": "ダーク",
  "chat.custom_modal_theme_light": "ライト",
  "chat.custom_modal_theme_default": "Bubble",
  "chat.custom_modal_label_character_dialogue": "キャラクターのセリフ",
  "chat.custom_modal_label_user_dialogue": "ユーザーのセリフ",
  "chat.custom_modal_label_character_narration": "キャラクターの状況説明",
  "chat.custom_modal_label_user_narration": "ユーザーの状況説明",
  "chat.custom_modal_label_character_bubble": "キャラクターの吹き出し",
  "chat.custom_modal_label_user_bubble": "ユーザーの吹き出し",
  "chat.custom_modal_color_picker_recent_colors": "最近使用したカラー",
  "chat.custom_modal_color_picker_default_custom_button": "デフォルト",
  "chat.custom_modal_color_picker_custom_button": "カスタム",
  "chat.custom_modal_apply_chat_all_alert_title": "変更内容はチャット形式のチャットルームにのみ適用されます",
  "chat.custom_modal_apply_story_all_alert_title": "変更内容は小説形式のチャットルームにのみ適用されます",
  "chat.custom_modal_apply_all_alert_description": "保存しますか？",
  "chat.custom_modal_unsaved_alert_title": "未保存の変更があります",
  "chat.custom_modal_unsaved_alert_description": "終了しますか？",
  "chat.custom_modal_reset_alert_title": "すべてのカラー設定がリセットされます",
  "chat.custom_modal_reset_alert_description": "このまま続行しますか？",
  "chat.conversation_suggested_messages_title": "おすすめメッセージ",
  "chat.conversation_suggested_messages_description": "キャラクターに送るメッセージを選んでみてください",
  "chat.message_card_title": "メッセージカード",
  "chat.message_card_select_message_deselect": "選択解除",
  "chat.message_export_title": "会話を保存",
  "chat.message_card_select_message": "メッセージ選択",
  "chat.message_card_private_unavailable": "非公開キャラクターで作成したチャットルームでは、メッセージカードを作成できません",
  "chat.message_card_select_text_guide": "メッセージカードに入れる文言を選択してください",
  "chat.message_card_edit": "メッセージカード編集",
  "chat.message_card_card_design": "カードデザイン",
  "chat.message_card_style": "スタイル",
  "chat.message_card_bg_background": "背景",
  "chat.message_card_bg_cutscene": "カットシーン",
  "chat.message_card_bg_text": "テキスト",
  "chat.message_card_ratio": "比率",
  "chat.message_card_ratio_portrait": "縦型",
  "chat.message_card_ratio_landscape": "横型",
  "chat.message_card_ratio_square": "正方形",
  "chat.message_card_image": "画像",
  "chat.message_card_edit_text": "テキストを編集",
  "chat.message_card_save_success": "メッセージカードが端末に保存されました",
  "chat.message_card_save_failed": "メッセージカードの保存に失敗しました。もう一度お試しください",
  "chat.nsfw_character_not_available_toast_message": "スリルモードのキャラクターはアプリで利用できません",
  "chat.nsfw_universe_not_available_toast_message": "スリルモードの世界観はアプリで利用できません",
  "chat.nsfw_scene_not_available_toast_message": "スリルモードのシーンはアプリで利用できません",
  "payment.charging_station_title": "チャージスポット",
  "payment.charging_station_shampoo": "シャンプー",
  "payment.charging_station_paid_bubble": "バブル",
  "payment.charging_station_free_bubble": "無料チャージ",
  "payment.charging_station_pass": "利用券",
  "payment.page_topup": "チャージする",
  "payment.page_history": "利用履歴",
  "payment.page_topup_history": "チャージ履歴",
  "payment.page_topup_history_earned": "チャージ/支払い",
  "payment.page_topup_history_used": "使用",
  "payment.page_topup_balance": "保有状況",
  "payment.page_topup_expiry_date": "満了日",
  "payment.page_topup_remaining": "残りのバブル",
  "payment.charging_station_toast_success": "購入が完了しました。",
  "payment.charging_station_toast_failed": "決済に失敗しました。もう一度お試しください。",
  "payment.charging_station_shampoo_purchase_modal": "スーパーシャンプーを<br/>購入しますか？",
  "payment.charging_station_super_shampoo_menu_title": "スーパーシャンプー購入",
  "payment.charging_station_hyper_shampoo_menu_title": "ハイパーシャンプー購入",
  "payment.charging_station_shampoo_menu_your_bubbles": "保有バブル",
  "payment.charging_station_shampoo_super_shampoo": "スーパーシャンプ",
  "payment.charging_station_shampoo_days_zero": "{{int_days}}日",
  "payment.charging_station_shampoo_days_one": "{{int_days}}日",
  "payment.charging_station_shampoo_days_other": "{{int_days}}日",
  "payment.charging_station_shampoo_hours_zero": "{{int_hours}}時間",
  "payment.charging_station_shampoo_hours_one": "{{int_hours}}時間",
  "payment.charging_station_shampoo_hours_other": "{{int_hours}}時間",
  "payment.charging_station_shampoo_purchase_complete": "購入が完了しました。",
  "payment.charging_station_shampoo_purchase_ok": "確認",
  "payment.charging_station_shampoo_not_enough_bubbles_title": "バブルが不足しているため<br/>シャンプーを購入できません。",
  "payment.charging_station_shampoo_not_enough_bubbles_description": "バブルをチャージして、シャンプーを購入してみましょう。",
  "payment.charging_station_shampoo_modal_your_bubbles": "現在のバブル",
  "payment.charging_station_shampoo_modal_required": "購入に必要なバブル",
  "payment.charging_station_shampoo_modal_missing": "不足しているバブル",
  "payment.charging_station_shampoo_modal_cancel": "閉じる",
  "payment.charging_station_shampoo_modal_topup": "チャージしに行く",
  "payment.charging_station_shampoo_purchase_failed_title": "購入に失敗しました。",
  "payment.charging_station_shampoo_purchase_failed_description": "もう一度お試しください。",
  "payment.charging_station_shampoo_modal_account_verification": "本人認証後に<br/>購入できる商品です。",
  "payment.charging_station_shampoo_modal_verify": "本人認証を行う",
  "payment.charging_station_shampoo_modal_already_in_use": "すでにシャンプーを使用中です。",
  "payment.charging_station_shampoo_modal_already_in_use_description1": "利用期間中の一部をすでに使用しているため、<br/>シャンプーをすぐにフルチャージできます！<br/>チャージしますか？",
  "payment.charging_station_shampoo_modal_already_in_use_description2": "*フルチャージを選択したシャンプーは、<br/>後からの返金が難しい場合があります。",
  "payment.charging_station_shampoo_modal_already_in_use_cancel": "いいえ",
  "payment.charging_station_shampoo_modal_already_in_use_recharge": "フルチャージする",
  "payment.charging_station_shampoo_pass_info": "現在の利用券情報",
  "payment.charging_station_shampoo_purchase_pass": "利用券購入",
  "payment.charging_station_shampoo_pass_description1": "通常シャンプーの{{int_value}}倍容量",
  "payment.charging_station_shampoo_pass_description2": "キャラ設定{{string_textCount}}文字",
  "payment.charging_station_shampoo_pass_description3": "ユーザーノート{{string_textCount}}文字",
  "payment.charging_station_shampoo_tooltip_title1": "✅ シャンプーとは？",
  "payment.charging_station_shampoo_tooltip_description1": "Bubblechatは、毎日一定量の無料チャットを提供します。",
  "payment.charging_station_shampoo_tooltip_description2": "無料のチャット量を視覚的に表すアイコンを「シャンプー」と呼びます。",
  "payment.charging_station_shampoo_tooltip_description3": "最初のチャット開始時間を基準に、6時間ごとに25%ずつチャージされます。",
  "payment.charging_station_shampoo_tooltip_title2": "📌 参考にしてください！",
  "payment.charging_station_shampoo_tooltip_description4": "シャンプーの種類によって消費速度が異なります。",
  "payment.charging_station_shampoo_tooltip_description5": "チャットルームの形式とAIモデルによってシャンプーの消耗量が異なる場合があります。",
  "payment.charging_station_shampoo_tooltip_description6": "プロンプト量、チャット入力量、および出力量によって差し引かれる程度が異なる場合があります。",
  "payment.charging_station_shampoo_tooltip_title3": "✅ 利用券のご案内",
  "payment.charging_station_shampoo_tooltip_description7": "スーパーシャンプー",
  "payment.charging_station_shampoo_tooltip_description8": "スーパーシャンプーは、普通のシャンプーより{{int_value}}倍多く会話できる商品です。",
  "payment.charging_station_shampoo_tooltip_description9": "スーパーシャンプーの利用期間中は、リフィル商品やユーザーノート、キャラ設定の拡張機能が利用できます。",
  "payment.charging_station_shampoo_tooltip_description10": "ハイパーシャンプー",
  "payment.charging_station_shampoo_tooltip_description11": "ハイパーシャンプーは、通常のシャンプーよりも{{int_value}}倍多く会話できる商品です。",
  "payment.charging_station_shampoo_tooltip_description12": "ハイパーシャンプー利用期間中は、追加されたリフィル商品とより強化されたユーザーノート、キャラ設定拡張機能を利用できます。",
  "payment.charging_station_shampoo_tooltip_description13": "利用券を追加購入した場合、現在利用券の残量はリフィルされません。",
  "payment.charging_station_shampoo_tooltip_description14": "残量をチャージしたい場合は、必ずリフィルを購入してください。",
  "payment.charging_station_shampoo_tooltip_description15": "リフィル商品はシャンプーが{{int_number}}%未満になった場合、チャージスポットやチャットルームで確認できます。",
  "payment.footer_msg_0": "サービス情報",
  "payment.footer_msg_1": "チャージされたバブルの有効期限は、チャージ後2年間です。",
  "payment.footer_msg_2": "未使用のバブルについては、7日以内であれば購入のキャンセルが可能です",
  "payment.footer_msg_3": "一度使用されたバブルは返金できません。不正に返金を受けた場合は、事前通知なく保有中のアイテムを回収され、アカウントの利用を制限することがあります。",
  "payment.footer_msg_4": "イベントやプロモーションで配布された無料アイテムは返金できず、有効期限は配布から6ヶ月以内です。",
  "payment.footer_msg_5": "リワードとして配布された有料アイテムも返金できません。",
  "payment.footer_msg_6": "プロモーション商品は返金後、再購入ができない場合があります。",
  "payment.footer_msg_7": "詳細はBubbleChat利用規約をご確認ください。",
  "payment.footer_msg_8": "お問い合わせは、<link1>お客様センター</link1>にお問い合わせください。",
  "payment.footer_msg_9": "キャリア決済の場合、当月決済時に当月のキャンセルおよび本人の口座にのみ返金されます",
  "payment.footer_exchange_rate_msg_bt_6_7_except_kr": "上記商品の価格表は為替レートの変動によって調整されることがあります。",
  "payment.shampoo_footer_msg_0": "",
  "payment.shampoo_footer_msg_1": "商品案内",
  "payment.shampoo_footer_msg_2": "スーパーシャンプー利用券は、購入後すぐに使用できるデジタル商品で、3日／7日券それぞれ有効期限が適用されます。",
  "payment.shampoo_footer_msg_3": "利用券の有効化は決済完了と同時に自動的に開始され、有効期限内にご利用いただけます。",
  "payment.shampoo_footer_msg_4": "初回限定券は本人確認済みのアカウントのみ購入可能で、1人あたり1回限りの購入となります。",
  "payment.shampoo_footer_msg_5": "返金ポリシー",
  "payment.shampoo_footer_msg_6": "スーパーシャンプー購入後、残量が一切消費されていない場合に限り、購入取消が可能です。",
  "payment.shampoo_footer_msg_7": "スーパーシャンプー利用中に追加購入した利用券は、当該追加購入分の有効期間が消費される前まで購入取消が可能です。",
  "payment.shampoo_footer_msg_8": "システムの不具合により正常な利用が不可能な場合は、お客様センターを通じて問題解決および補償を受けることができます。",
  "payment.shampoo_footer_msg_9": "注意事項",
  "payment.shampoo_footer_msg_10": "イベントで配布された無料利用券および割引プロモーション商品は返金対象外です。",
  "payment.shampoo_footer_msg_11": "不正な手段での返金申請や利用券の悪用が確認された場合、事前通知なく所持アイテムの回収やアカウント利用の制限を行うことがあります。",
  "payment.shampoo_footer_msg_12": "プロモーション商品は、返金後に同条件で再購入できない場合がありますので、ご注意ください。",
  "payment.shampoo_footer_msg_13": "繰り返しの購入・返金行為は不正利用とみなされ、アカウント制限の対象となる場合があります。",
  "payment.shampoo_footer_msg_14": "退会後の再登録によって特典を複数回受け取ろうとする行為は、システムにより検知され、制限の対象となります。",
  "payment.shampoo_footer_msg_15": "スーパーシャンプーのリフィルは、商品の期間延長は行われず、即時チャージのみが行われる商品です。",
  "payment.shampoo_footer_msg_16": "スーパーシャンプー状態でスーパーシャンプーを追加購入した場合、残量のチャージは行われず、有効期間のみが延長されます。",
  "payment.shampoo_footer_msg_17": "スーパーシャンプーからハイパーシャンプーにアップグレードすると、スーパーシャンプーの残り期間は5:1の割合で換算され、ハイパーシャンプー期間に追加されます。",
  "payment.shampoo_footer_msg_18": "リフィル商品は、スーパーシャンプーを購入した利用者のみ購入できます。",
  "payment.shampoo_footer_msg_19": "その他のお問い合わせは、お客様センターをご利用ください。",
  "payment.shampoo_footer_msg_20": "スーパーシャンプーのパーセンテージが0%未満の場合、文字数は従来の250文字（キャラ設定）・500文字（ユーザーノート）までの適用となります。",
  "payment.history_bubblechat": "BubbleChat",
  "payment.history_unlock_image": "画像のアンロック",
  "payment.history_payment": "決済",
  "payment.history_referrer_registration": "紹介者登録",
  "payment.history_payment_no_record": "有料購入履歴がありません",
  "payment.history_used_no_record": "内訳がありません",
  "payment.failed_button_description": "決済ページに戻る",
  "payment.super_shampoo_refill_expired_message_modal": "スーパーシャンプーの使用期限が切れているため、<br/>リフィルに失敗しました。",
  "payment.super_shampoo_refill_expired_description_modal": "スーパ―シャンプーを購入してみましょう。",
  "payment.super_shampoo_refill_expired_message_modal_button": "スーパ―シャンプーを購入する",
  "payment.super_shampoo_refill_message_modal": "スーパ―シャンプーのリフィル",
  "payment.super_shampoo_refill_description1_modal": "スーパ―シャンプーの使用期限が切れると、<br/>残っている分は消えてしまいます。",
  "payment.super_shampoo_refill_description2_modal": "それでもリフィルしますか？",
  "payment.hyper_shampoo_refill_expired_message_modal": "ハイパーシャンプーの使用期限が切れたため、<br/>リフィルに失敗しました",
  "payment.hyper_shampoo_refill_expired_description_modal": "ハイパーシャンプーを購入してみてください",
  "payment.hyper_shampoo_refill_expired_message_modal_button": "ハイパーシャンプーを購入する",
  "payment.hyper_shampoo_refill_message_modal": "ハイパーシャンプーリフィル",
  "payment.hyper_shampoo_refill_description1_modal": "ハイパーシャンプーの使用期限が過ぎると、<br/>使い切れなかった分は消滅します",
  "payment.shampoo_refill_message_modal_button": "シャンプーをリフィルする",
  "payment.shampoo_refill_complete_message_modal": "シャンプーリフィル完了！",
  "payment.shampoo_refill_complete_description1_modal": "シャンプーがリフィルされました。会話を続けてみましょう！",
  "payment.shampoo_refill_failed_message_modal": "バブルが足りなくて<br>シャンプーをリフィルできません。",
  "payment.shampoo_refill_failed_description1_modal": "リフィルに必要なバブル数",
  "payment.payletter_modal_title": "決済する",
  "payment.payletter_modal_selected_item": "選択した商品",
  "payment.payletter_modal_payment_method": "お支払い方法",
  "payment.payletter_modal_card_button": "クレジットカード／デビットカード",
  "payment.payletter_modal_transfer_button": "銀行振込",
  "payment.payletter_modal_billing_button": "キャリア決済",
  "payment.payletter_modal_pay_button": "購入手続きへ",
  "payment.payletter_modal_success_title": "決済成功",
  "payment.payletter_modal_success_description": "決済が完了しました",
  "payment.payletter_modal_fail_title": "決済失敗",
  "payment.payletter_modal_fail_description": "決済に失敗しました",
  "payment.payletter_modal_fail_description_sub": "もう一度お試しください",
  "payment.ad_free_modal_title": "広告なしで、さらに没入感のあるストーリーを楽しもう",
  "payment.ad_free_product_name": "Weave Plus",
  "payment.ad_free_product_price_subscription": "月額 / {{string_N}}",
  "payment.ad_free_product_price_1day": "1日 / {{string_N}}",
  "payment.ad_free_product_price_30days": "30日 / {{string_N}}",
  "payment.ad_free_modal_description1": "広告非表示",
  "payment.ad_free_modal_description2": "さらに高速な応答速度",
  "payment.ad_free_modal_description3": "さらに増加した出力量",
  "payment.ad_free_modal_description4": "ユーザーノート利用可能",
  "payment.ad_free_modal_description5": "{{int_number}}ポイント付与",
  "payment.ad_free_modal_description_inactived": "Web決済は準備中です。<br/>現在はアプリからご購入いただけます。<br/>アプリ → チャージスポット → 利用券",
  "payment.ad_free_modal_description_inactived_button": "アプリで購入する",
  "payment.ad_free_product_name_subscription": "定期購読",
  "payment.ad_free_product_name_day": "1日",
  "payment.ad_free_product_recommended_web_top_up_title": "Web版の定期購読は月額 {{int_number}}",
  "payment.ad_free_product_recommended_web_top_up_title2": "Webでさらにお得に₩1,500から",
  "payment.ad_free_product_recommended_web_top_up_button": "詳細を見る",
  "payment.ad_free_product_purchase": "購入する",
  "payment.ad_free_product_price_day2": "{{int_number}}でWeave Plusを1日体験",
  "payment.ad_free_modal_description6": "1日券にはポイントは付与されません",
  "payment.ad_free_urchase_modal_title1": "{{string_productName}}を購入しますか？",
  "payment.ad_free_urchase_modal_title_completed": "{{string_productName}}の購入が完了しました！",
  "payment.ad_free_urchase_modal_title_failed": "{{string_productName}}の購入に失敗しました",
  "payment.ad_free_chatroom_banner_title": "広告を気にせず、会話に集中したいですか？",
  "payment.ad_free_chatroom_banner_remove_Ads": "広告を非表示にする",
  "payment.ad_free_product_infomation_subscription_date": "支払予定日",
  "payment.ad_free_product_infomation_subscription": "ご利用中",
  "payment.ad_free_product_infomation_subscribe": "購読する",
  "payment.ad_free_product_infomation_cancellation_date": "解約予定日",
  "payment.ad_free_product_infomation_cancellation": "解約予定",
  "payment.ad_free_product_infomation_undo_cancellation": "購読解約を取り消す",
  "payment.ad_free_product_infomation_cancel_Subscription": "購読を解約する",
  "payment.ad_free_product_infomation_expiration_date": "利用期限",
  "payment.ad_free_product_infomation_Inactive_pass": "利用券はありません",
  "payment.ad_free_cancel_subscription_error_title1": "Webページから解約できます",
  "payment.ad_free_cancel_subscription_error_description1": "Web：チャージスポット ＞ 利用券 ＞ 現在の利用券情報 ＞ 購読解約",
  "payment.ad_free_cancel_subscription_error_title2": "Playストアから解約できます",
  "payment.ad_free_cancel_subscription_error_description2": "Android：Playストア ＞ プロフィール ＞ お支払いと定期購入 ＞ 定期購入 ＞ アプリ選択 ＞ 購読解約",
  "payment.ad_free_cancel_subscription_error_title3": "App Storeから解約できます",
  "payment.ad_free_cancel_subscription_error_description3": "iOS：設定 ＞ Apple ID ＞ サブスクリプション ＞ アプリ選択 ＞ サブスクリプションをキャンセル",
  "payment.ad_free_resubscribe_error_title1": "購読を再開する場合は、Webページからお手続きください",
  "payment.ad_free_resubscribe_error_title2": "購読を再開する場合は、App Storeからお手続きください",
  "payment.ad_free_resubscribe_error_title3": "購読を再開する場合は、Google Playからお手続きください",
  "payment.ad_free_perchase_error_title": "すでに利用中の利用券があります",
  "payment.ad_free_perchase_error_description": "{{string_productName}}の利用終了後に購入できます",
  "payment.ad_free_chatroom_sidemenu_active": "利用中",
  "payment.ad_free_footer_msg_1": "サービス情報 - Weave Plus利用券",
  "payment.ad_free_footer_msg_2": "商品案内",
  "payment.ad_free_footer_msg_3": "Weave Plus利用券は、購入後すぐに利用可能なデジタル商品で、1日券／30日券それぞれに有効期間(特典期間)が設定されています。",
  "payment.ad_free_footer_msg_4": "Weave Plus利用券は、購入後すぐに利用可能なデジタル商品で、1日券／定期購読(1ヶ月)それぞれに有効期間(特典期間)が設定されています。",
  "payment.ad_free_footer_msg_5": "特典は決済完了時点から自動的に適用され、有効期間中に無料モデル「Weave」を利用する際、広告非表示・応答速度向上・出力量増加・ユーザーノート機能をご利用いただけます。",
  "payment.ad_free_footer_msg_6": "ボーナスバブルは30日券購入時に付与され、1日券には付与されません。",
  "payment.ad_free_footer_msg_7": "ボーナスバブルは30日券および定期購読(1カ月)購入時に付与され、1日券には付与されません。",
  "payment.ad_free_footer_msg_8": "利用券は重複して保有できず、現在利用中の利用券の有効期間終了後に、別の利用券をご購入いただけます。",
  "payment.ad_free_footer_msg_9": "初回購入限定商品は、本人確認済みアカウントに限り、本人名義で1回のみ購入可能です。",
  "payment.ad_free_footer_msg_10": "定期購読(1カ月)案内",
  "payment.ad_free_footer_msg_11": "利用料金：月額 {{int_number}}ウォン（付加価値税 VAT 含む）",
  "payment.ad_free_footer_msg_12": "Weave Plus定期購読(1カ月)は、30日単位で自動更新される定期購読商品で、解約するまで、更新予定日に登録済みのお支払い方法へ自動決済されます。",
  "payment.ad_free_footer_msg_13": "定期購読は次回更新日前までいつでも解約でき、解約後も残りの利用期間中は特典をご利用いただけます。",
  "payment.ad_free_footer_msg_14": "アプリ内購入の場合、定期購読期間終了の24時間前までに解約しない限り、同額で自動更新・決済されます。定期購読の管理および解約は、「設定 ＞ アカウント ＞ サブスクリプション」または「Google Play ストア ＞ 定期購入」から行えます。",
  "payment.ad_free_footer_msg_14_1": "*定期購入の管理・解約方法: iOS-設定>アカウント>サブスクリプション/AOS：Playストア>定期購入",
  "payment.ad_free_footer_msg_15": "返金ポリシー",
  "payment.ad_free_footer_msg_16": "Weave Plus利用券は、購入後すぐに特典が提供されるデジタルコンテンツのため、「電子商取引等における消費者保護に関する法律」に基づき、購入後の返金(購入取消)は制限されます。",
  "payment.ad_free_footer_msg_17": "購入後、利用券の特典を一切利用していない場合、すなわち ① 無料モデルを一度も利用しておらず、広告非表示特典が適用されたことがない場合 ② 付与されたボーナスバブルを一切使用していない場合 に限り、購入日から7日以内であれば購入取消および返金を申請できます。上記特典のいずれかを利用開始した場合は、コンテンツ提供が開始されたものとみなし、返金対象外となります。",
  "payment.ad_free_footer_msg_18": "アプリ内購入については、各ストア(App Store、Google Play)の返金ポリシーに従います。",
  "payment.ad_free_footer_msg_19": "システム障害等により正常に利用できない場合は、お客様センターまでお問い合わせください。",
  "payment.ad_free_footer_msg_20": "注意事項",
  "payment.ad_free_footer_msg_21": "イベントで配布された無料利用券および割引プロモーション商品は返金対象外です。",
  "payment.ad_free_footer_msg_22": "不正な方法で返金を試みたり、利用券を不正利用した場合、事前の通知なく保有資産の回収やアカウント利用が制限されることがあります。",
  "payment.ad_free_footer_msg_23": "プロモーション商品は、返金後に同条件で再購入できない場合がありますので、あらかじめご了承ください。",
  "payment.ad_free_footer_msg_24": "購入と返金を繰り返す行為が確認された場合、不正利用と判断し、アカウント利用を制限する場合があります。",
  "payment.ad_free_footer_msg_25": "退会後の再登録による重複特典の受領はシステムにより検知され、利用制限の対象となる場合があります。",
  "payment.ad_free_footer_msg_26": "その他ご不明な点がございましたら、お客様センターまでお問い合わせください。",
  "payment.ad_watch_incomplete_toast": "広告の視聴が完了していません。メッセージを再送信してください。",
  "payment.app_only_guide_title": "決済機能はアプリ限定です",
  "payment.app_only_guide_description": "Web版でもご利用いただけるよう、早期対応を進めております。",
  "chat.profile_my_title": "マイページ",
  "chat.profile_other_title": "プロフィール",
  "chat.profile_writername": "ニックネーム",
  "chat.profile_username": "ユーザーコード",
  "chat.profile_followers_zero": "フォロワー",
  "chat.profile_followers_one": "フォロワー",
  "chat.profile_followers_other": "フォロワー",
  "chat.profile_my_following": "フォロー中",
  "chat.profile_my_following_modal_title": "フォロー中",
  "chat.profile_my_following_modal_description": "フォローしてみましょう。",
  "chat.profile_others_follow_button": "フォロー",
  "chat.profile_others_following_button": "フォロー中",
  "chat.profile_introduction": "紹介文",
  "chat.profile_my_introduction_empty": "自己紹介文を作成してください",
  "chat.profile_other_introduction_empty": "登録された紹介文がありません。",
  "chat.profile_username_copy_message": "ユーザーコードがコピーされました。",
  "chat.profile_my_personas": "キャラ設定",
  "chat.profile_my_personas_my_personas_zero": "私のキャラ設定",
  "chat.profile_my_personas_my_personas_one": "私のキャラ設定",
  "chat.profile_my_personas_my_personas_other": "私のキャラ設定",
  "chat.profile_my_personas_empty": "作成したキャラ設定がありません。",
  "chat.profile_character": "キャラクター",
  "chat.profile_my_characters_my_characters_zero": "マイキャラクター",
  "chat.profile_my_characters_my_characters_one": "マイキャラクター",
  "chat.profile_my_characters_my_characters_other": "マイキャラクター",
  "chat.profile_my_characters_empty": "作成したキャラクターがありません。",
  "chat.profile_others_characters_empty": "キャラクターがありません。",
  "chat.profile_universe": "世界観",
  "chat.profile_my_universes_my_universes_zero": "マイ世界観",
  "chat.profile_my_universes_my_universes_one": "マイ世界観",
  "chat.profile_my_universes_my_universes_other": "マイ世界観",
  "chat.profile_my_universes_empty": "自分が作成した世界観がありません。",
  "chat.profile_others_universes_empty": "世界観がありません。",
  "chat.profile_scene": "シーン",
  "chat.profile_my_scenes_my_scenes_zero": "マイシーン",
  "chat.profile_my_scenes_my_scenes_one": "マイシーン",
  "chat.profile_my_scenes_my_scenes_other": "マイシーン",
  "chat.profile_my_scenes_empty": "作成したシーンがありません。",
  "chat.profile_others_scenes_empty": "シーンがありません。",
  "chat.profile_assets_count_zero": "アセット",
  "chat.profile_assets_count_one": "アセット",
  "chat.profile_assets_count_other": "アセット",
  "chat.profile_my_rewards": "リワード",
  "chat.profile_my_shampoo": "シャンプー",
  "chat.profile_others_nsfw_toggle": "スリルモード",
  "chat.profile_my_edit_title": "プロフィール編集",
  "chat.profile_my_edit_modal_edit_writername": "ニックネーム変更",
  "chat.profile_my_edit_modal_profile_introduction": "プロフィール紹介",
  "chat.profile_my_edit_writername": "ニックネーム",
  "chat.profile_my_edit_username": "ユーザーコード",
  "chat.profile_my_edit_introduction": "紹介文",
  "chat.profile_my_edit_introduction_empty": "自己紹介文を作成してください",
  "chat.profile_my_edit_email": "メールアドレス",
  "chat.profile_my_edit_email_verify_message": "メールを認証してください。",
  "chat.profile_my_edit_password": "パスワード",
  "chat.profile_my_edit_password_set_message": "パスワードを設定してください。",
  "chat.profile_my_edit_password_completed_message": "パスワードの設定が完了しました。",
  "chat.profile_my_edit_identify_verification": "本人認証",
  "chat.profile_my_edit_verify_identity": "本人認証をしてください。",
  "chat.profile_my_edit_identify_verification_completed_message": "本人認証が完了しました。",
  "chat.profile_my_edit_edit_button": "変更する",
  "chat.profile_my_edit_edit_verify_button": "認証する",
  "chat.profile_my_edit_edit_verify_completed_button": "認証完了",
  "chat.profile_my_edit_country_content_options_change_toast": "国を変更しました。",
  "chat.profile_my_edit_content_display_settings_change_toast": "コンテンツ表示設定を変更しました。",
  "chat.profile_my_edit_country_content_options": "国およびコンテンツ",
  "chat.profile_my_edit_view_content_other_languages": "他の国のコンテンツを見る",
  "chat.profile_my_edit_view_content_other_languages_thai": "タイ語",
  "chat.profile_my_edit_view_content_other_languages_korean": "韓国語",
  "chat.profile_my_edit_view_content_other_languages_taiwanese": "台湾語",
  "chat.profile_my_edit_view_content_other_languages_japanese": "日本語",
  "chat.profile_my_edit_view_content_display_settings": "コンテンツ表示設定",
  "chat.profile_my_edit_view_content_current_country": "現在の国",
  "chat.profile_my_edit_view_content_all_countries": "すべての国",
  "chat.profile_my_edit_country_settings": "国設定",
  "chat.profile_my_edit_language_settings": "言語設定",
  "chat.profile_my_edit_language_settings_popup_title": "言語設定",
  "chat.profile_my_edit_language_settings_popup_subtitle": "言語選択",
  "chat.profile_no_exist": "存在しないユーザーです。",
  "chat.profile_number_of_people": "{{int_numbers}}人",
  "chat.profile_my_create_no_personas": "自分が作ったキャラ設定がありません。",
  "chat.profile_my_create_no_scenes": "作成したシーンがありません。",
  "chat.profile_my_create_no_universes": "作成した世界観がありません。",
  "chat.profile_my_create_no_characters": "作成したキャラクターがありません。",
  "chat.profile_my_favorite_no_scenes": "お気に入りのシーンがありません。",
  "chat.profile_my_favorite_no_universes": "お気に入りの世界観がありません。",
  "chat.profile_my_favorite_no_characters": "お気に入りのキャラクターがありません。",
  "chat.profile_my_recently_played_no_scenes": "最近プレイしたシーンがありません。",
  "chat.profile_my_recently_played_no_universes": "最近プレイした世界観がありません。",
  "chat.profile_my_recently_played_no_characters": "最近プレイしたキャラクターがありません。",
  "chat.profile_my_like_find_scenes": "お気に入りのシーンを探してみましょう。",
  "chat.profile_my_like_find_universes": "お気に入りの世界観を探してみましょう。",
  "chat.profile_my_like_find_characters": "お気に入りのキャラクターを探してみましょう。",
  "chat.profile_my_contest_tab_title": "コンテスト",
  "chat.profile_my_contest_tab_ongoing": "開催中",
  "chat.profile_my_contest_tab_past_entries": "過去の参加作品",
  "chat.profile_my_contest_participate_button": "参加する",
  "chat.profile_my_contest_badge_button": "審査中",
  "chat.profile_my_contest_view_button": "コンテストを確認する",
  "chat.profile_my_contest_view_results_button": "結果を確認する",
  "chat.profile_my_contest_no_ongoing_contests": "開催中のコンテストはありません",
  "chat.profile_my_contest_ongoing_contests": "コンテスト開催中!<br/>今すぐキャラクターを作成して参加してみましょう",
  "chat.profile_my_contest_entered_null": "参加したコンテストはありません",
  "chat.profile_my_set_password": "設定",
  "chat.profile_my_same_verified_email": "既に認証済みのメールアドレスです。",
  "chat.profile_my_already_verified": "すでに認証された名義です。",
  "chat.profile_my_verify_adult_verification_toast_title": "Adult verification required.",
  "chat.profile_my_verify_adult_reverification_toast_title": "成人認証の有効期限が<br/>満了しました。",
  "chat.profile_my_verify_adult_reverification_toast_description": "成人認証は「青少年保護法施行令第17条第2項」に基づき、初回認証から1年経過後に再度本人確認を行う法的義務です。<br/><br/> 安全かつ合法的なご利用のため\\n再認証手続きをお願いします",
  "chat.profile_my_verify_youth_protection_toast_title": "未成年の方はご利用いただけません。",
  "chat.profile_my_verify_adult_verification_identity_verification": "本人認証する",
  "chat.profile_my_verify_adult_verification_identity_reverification": "再認証する",
  "chat.profile_my_verify_youth_protection_toast": "このコンテンツは青少年有害媒体物に該当し、<br/>情報通信網の利用促進および情報保護等に関する<br/>法律および青少年保護法に基づき、<br/>18歳未満の方はご利用いただけません。",
  "chat.profile_my_edit_verify_modal_personal_information": "<link1>個人情報の収集および利用</link1>に同意します。",
  "chat.profile_my_edit_verify_modal_personal_information_transfer": "個人情報が盗用防止を目的に韓国インターネット振興院eプライバシークリーンサービスに譲渡されることに同意します。",
  "chat.profile_my_edit_verify_modal_legally_responsible": "他人の名義を無断で使用したり、自身の情報でない場合、法的責任を負うことに同意します。",
  "chat.profile_my_edit_verify_modal_termination_suspension": "名義の不正使用が確認された場合、サービスの利用が制限されることがあります。",
  "chat.profile_my_edit_verify_modal_one_identify": "1つのアカウントにつき、1つの名義のみ本人認証が可能です。",
  "chat.profile_my_edit_verify_modal_adult_content": "本人認証により成人であることが確認された場合、成人向けコンテンツの作成および利用が可能になります。",
  "chat.profile_my_edit_verify_modal_valid": "成人認証の有効期間は1年間です",
  "chat.profile_my_edit_verify_modal_penalties": "他人の名義を使用して本人確認を行った場合、法的制裁やサービス制限等の不利益が発生する可能性があります。",
  "chat.profile_delete_account_rewards": "アカウントを削除すると、アカウントのすべてのリワードが失われ復旧は不可能です。",
  "chat.profile_delete_account_delete_assets": "アカウントを削除しても、作成したキャラクター、ストーリー、テーマは削除されません。 削除をご希望の場合は、お客様ご自身で削除をお願いいたします。",
  "chat.profile_delete_account_personal_info": "退会後も、株式会社BubbleTapの「個人情報保護方針」に従い、一定期間保管された後、個人情報は完全に削除されます。",
  "chat.profile_delete_account_verification": "本人確認済みアカウントを削除した場合、同じ名義では7日間再認証ができません。",
  "chat.profile_delete_account_benefits": "新規会員としてスーパーシャンプー特典を受け取った後に退会された場合、同じ名義では再びスーパーシャンプー特典を受け取ることはできません。",
  "chat.profile_delete_account_enter_password": "本人確認のため、アカウントのパスワードを入力してください。",
  "chat.profile_delete_account_current_password": "現在のパスワード入力",
  "chat.profile_delete_account_password_combination": "半角英数字・記号で8~25文字を入力してください。",
  "chat.profile_delete_account_agree_all": "すべてに同意してください。",
  "chat.profile_delete_account_agree_all_delete": "すべての項目に同意いただくことで、アカウントの削除が可能です。",
  "chat.profile_delete_account_password_incorrect": "パスワードが正しくありません。",
  "chat.profile_delete_account_set_password": "続行するには、パスワードを設定してください。",
  "chat.profile_delete_account_delete_success": "アカウントが正常に削除されました。",
  "chat.profile_my_purchased_stories_title": "購入済みのストーリー",
  "chat.profile_my_purchased_stories_count_zero": "ストーリー",
  "chat.profile_my_purchased_stories_count_one": "ストーリー",
  "chat.profile_my_purchased_stories_count_other": "ストーリー",
  "chat.profile_my_upload_image_button": "画像アップロード",
  "chat.profile_my_decorate_profile_button": "プロフィールのカスタマイズ",
  "chat.profile_my_decorater_profile_edit_message": "プロフィール画像を変更すると、適用されたデコターが解除されます",
  "chat.profile_my_decorater_upload_profile_message": "プロフィール画像を登録後にご利用いただけます",
  "chat.profile_my_edit_referrer_title": "紹介者",
  "chat.profile_my_edit_referrer_register_code_title": "コード登録",
  "chat.profile_my_edit_referrer_register_code_button": "登録",
  "chat.profile_my_edit_referrer_copy_code_title": "コードコピー",
  "chat.profile_my_edit_referrer_register_code_description": "紹介者コードを入力して<br/><highlight>{{int_numbers}} バブル</highlight><bold>を受け取ってください！</bold>",
  "chat.profile_my_edit_referrer_register_code_input_placeholder": "紹介者コード入力",
  "chat.profile_my_edit_referrer_register_code_remaining_time_label": "残りの登録可能時間",
  "chat.profile_my_edit_referrer_register_code_remaining_time_format": "{{int_day}}日 {{int_time}}:{{int_minute}}:{{int_second}}",
  "chat.profile_my_edit_referrer_notice_title": "注意事項",
  "chat.profile_my_edit_referrer_notice_description1": "本人認証済みのアカウントのみ紹介者として登録できます",
  "chat.profile_my_edit_referrer_notice_description2": "本人認証済みのアカウントのみ紹介者の登録が可能です",
  "chat.profile_my_edit_referrer_notice_description3": "紹介者登録時に登録したユーザーへ {{int_refereeAmount}} バブル、紹介者ユーザーへ {{int_referrerAmount}} バブルが付与されます",
  "chat.profile_my_edit_referrer_copy_code_description": "私の紹介コードをユーザーが登録すると<br/>私に {{int_referrerAmount}} バブル、登録ユーザーに {{int_refereeAmount}} バブル即時付与",
  "chat.profile_my_edit_referrer_register_code_completed_prefix": "登録完了：",
  "chat.profile_my_edit_referrer_verification_required_description": "本人認証が完了した後、紹介者の登録が可能です",
  "chat.profile_my_edit_referrer_copy_code_toast": "紹介者コードがコピーされました",
  "chat.profile_my_edit_referrer_register_code_expired": "登録期限切れ",
  "chat.profile_my_edit_referrer_error_unverified_account": "本人認証されていないアカウントの紹介者コードは、紹介者として登録できません。",
  "chat.profile_my_edit_referrer_error_user_not_found": "存在しないユーザーです",
  "chat.profile_my_edit_referrer_error_self_register": "本人のアカウントは紹介者として登録できません",
  "chat.profile_my_edit_referrer_error_period_expired": "入力可能期間が過ぎました",
  "chat.profile_my_edit_referrer_registration_error_other_country": "他国ユーザーの紹介コードは、紹介者として登録できません",
  "chat.profile_my_edit_referrer_registration_completed": "紹介者の登録が完了しました",
  "chat.profile_my_edit_referrer_registered_referrer": "登録した紹介者：",
  "chat.profile_my_edit_referrer_registration_period_expired": "紹介者の登録は本人確認後{{deadline_time}}日以内に限り可能です",
  "chat.profile_my_edit_referrer_benefit_title": "特典",
  "chat.profile_my_edit_referrer_benefit_registration": "紹介者登録が可能",
  "chat.profile_my_edit_referrer_benefit_condition": "登録時",
  "chat.profile_my_edit_referrer_benefit_reward": "3,000バブル付与",
  "chat.profile_setting_account_settings": "アカウント設定",
  "chat.profile_setting_service_settings": "サービス設定",
  "chat.profile_setting_country_content_settings": "国・コンテンツ設定",
  "chat.profile_setting_blocked_list": "ブロックリスト管理",
  "chat.profile_setting_creator_support": "クリエイターサポート",
  "chat.profile_setting_account": "アカウント",
  "chat.profile_setting_service_support": "サポート",
  "chat.profile_my_mileage_convert_menu_title": "マイレージ",
  "chat.profile_my_mileage_convert_sheet_title": "マイレージ交換",
  "chat.profile_my_mileage_convert_sheet_description": "マイレージ1点は1バブルに変換されます",
  "chat.profile_my_mileage_convert_balance_label": "保有中のマイレージ",
  "chat.profile_my_mileage_convert_input_label": "変換するマイレージ",
  "chat.profile_my_mileage_convert_input_max": "最大",
  "chat.profile_my_mileage_convert_input_placeholder": "{{int_numbers}}点単位で変換できます。",
  "chat.profile_my_mileage_convert_input_error_unit": "* {{int_numbers}}点単位でのみ変換できます",
  "chat.profile_my_mileage_convert_info_title": "マイレージとは？",
  "chat.profile_my_mileage_convert_info_description_1": "{{int_numbers}}点からバブルに変換でき、変換されたバブルは通常のバブルと同じ用途で使用できます",
  "chat.profile_my_mileage_convert_info_description_2": "マイレージから返還されたバブルの有効期限は1年です",
  "chat.profile_my_mileage_convert_info_description_3": "マイレージから返還されたバブルは交換・返金できません",
  "chat.profile_my_mileage_convert_submit_button": "バブルに変換",
  "chat.profile_my_mileage_convert_confirm_modal_title": "マイレージを変換しますか？",
  "chat.profile_my_mileage_convert_confirm_modal_description": "変換したバブルをマイレージに戻すことはできず、\n付与されたバブルの有効期限は1年間です",
  "chat.profile_my_mileage_convert_confirm_modal_submit": "変換する",
  "chat.profile_my_mileage_convert_complete_modal_title": "変換完了",
  "chat.profile_my_mileage_convert_complete_modal_description": "{{int_numbers}}バブルを受け取りました",
  "chat.profile_my_mileage_convert_my_bubble_label": "保有バブル",
  "chat.profile_my_mileage_convert_remaining_label": "残りのマイレージ",
  "chat.profile_my_mileage_load_failed": "読み込み失敗",
  "chat.profile_my_mileage_reward_view": "見る",
  "chat.studio_create_image": "画像を生成",
  "chat.studio_create_story": "ストーリーを作成",
  "chat.create_create_preset_create_description": "キャラクターから世界観まで、一度に作成",
  "chat.create_create_custom_create_description": "さまざまな世界観、シーンと組み合わせて使用するキャラクターを作成します",
  "chat.create_create_universe_create_description": "会話が行われる背景と環境を設定します。",
  "chat.create_create_scene_create_description": "特定の会話が起こる即時の状況を設定します。",
  "chat.create_create_preset": "統合型",
  "chat.create_create_preset_title": "キャラクター×世界観×シーン",
  "chat.create_create_custom": "組合型",
  "chat.create_create_preset_tooltip_title": "✅ 統合型とは？",
  "chat.create_create_preset_tooltip_description1": "キャラクター・世界観・シーンをまとめて一度に制作する方式です。",
  "chat.create_create_preset_tooltip_description2": "広いプロンプト範囲と機能を活用し、完成度の高いキャラクターを素早く制作できます。",
  "chat.create_create_preset_tooltip_description3": "統合型で作られたアセットは 組合型アセットと一緒に使用できません。",
  "chat.create_create_preset_tooltip_description4": "一度統合型で生成した場合、組合型へ変更することはできません。",
  "chat.create_create_custom_tooltip_title": "✅ 組合型とは？",
  "chat.create_create_custom_tooltip_description1": "キャラクター・世界観・シーンを段階的に分けて制作し、連結する方式です。",
  "chat.create_create_custom_tooltip_description2": "各要素を個別に制作・修正できるため、拡張性と再利用性が高いです。",
  "chat.create_create_custom_tooltip_description3": "組合型アセット同士のみ 互いに組み合わせることができます。",
  "chat.create_create_custom_tooltip_description4": "統合型で作られたアセットは 組合型と一緒に使用できません。",
  "chat.create_preset_lorebook_placeholder": "タイトルは本文の文字数に含まれません",
  "chat.create_preset_character_details": "人物説明",
  "chat.create_preset_character_details_placeholder": "人物説明のうち、公開したくない内容はこちらに入力してください",
  "chat.create_preset_background_details": "背景説明",
  "chat.create_preset_background_details_public_placeholder": "キャラクターの背景ストーリーと物語を自由に設定してください<br/><br/>例)<br/>魔法が大衆化された時代である。<br/>怪異現象とモンスターがあふれる世界だ。",
  "chat.create_preset_background_details_private_placeholder": "背景説明のうち、公開したくない内容はこちらに入力してください",
  "chat.create_asset_relationship_placeholder": "関係中に公開したくない内容はこちらに作成してください",
  "chat.create_asset_details_placeholder": "追加説明の中で公開したくない内容はこちらに作成してください",
  "chat.create_asset_lorebook_placeholder": "設定集の中で公開したくない内容はこちらに作成してください",
  "chat.create_create_button": "作成",
  "chat.create_character_profile_img": "プロフィール画像",
  "chat.create_character_name_placeholder1": "イ ファン",
  "chat.create_character_name_placeholder2": "キム ウビン",
  "chat.create_character_name_placeholder3": "ジョン ハンナ",
  "chat.create_introduction_label": "紹介文",
  "chat.create_character_introduction_placeholder1": "たまにしか学校に来ない大学生",
  "chat.create_character_introduction_placeholder2": "内気だけど愛に飢えているオタク系幼なじみ男子",
  "chat.create_character_introduction_placeholder3": "アンドロイドメイド",
  "chat.create_character_introduction_help_text": "※紹介文はキャラクターの動作には影響しません",
  "chat.create_tags_label": "タグ",
  "chat.create_character_tags_description": "キャラクターに合ったタグを選んでください",
  "chat.create_tags_placeholder": "タグを検索してみましょう",
  "chat.create_tags_add": "新規タグ追加",
  "chat.create_tags_minimum_fail_message": "タグは1つ以上選択してください。",
  "chat.create_tags_repeated_fail_message": "同じタグは複数選べません。",
  "chat.create_tags_maximum_fail_message": "タグは最大5つまで入力できます。",
  "chat.create_tags_maximum_fail_message_a": "タグは最大{{int_tagNumbers}}個まで設定できます。",
  "chat.create_tags_no_match_scenes": "該当するタグのシーンが見つかりません。",
  "chat.create_tags_no_match_universes": "該当するタグの世界観が見つかりません。",
  "chat.create_tags_no_match_characters": "該当するタグのキャラクターが見つかりません。",
  "chat.create_sharing_option_label": "公開設定",
  "chat.create_sharing_option_private_title": "非公開",
  "chat.create_sharing_option_private_description": "自分だけが使用できます。",
  "chat.create_sharing_option_public_title": "公開",
  "chat.create_sharing_option_public_description": "他のユーザーも使用できます。",
  "chat.create_tap_specifics": "詳細情報",
  "chat.create_age_minimum_fail_message": "年齢は0以上で入力してください",
  "chat.create_age_maximum_fail_message": "年齢は 10億以下で入力してください",
  "chat.create_character_job_placeholder1": "大学生",
  "chat.create_character_job_placeholder2": "バブル大学の新入生",
  "chat.create_character_job_placeholder3": "メイド",
  "chat.create_character_character_placeholder1": "親切 優しさ 活発",
  "chat.create_character_character_placeholder2": "内気・人見知り・思いやりがある・愛に飢えている",
  "chat.create_character_character_placeholder3": "優しいけれど、注意するときはきっぱり。ちょっと天然",
  "chat.create_character_speaking_style_placeholder1": "「学校では学生として過ごしたい」",
  "chat.create_character_speaking_style_placeholder2": "「あ…こんにちは…」 「私も…誰かに愛される日が来るのかな…？」「ずっと会いたかったよ」",
  "chat.create_character_speaking_style_placeholder3": "「どこを片付ければいいですか？」",
  "chat.create_character_interests_placeholder1": "ボイストレーニング・もうすぐあるコンサートへの不安",
  "chat.create_character_interests_placeholder2": "読書・運動・恋愛・愛",
  "chat.create_character_interests_placeholder3": "アジサイ、家事、チキン",
  "chat.create_details_help_text": "{{assistant}}を書くと、キャラクターの名前に置き換えられます。 {{user}}を書くと、会話中のユーザーの名前に置き換わります。",
  "chat.create_global_availability_title": "他国への公開可否",
  "chat.create_global_availability_global": "グローバル",
  "chat.create_global_availability_global_description": "すべての国のコメントが受け取れます",
  "chat.create_global_availability_domestic": "国内",
  "chat.create_global_availability_domestic_description": "現在の国のコメントのみ受け取れます",
  "chat.create_global_availability_help_text": "* グローバル公開時、他国では設定集の内容が反映されません",
  "chat.create_global_availability_auto_translation_help_text": "* 自動翻訳を通じて提供されます",
  "chat.create_character_failed_domestic_universe_scene": "選択した世界観/シーンの‘他国公開の可否’が国内に設定されているため、グローバルキャラクターとして作成できません。<br/>グローバル世界観/シーンを選択してください。",
  "chat.modify_character_failed_domestic_universe_scene": "選択した世界観/シーンの‘他国公開の可否’が国内に設定されているため、グローバルキャラクターとして修正できません。<br/>グローバル世界観/シーンを選択してください。",
  "chat.modify_character_alert_domestic_universe": "‘他国公開の可否’を国内に変更すると、他国では該当世界観が基本設定されたキャラクターから除外されます。<br/>それでも修正しますか？",
  "chat.modify_character_alert_domestic_scene": "‘他国公開の可否’を国内に変更すると、他国では該当シーンが基本設定されたキャラクターから除外されます。<br/>それでも修正しますか？",
  "chat.create_tap_background": "会話環境",
  "chat.create_tooltip_title": "ヘルプ",
  "chat.create_tooltip_universe_description": "世界観を「作成する」または「追加する」から、キャラクターに合った世界観をデフォルトでセットしておくことができます。",
  "chat.create_tooltip_scene_description": "シーン「作成する」または「追加する」から、キャラクターに合ったシーンをデフォルトでセットしておくことができます。",
  "chat.create_first_sentence_description": "キャラクターが最初に送るひとことです。",
  "chat.create_first_sentence_placeholder1": "*久しぶりに学校に来たイファンがあなたに話しかけてきた*教科書見せてもらってもいい？忘れちゃってさ。",
  "chat.create_first_sentence_placeholder2": "なんで今になって来たの..？ずっと待ってたのに..",
  "chat.create_first_sentence_placeholder3": "何かご用でしょうか？",
  "chat.create_first_sentence_int_numbers": "最初のひとこと{{int_numbers}}",
  "chat.create_first_sentence_add_button": "最初のひとことを追加",
  "chat.create_first_sentence_title": "件名",
  "chat.create_first_sentence_description1": "*最大3件まで追加できます",
  "chat.create_first_sentence_description2": "*最初のひとことはプロンプト文字数に含まれません",
  "chat.create_first_sentence_delete_confirm_message": "最初のひとことを削除しますか？",
  "chat.create_creator_comment_label": "制作者コメント",
  "chat.create_creator_comment_placeholder": "ユーザーに伝えたいメッセージを入力してみてください",
  "chat.create_prompt_label": "プロンプト",
  "chat.create_basic_info_label": "必須情報",
  "chat.create_media_label": "メディア",
  "chat.create_extra_info_label": "追加情報",
  "chat.create_prompt_characters_toast": "プロンプトは合わせて{{int_characters}}字以下で入力してください",
  "chat.create_creator_comment_characters_toast": "製作者コメントは合わせて{{int_characters}}字以下で入力してください",
  "chat.create_creator_first_sentence_characters_toast": "最初のひとことは{{int_characters}}字以下で入力してください",
  "chat.create_creator_lorebook_characters_toast": "設定集は {{int_characters}}字以下で入力してください",
  "chat.create_creator_keywordbook_characters_toast": "キーワードブック{{int_keywordbookNumbers}} の内容は{{int_characters}}字以下で入力してください",
  "chat.create_creator_description_characters_toast": "状況設定は{{int_characters}}字以下で入力してください",
  "chat.create_character_create_fail_message": "キャラクターの作成に失敗しました。<br/>もう一度お試しください。",
  "chat.create_alert_message_name": "名前を入力してください。",
  "chat.create_alert_message_image": "画像を添付してください。",
  "chat.create_modal_gif_description": "GIFイメージは編集機能を提供しません。",
  "chat.create_alert_message_tags": "タグを少なくとも 1 つ以上選択してください。",
  "chat.create_alert_message_introduction": "紹介文を入力してください。",
  "chat.create_alert_message_age": "年齢を入力してください。",
  "chat.create_alert_message_nsfw": "スリルモードの世界観/場面はスリルモードのキャラクターにのみ適用できます。",
  "chat.create_alert_message_private": "選択した世界観/シーンが非公開に設定されているため、公開キャラクターとして作成することはできません。非公開のキャラクターで作成しますか？",
  "chat.create_alert_message_cancel": "キャンセル",
  "chat.create_private_character": "非公開で作成",
  "chat.create_universe_name_help_text": "* 他人の権利を侵害する世界観を作成する行為は禁止されます。",
  "chat.create_universe_details_placeholder": "世界観自体の詳細な設定を作成してください。<br/><br/>例)<br/>魔法が大衆化された時代である。<br/>怪異現象とモンスターがあふれる世界だ。",
  "chat.create_universe_create_fail_message": "世界観の制作に失敗しました。<br/>もう一度お試しください。",
  "chat.create_scene_name_help_text": "* 他人の権利を侵害するシーンを制作する行為は禁止されています。",
  "chat.create_setup_label": "空間設定",
  "chat.create_scene_create_fail_message": "シーンの作成に失敗しました。<br/>もう一度お試しください。",
  "chat.create_draft_button": "下書き保存",
  "chat.create_draft_asset_in_progress_modal_title": "作成中のアセットがあります",
  "chat.create_draft_asset_in_progress_modal_description": "続けて作成しますか？",
  "chat.create_draft_save_fail_storage_full_modal_title": "現在作成中のアセットは下書き保存できません",
  "chat.create_draft_save_fail_storage_full_modal_description": "保存容量がいっぱいのため、新規作成のみ可能です<br/>下書きアセットを整理するか、作成後にご利用ください",
  "chat.create_draft_save_fail_storage_full_modal_manage_drafts_button": "下書きを整理",
  "chat.create_draft_save_modal_title": "作成中のアセットを下書き保存しますか？",
  "chat.create_draft_save_modal_description": "下書き保存は最大{{count}}件まで可能で、保存していない内容は削除されます",
  "chat.create_draft_save_fail_maximum_limit_modal_title": "下書き保存は最大{{count}}件までです",
  "chat.create_draft_save_success_toast": "下書き保存に成功しました",
  "chat.create_draft_save_fail_toast": "下書き保存に失敗しました。もう一度お試しください",
  "chat.create_draft_edit_option": "続きから作成",
  "chat.create_draft_delete_success_toast": "下書きアセットを削除しました",
  "chat.create_draft_delete_fail_toast": "下書きアセットの削除に失敗しました<br/>もう一度お試しください",
  "chat.create_draft_empty": "作成中のアセットはありません",
  "chat.create_draft_noname": "No name",
  "chat.create_create_title": "作成",
  "chat.create_create_character": "キャラクター",
  "chat.create_create_universe": "世界観",
  "chat.create_create_scene": "シーン",
  "chat.create_create_character_header": "キャラクター作成",
  "chat.create_create_universe_header": "世界観作成",
  "chat.create_create_scene_header": "シーン作成",
  "chat.create_add_image_help_text_square": "正方形で編集する際に最適に露出します。",
  "chat.create_create_character_create": "キャラクター作成",
  "chat.create_create_character_create_description": "AIキャラクターの個性と特性を定義します。",
  "chat.create_create_character_my_characters": "自分のキャラクター",
  "chat.create_create_character_my_characters_empty": "自分だけのキャラクターを作ってみてください。",
  "chat.create_create_universe_create": "世界観作成",
  "chat.create_create_universe_my_universes": "自分の世界観",
  "chat.create_create_universe_my_universes_empty": "自分だけの世界観を作ってみてください。",
  "chat.create_create_scene_create": "シーン作成",
  "chat.create_create_scene_my_scenes": "自分のシーン",
  "chat.create_create_scene_my_scenes_empty": "自分だけのシーンを作ってみてください。",
  "chat.create_character_creation_guide": "キャラクター作成ガイドを必ずお読みください！",
  "chat.create_character_add_thumbnail_image_button": "イメージ追加",
  "chat.create_add_image_failed": "画像の追加に失敗しました。",
  "chat.create_character_basics_label": "基本情報",
  "chat.create_character_basics_name": "名前",
  "chat.create_character_basics_name_help_text": "* 他人の権利を侵害するキャラクターを製作する行為は禁止されます。 詳細については、運用ポリシーを参照してください。",
  "chat.create_character_basics_gender_label": "性別",
  "chat.create_character_basics_gender_male": "男子",
  "chat.create_character_basics_gender_female": "女子",
  "chat.create_character_basics_gender_other": "その他",
  "chat.create_character_basics_age_rating_label": "年齢区分",
  "chat.create_character_basics_age_rating_normal_mode": "一般モード",
  "chat.create_character_basics_age_verification": "スリルモードのキャラクターは年齢認証後に作ることができます。",
  "chat.create_character_basics_age_rating_normal_mode_description": "すべてのユーザーが使用できます。",
  "chat.create_character_basics_age_rating_nsfw_mode": "スリルモード",
  "chat.create_character_basics_age_rating_nsfw_mode_description": "成人のユーザーのみが使用できます。",
  "chat.create_character_basics_age_rating_nsfw_mode_toast": "18歳未満のキャラクターは、スリルモードのキャラクターでは作成できません。",
  "chat.create_character_basics_age_rating_help_text": "* 一般モード選択時、作成段階でスリルモード世界観/シーンを適用することができません。",
  "chat.create_character_Information_label": "詳細情報",
  "chat.create_character_Information_optional": "選択",
  "chat.create_character_Information_description": "キャラクターを詳細に描写することができます。",
  "chat.create_character_Information_age": "年齢",
  "chat.create_character_Information_job": "職業",
  "chat.create_character_Information_character": "性格",
  "chat.create_character_Information_speaking_style": "言い方",
  "chat.create_character_Information_interests": "関心事",
  "chat.create_character_details_label": "追加説明",
  "chat.create_character_details_toast": "追加説明は合わせて{{int_characters}}字以下で入力します。",
  "chat.create_character_details_public": "公開説明",
  "chat.create_character_details_placeholder": "キャラクター自体の詳細な性格や設定などを作成していただきます。<br/>「私」に関する内容が入らないようにお願いします。<br/><br/>例)<br/>キャラクターはプロゲーマー練習生です。<br/>キャラクターは他人にあまり関心がありません。<br/>キャラクターは負けず嫌いです。",
  "chat.create_character_details_private": "非公開説明",
  "chat.create_character_details_character_button": "キャラクター",
  "chat.create_character_details_user_button": "私",
  "chat.create_character_multi_images_title": "マルチイメージ",
  "chat.create_character_image_name_title": "画像タイトル {{int_imageNumbers}}",
  "chat.create_character_image_name_placeholder1": "徹夜したバブル",
  "chat.create_character_image_name_placeholder2": "退屈な午後",
  "chat.create_character_image_name_placeholder3": "運動しに向かう途中",
  "chat.create_character_image_name_placeholder4": "狂った科学者",
  "chat.create_character_image_name_placeholder5": "チャットボットをしているバブル",
  "chat.create_character_add_multi_image_button": "画像を追加",
  "chat.create_character_delete_multi_image_button": "画像を削除",
  "chat.create_character_context_title": "状況設定",
  "chat.create_character_context_tooltip_message": "名前・表情・感情・場所・服装・動作の形式で入力すると、画像が表示される確率が高くなります。\n<br/>以下の例を参考にしてください。<br/>-バブル、眠そうな目、疲労感、机、パーカー、髪をいじる<br/>- ミル、無表情、退屈、学校、制服、机にうつ伏せ<br/>- ユ・チェウォン、恥ずかしそうな微笑み、緊張感、ピラティスに向かう途中、レギンス、挑発的な姿勢",
  "chat.create_character_context_placeholder1": "バブル、眠そうな目、疲労感、机、パーカー、髪をいじる",
  "chat.create_character_context_placeholder2": "学校、制服、無表情、退屈、机にうつ伏せる、ミル",
  "chat.create_character_context_placeholder3": "ピラティスに向かう途中、歩いている、はにかんだ笑顔、緊張感、ユ・チェウォン、レギンス",
  "chat.create_character_context_placeholder4": "破れた実験服とゴム手袋、アンナ・ファウスト、狂気じみた眼差し、好奇心、実験室、試薬の実験",
  "chat.create_character_context_placeholder5": "机の上、バブル、赤らんだ顔、ドキドキ、カジュアルなパーカー、チャット中",
  "chat.create_character_multi_images_help_text": "アップロードされた画像は審査後、規定によりキャラクターがスリルモード専用に変更されたり、非公開になる場合があります。",
  "chat.create_character_add_multi_images_button": "画像をまとめてアップロード",
  "chat.create_character_multi_images_modal_title": "画像を追加",
  "chat.create_character_multi_images_modal_my_ai_images": "マイAI画像",
  "chat.create_character_multi_images_modal_upload_images": "自分のデバイス",
  "chat.create_character_multi_images_modal_help_text": "横型（16:9）で編集すると最も適切に表示されます。",
  "chat.create_character_multi_images_modal_edit": "編集する",
  "chat.create_character_multi_images_modal_edit_done": "完了",
  "chat.create_character_multi_images_modal_edit_zoom": "拡大",
  "chat.create_character_multi_images_modal_edit_reset": "初期化",
  "chat.create_character_multi_images_modal_edit_square": "正方形",
  "chat.create_character_multi_images_modal_edit_landscape": "横長",
  "chat.create_character_multi_images_modal_edit_portrait": "縦長",
  "chat.create_character_multi_images_context_error_msg_a": "画像{{int_imageNumbers}}の状況設定を入力してください。",
  "chat.create_character_multi_images_context_error_msg_b": "*画像 {{int_imageNumbers}} の状況設定が重複しないように入力してください。",
  "chat.create_character_multi_images_main_image_badge": "代表画像",
  "chat.create_character_multi_images_main_image_description": "代表画像を登録してください。",
  "chat.create_character_multi_images_image_title_description": "画像のタイトルを入力してください。",
  "chat.create_character_multi_images_describe_image": "状況設定を入力してください。",
  "chat.create_character_multi_images_edit_info_button": "情報を修正",
  "chat.create_character_multi_images_edit_info_modal_title": "情報を修正",
  "chat.create_character_multi_images_delete_image_button": "画像を削除",
  "chat.create_character_multi_images_max_size": "最大 {{int_size}}",
  "chat.create_character_multi_images_edit_info_modal_public_toggle": "画像を公開する",
  "chat.create_character_multi_images_edit_info_modal_main_image_description": "代表画像は1枚のみ登録可能です。",
  "chat.create_character_multi_images_edit_info_modal_save_button": "登録",
  "chat.create_character_context_placeholder6": "状況設定がシンプルであればあるほど、画像が表示されやすくなり、逆に複雑で詳細な設定ほど、画像の表示が難しくなります。<br/><br/>シンプルな例) 疲れたバブル<br/>複雑な例) 眠そうな目で机に座り、髪をいじりながら夜通しチャットして疲れきったバブルの姿",
  "chat.create_character_multi_images_set_public": "画像を全体公開",
  "chat.create_character_multi_images_modal_delete_description": "画像と一緒に入力された情報もすべて削除されます。",
  "chat.create_character_multi_images_modal_delete_cancel": "キャンセル",
  "chat.create_character_multi_images_modal_delete_delete": "削除",
  "chat.create_character_multi_images_modal_set_unlock_bubbles": "アンロックバブル設定",
  "chat.create_character_multi_images_modal_unlock_available_images": "非公開画像のみ設定できます。",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert1": "アンロックバブル数を設定してください。",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert2": "100バブル単位で入力が可能です。",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert": "アンロックバブルを設定してください。<br/>100バブル単位で入力できます。",
  "chat.create_character_multi_images_modal_unlock_bubbles": "バブル",
  "chat.create_character_multi_images_no_unlock_bubble_set": "アンロックバブルが設定されていません。",
  "chat.create_character_multi_images_tooltip_title1": "マルチイメージとは？",
  "chat.create_character_multi_images_tooltip_description1": "マルチイメージは、会話中に特定のキーワードや状況が現れたら、それにふさわしい画像を自然に表示させる機能です。",
  "chat.create_character_multi_images_tooltip_description2": "状況設定が単純であればあるほど、画像が簡単に開きます。",
  "chat.create_character_multi_images_tooltip_title2": "参考にしてください！",
  "chat.create_character_multi_images_tooltip_description3": "非公開画像は、会話中に設定された状況が作成されたときに開くことができます。",
  "chat.create_character_multi_images_tooltip_description4": "アンロックバブルは最低100バブルから設定でき、キャラクターのリワード収益に含まれます。",
  "chat.create_character_multi_images_tooltip_description5": "非公開イメージに対する収益配分率は50%です。",
  "chat.create_character_multi_images_title_placeholder": "画像タイトルを入力してください(選択)",
  "chat.create_character_multi_images_upload_title": "画像をアップロードしてください",
  "chat.create_character_multi_images_add_title1": "画像を追加する",
  "chat.create_character_multi_images_add_title2": "({{int_numbers}}/200)",
  "chat.create_character_multi_images_add_description1": "クリック/ドラッグ＆ドロップで画像をアップロードしてください",
  "chat.create_character_multi_images_add_description2": "最大{{int_numbers}}枚まで同時にアップロードできます",
  "chat.create_character_multi_images_add_description3": "画像1枚あたり最大15MBまでアップロードできます",
  "chat.create_character_multi_images_upload_fail_size_toast": "容量超過で{{int_numbers}}枚の画像がアップロードに失敗しました",
  "chat.create_character_multi_images_upload_fail_toast": "{{int_numbers}}枚の画像がアップロードに失敗しました。",
  "chat.create_character_multi_images_upload_fail_size": "• 容量超過",
  "chat.create_character_multi_images_upload_fail_format": "• サポートされていない形式",
  "chat.create_character_multi_images_upload_fail_limit": "• アップロード数超過",
  "chat.create_character_multi_images_upload_limit_toast": "一度にアップロードできる画像は{{int_numbers}}枚までです。",
  "chat.create_character_multi_images_uploading": "画像アップロード中…",
  "chat.create_character_multi_images_bulk_edit_modal_title": "一括編集",
  "chat.create_character_multi_images_bulk_edit_modal_image_settings_title": "画像設定",
  "chat.create_character_multi_images_bulk_edit_modal_privacy_settings_title": "公開設定",
  "chat.create_character_multi_images_bulk_edit_modal_bubble_unit_placeholder": "100バブル単位で入力してください",
  "chat.create_character_multi_images_bulk_edit_modal_description": "代表画像は公開設定できません",
  "chat.create_character_multi_images_bulk_edit_modal_delete_alert_description": "削除した画像は復元できません",
  "chat.create_character_multi_images_bulk_edit_modal_selected": "{{count}}個選択されました",
  "chat.create_character_multi_images_bulk_edit_modal_select_all": "全選択",
  "chat.create_character_multi_images_bulk_edit_modal_deselect": "選択解除",
  "chat.create_character_multi_images_bulk_edit_unable_to_set": "設定不可",
  "chat.create_character_multi_images_upload_progress": "{{int_current}}/{{int_total}}枚をアップロード中",
  "chat.create_character_multi_images_upload_cancel": "キャンセル",
  "chat.create_character_multi_images_upload_cancel_confirm_title": "アップロードをキャンセルしますか？",
  "chat.create_character_multi_images_upload_cancel_confirm": "アップロード済みの画像はそのまま保持されます。",
  "chat.create_character_multi_images_upload_failed_label": "アップロード失敗",
  "chat.create_character_multi_images_upload_retry": "再試行",
  "chat.create_character_multi_images_upload_retry_all": "失敗した{{int_numbers}}枚を再試行",
  "chat.create_character_multi_images_upload_partial_toast": "空き枠の分だけ{{int_numbers}}枚を追加しました。",
  "chat.create_character_multi_images_upload_slot_full_toast": "枠がいっぱいのため{{int_numbers}}枚を追加できませんでした。",
  "chat.create_character_multi_images_upload_in_progress_block": "画像のアップロード完了後に保存できます。",
  "chat.create_character_multi_images_error_nav_prev": "前のエラー画像",
  "chat.create_character_multi_images_error_nav_next": "次のエラー画像",
  "chat.create_character_select_universe": "世界観を選択してください",
  "chat.create_character_select_universe_optional": "選択",
  "chat.create_character_select_universe_add": "追加する",
  "chat.create_character_select_universe_create": "作成する",
  "chat.create_character_select_universe_change": "変更する",
  "chat.create_character_select_scene": "シーンを選択してください",
  "chat.create_character_select_scene_optional": "選択",
  "chat.create_character_select_scene_add": "追加する",
  "chat.create_character_select_scene_create": "作成する",
  "chat.create_character_select_scene_change": "変更する",
  "chat.create_character_first_sentence": "最初のひとこと",
  "chat.create_character_first_sentence_optional": "選択",
  "chat.create_character_first_sentence_description": "キャラクターが送る最初の言葉です。",
  "chat.create_character_create_character": "キャラクター作成",
  "chat.create_character_link_only": "リンク公開",
  "chat.create_character_link_only_help_text": "* リンク公開キャラクターは、公開または非公開の状態に修正することはできません。",
  "chat.create_character_link_only_description": "リンクを知っているユーザーのみ使用できます",
  "chat.create_character_link_only_copied": "リンクをコピーしました",
  "chat.create_character_link_only_copied_failed": "リンクのコピーに失敗しました。",
  "chat.create_character_keyword_book_title": "キーワードブック",
  "chat.create_character_keyword_book_number": "キーワードブック{{int_numbers}}",
  "chat.create_character_keyword_book_keyword": "キーワード",
  "chat.create_character_keyword_book_keyword_placeholder": "キーワード入力後エンター(例:ミル)",
  "chat.create_character_keyword_book_keyword_description": "キーワードブック1つあたり最大5つのキーワードを入力できます。",
  "chat.create_character_keyword_book_max_toast": "キーワードは最大5つまで登録できます。",
  "chat.create_character_keyword_book_keyword_alert": "キーワードを入力後、Enterキーを押してください",
  "chat.create_character_keyword_book_content": "内容",
  "chat.create_character_keyword_book_content_placeholder": "キーワードが登場したときに表示される内容を入力してください（例: ミルは追い出されたバブルの面倒を見てほしいという母親の頼みで、仕方なく地球に来ることになる。）",
  "chat.create_character_keyword_book_content_alert": "内容を入力してください。",
  "chat.create_character_keyword_book_add_keyword_book": "キーワードブック追加",
  "chat.create_character_keyword_book_incomplete_toast": "入力中のキーワードブックの項目をすべて記入して下さい。",
  "chat.create_character_keyword_book_edit_modal_title": "キーワードブック名",
  "chat.create_character_keyword_book_edit_modal_cancel": "キャンセル",
  "chat.create_character_keyword_book_edit_modal_done": "編集",
  "chat.create_character_keyword_book_delete_modal_title": "キーワードブックを削除しますか？",
  "chat.create_character_keyword_book_delete_modal_cancel": "キャンセル",
  "chat.create_character_keyword_book_delete_modal_delete": "削除",
  "chat.create_character_keyword_book_tooltip_title1": "キーワードブックとは？",
  "chat.create_character_keyword_book_tooltip_description1": "キーワードブックは、会話中に特定のキーワードが登場したときに、あらかじめ用意した内容を呼び出す機能です。",
  "chat.create_character_keyword_book_tooltip_description2": "キーワードが正確に一致しないと、内容が反映されません。",
  "chat.create_character_keyword_book_tooltip_title2": "ポイント！",
  "chat.create_character_keyword_book_tooltip_description3": "重要なキーワードブックは上にドラッグして優先順位を上げてください。",
  "chat.create_character_keyword_book_tooltip_description4": "1つのキーワードを複数のキーワードブックに登録した場合、そのキーワード言及時に上位10個までのキーワードブックのみ適用されます",
  "chat.create_character_keyword_book_tooltip_description5": "複数のキーワードが同時に出た場合は、最も多く一致したキーワードブックが優先されます。",
  "chat.create_character_keyword_book_tooltip_description6": "キーワードブックは、キャラクターとユーザーのメッセージの両方を認識します",
  "chat.create_universe_creation_guide": "世界観作成ガイドを必ずお読みください！",
  "chat.create_universe_profile_img": "サムネイル画像",
  "chat.create_universe_basics_label": "基本情報",
  "chat.create_universe_add_thumbnail_image_button": "画像追加",
  "chat.create_universe_basics_name": "名前",
  "chat.create_universe_basics_name_placeholder1": "有名人との初めての会話",
  "chat.create_universe_basics_name_placeholder2": "未来科学都市",
  "chat.create_universe_basics_name_placeholder3": "偶然の出会い",
  "chat.create_universe_introduction": "紹介文",
  "chat.create_universe_introduction_help_text": "* 紹介文は世界観の動作には影響しません。",
  "chat.create_universe_introduction_placeholder1": "接点がなさそうだったキャラクターが話しかけてくる。",
  "chat.create_universe_introduction_placeholder2": "科学が目覚ましく発展した近未来",
  "chat.create_universe_introduction_placeholder3": "バスジャック事件の犯人を軽々と制圧したキャラクターと偶然出会った",
  "chat.create_universe_tags_label": "タグ",
  "chat.create_universe_tags_description": "世界観に合うタグを選んでください",
  "chat.create_universe_tags_placeholder": "タグを検索してみてください",
  "chat.create_universe_sharing_options_label": "公開の可否",
  "chat.create_universe_sharing_options_private": "非公開",
  "chat.create_universe_sharing_options_private_description": "自分だけが使用できます。",
  "chat.create_universe_sharing_options_public": "公開",
  "chat.create_universe_sharing_options_public_description": "他のユーザーも使用できます。",
  "chat.create_universe_age_rating_label": "年齢区分",
  "chat.create_universe_age_rating_normal_mode": "一般モード",
  "chat.create_universe_age_verification": "スリルモードの世界観は、年齢確認後に作ることができます。",
  "chat.create_universe_age_rating_normal_mode_description": "すべてのユーザーが使用できます。",
  "chat.create_universe_age_rating_nsfw_mode": "スリルモード",
  "chat.create_universe_age_rating_nsfw_mode_description": "成人のユーザーのみが使用できます。",
  "chat.create_universe_relationship_label": "キャラクターと私の関係",
  "chat.create_universe_relationship_label2": "関係",
  "chat.information_universe_relationship_toast_characters": "キャラクターと私の関係は{{int_characters}}字以下で入力してください。",
  "chat.create_universe_relationship_public": "公開説明",
  "chat.create_universe_relationship_private": "非公開説明",
  "chat.create_universe_relationship_character_button": "キャラクター",
  "chat.create_universe_relationship_user_button": "私",
  "chat.create_universe_relationship_placeholder": "キャラクターと「私」がどんな関係なのか作成してください。<br/>キャラクター自体の属性や性格に対する説明は入れないようにしてください。<br/><br/>例)<br/>キャラクターと私は同居中だ。<br/>キャラクターと私はライバルだ。<br/>キャラクターは私に積極的にアプローチする。",
  "chat.create_universe_details_label": "追加説明",
  "chat.create_universe_details_public": "公開説明",
  "chat.create_universe_details_private": "非公開説明",
  "chat.create_universe_details_character_button": "キャラクター",
  "chat.create_universe_details_user_button": "私",
  "chat.create_universe_create_universe": "世界観の作成",
  "chat.create_universe_lorebook_label": "設定集",
  "chat.create_universe_lorebook_description1": "入力した内容を解釈し、会話中に状況に応じて反映します。",
  "chat.create_universe_lorebook_title": "タイトル",
  "chat.create_universe_lorebook_title_placeholder": "異世界ファンタジー設定集 v0.1.0",
  "chat.create_universe_lorebook_content": "内容",
  "chat.create_universe_lorebook_content_placeholder": "この世界は7つの次元が交差する地点である「ベラノート」を中心に構成されています。<br/>それぞれの次元は時間の流れ、物理法則、生物の姿も異なり、ベラノーテでは異なる存在たちが入り混じって暮らしています。",
  "chat.create_universe_lorebook_description2": "設定集のタイトルは世界観の動作には影響しません。",
  "chat.create_universe_lorebook_description3": "設定集のタイトルは、世界観の動作に影響を与えません。",
  "chat.create_universe_lorebook_incomplete_title_alert": "タイトルを入力してください。",
  "chat.create_universe_lorebook_incomplete_content_alert": "内容を入力してください。",
  "chat.create_universe_lorebook_incomplete_toast": "入力中の設定集項目をすべて満たしてください。",
  "chat.create_scene_creation_guide": "シーン作成ガイドを必ずお読みください！",
  "chat.create_scene_basics_label": "基本情報",
  "chat.create_scene_add_thumbnail_image_button": "画像を追加",
  "chat.create_scene_basics_name": "名前",
  "chat.create_scene_basics_name_placeholder1": "隣の席の有名人",
  "chat.create_scene_basics_name_placeholder2": "病室へお見舞い",
  "chat.create_scene_basics_name_placeholder3": "バスジャック事件",
  "chat.create_scene_introduction_placeholder1": "午前9時、教室の前の席に座ったキャラクターと目が合った",
  "chat.create_scene_introduction_placeholder2": "午後2時、キャラクターがお見舞いに来た",
  "chat.create_scene_introduction_placeholder3": "遅い退勤時間、バスが丸ごと拉致された",
  "chat.create_scene_introduction_help_text": "*紹介フレーズは、シーンの動作に影響を与えません",
  "chat.create_scene_tags_label": "タグ",
  "chat.create_scene_tags_description": "シーンに合ったタグを選んでください。",
  "chat.create_scene_tags_placeholder": "タグを検索してみましょう",
  "chat.create_scene_sharing_options_label": "公開設定",
  "chat.create_scene_sharing_options_private": "非公開",
  "chat.create_scene_sharing_options_private_description": "自分だけが使用できます。",
  "chat.create_scene_sharing_options_public": "公開",
  "chat.create_scene_sharing_options_public_description": "他のユーザーも使用できます。",
  "chat.create_scene_age_rating_label": "年齢区分",
  "chat.create_scene_age_rating_normal_mode": "一般モード",
  "chat.create_scene_age_verification": "スリルモード",
  "chat.create_scene_age_rating_normal_mode_description": "すべてのユーザーが使用できます。",
  "chat.create_scene_age_rating_nsfw_mode": "スリルモード",
  "chat.create_scene_age_rating_nsfw_mode_description": "成人ユーザーのみ使用できます。",
  "chat.create_scene_time": "時間帯",
  "chat.create_scene_place": "場所",
  "chat.create_scene_place_placeholder1": "教室",
  "chat.create_scene_place_placeholder2": "バブル総合病院 入院病棟の病室",
  "chat.create_scene_place_placeholder3": "バスの中",
  "chat.create_scene_time_placeholder1": "午前9時",
  "chat.create_scene_time_placeholder2": "土曜日 午後2時",
  "chat.create_scene_time_placeholder3": "退勤時間",
  "chat.create_scene_optional": "選択",
  "chat.create_scene_details_label": "追加説明",
  "chat.create_scene_details_public": "公開説明",
  "chat.create_scene_details_private": "非公開説明",
  "chat.create_scene_details_character_button": "キャラクター",
  "chat.create_scene_details_user_button": "私",
  "chat.create_scene_details_placeholder": "会話開始のシーンを設定してください。<br/>より詳しく作成すると、より楽しくご利用いただけますよ！<br/><br/>例)<br/>キャラクターが私を起こしに来た。<br/>キャラクターが病棟にお見舞いに来た。",
  "chat.create_scene_create_universe": "シーンを作成する",
  "chat.create_persona_title": "キャラ設定作成",
  "chat.create_persona_placeholder1": "イ·ファン, 17歳, 男性, 高校生、アイドル, 親切、優しさ、活発, 興味関心: ボーカルトレーニング、もうすぐあるコンサートへの不安",
  "chat.create_persona_placeholder2": "キム·ウビン, 20歳, 男性, バブル大学の新入生, 内気、人見知り、思いやりがある、愛に飢えている, 興味関心: 読書、運動、恋愛、愛",
  "chat.create_persona_placeholder3": "ジョン·ハンナ, 18歳, 女性, メイド, 優しいけれど、注意するときはきっぱり、ちょっと天然, 興味関心: アジサイ、家事、チキン",
  "chat.create_persona_create_failed": "キャラ設定の作成に失敗しました。もう一度お試しください。",
  "chat.create_persona_done": "完了",
  "chat.create_persona_create": "自分で作成",
  "chat.create_persona_add_image": "画像を追加",
  "chat.create_persona_optional": "選択",
  "chat.create_persona_name_label": "名前",
  "chat.create_persona_name_placeholder": "イ・ファン",
  "chat.create_persona_name_help_text": "* 他人の権利を侵害するキャラ設定の作成は禁止されています。詳しくは運営ポリシーをご確認ください。",
  "chat.create_persona_gender_label": "性別",
  "chat.create_persona_gender_male": "男性",
  "chat.create_persona_gender_female": "女性",
  "chat.create_persona_gender_other": "その他",
  "chat.create_persona_age_label": "年齢",
  "chat.create_persona_job_label": "職業",
  "chat.create_persona_job_placeholder": "高校生、アイドル",
  "chat.create_persona_character": "性格",
  "chat.create_persona_personality_placeholder": "親切 優しさ 活発",
  "chat.create_persona_interests_label": "関心事",
  "chat.create_persona_interests_placeholder": "ボイストレーニング・もうすぐあるコンサートへの不安",
  "chat.create_persona_import": "キャラクターを作る",
  "chat.create_persona_search": "検索ワードを入力してください。",
  "chat.create_persona_select_tags_button": "タグ選択",
  "chat.create_persona_select_tags_modal_title": "タグ選択",
  "chat.create_persona_select_tags_modal_search": "タグを検索してみてください",
  "chat.create_persona_select_tags_modal_trending_tags": "リアルタイム人気タグ",
  "chat.create_persona_select_tags_modal_selected_tags": "選択したタグ",
  "chat.create_persona_select_tags_modal_reset_button": "初期化",
  "chat.create_persona_select_tags_modal_apply_tags_button": "タグを適用する",
  "chat.create_persona_select_tags_button_selected": "{{int_tagNumbers}}個選択しました",
  "chat.create_persona_chat_list_relevancy": "関連度順",
  "chat.create_persona_chat_list_order_recent": "最新順",
  "chat.create_persona_chat_list_order_liked": "いいねの多い順",
  "chat.create_persona_chat_list_order_played": "プレイの多い順",
  "chat.create_persona_create_toast": "キャラ設定が作成されました。",
  "chat.create_persona_age_limit": "年齢は10億以下、-10億以上のみ可能です。",
  "chat.create_add_multiple_images_toast": "真ん中の空のスロットをすべて埋めると、画像をまとめることができます。",
  "chat.create_tags_characters_toast": "タグは {{int_characters}} 文字以下で入力してください",
  "chat.modify_change_thumbnail_image_button": "画像変更",
  "chat.modify_persona": "キャラ設定修正",
  "chat.modify_persona_failed": "キャラ設定の修正に失敗しました。 もう一度お試し下さい。",
  "chat.modify_character_modify_fail_message": "キャラクターの修正に失敗しました。<br/>もう一度お試し下さい。",
  "chat.modify_universe_modify_fail_message": "世界観の修正に失敗しました。<br/>もう一度お試し下さい。",
  "chat.modify_scene_modify_fail_message": "シーンの修正に失敗しました。<br/>もう一度お試し下さい。",
  "chat.general_connect_fail_message": "サービスに接続できません。 再度読み込むか、しばらくしてから再接続をお願いします。",
  "chat.modify_character_header": "キャラクター修正",
  "chat.modify_universe_header": "世界観修正",
  "chat.modify_scene_header": "シーン修正",
  "chat.modify_character_modify_save": "キャラクター修正",
  "chat.modify_universe_modify_save": "世界観修正",
  "chat.modify_scene_modify_save": "シーン修正",
  "chat.modify_modal_unsaved_changes_title": "保存していない変更があります。",
  "chat.modify_modal_excluded_character_universe": "非公開の場合、当該世界観が基本設定されたすべてのキャラクターから除外されます。<br/>それでも修正しますか？",
  "chat.modify_modal_excluded_character_scene": "非公開の場合、そのシーンがデフォルトに設定されたすべてのキャラクターから除外されます。<br/>それでも修正しますか？",
  "chat.modify_toast_blocked_universe": "非公開処理された世界観は、公開状態に修正できません。",
  "chat.modify_toast_blocked_scene": "非公開処理されたシーンは公開状態に修正できません。",
  "chat.modify_toast_created_only_character": "自分が作ったキャラクターのみ修正できます。",
  "chat.modify_toast_created_only_universe": "自分が作った世界観だけ修正することができます。",
  "chat.modify_toast_created_only_scene": "自分が作ったシーンのみ修正できます。",
  "chat.modify_toast_nsfw_character": "スリルモードキャラクターの年齢は18歳以下に修正できません。",
  "chat.modify_modal_unsaved_changes_description": "作成中の内容は保存されません。 <br/>このページから離れますか？",
  "chat.modify_modal_unsaved_changes_cancel_button": "キャンセル",
  "chat.modify_modal_unsaved_changes_leave_button": "退出",
  "chat.modify_no_change_private_character": "非公開処理されたキャラクターは公開状態に修正できません。",
  "chat.modify_persona_deleted": "キャラ設定を削除しました。",
  "chat.modify_persona_deleted_failed": "キャラ設定の削除に失敗しました。",
  "chat.search_title": "何をお探しですか？",
  "chat.search_search_description_characters": "キャラクター検索",
  "chat.search_search_description_universes": "世界観検索",
  "chat.search_search_description_scenes": "シーン検索",
  "chat.search_search_toggle_menu_characters": "キャラクター",
  "chat.search_search_toggle_menu_universes": "世界観",
  "chat.search_search_toggle_menu_scenes": "シーン",
  "chat.search_search_modal_recent_searches": "最近の検索",
  "chat.search_search_modal_delete_all": "全削除",
  "chat.search_select_tags_button": "タグ選択",
  "chat.search_select_tags_modal_title": "タグ選択",
  "chat.search_select_tags_modal_search": "タグを検索してみてください",
  "chat.search_select_tags_modal_trending_tags": "リアルタイム人気タグ",
  "chat.search_select_tags_modal_selected_tags": "選択したタグ",
  "chat.search_select_tags_modal_reset_button": "リセット",
  "chat.search_select_tags_modal_apply_tags_button": "タグを適用する",
  "chat.search_select_tags_button_selected": "{{int_tagNumbers}}個選択しました",
  "chat.search_nsfw_toggle": "スリルモード",
  "chat.search_chat_list_relevancy": "関連度順",
  "chat.search_chat_list_order_recent": "最新順",
  "chat.search_chat_list_order_liked": "いいねの多い順",
  "chat.search_chat_list_order_played": "プレーの多い順",
  "chat.search_no_results": "検索結果がありません。",
  "chat.search_search_description_writername": "ニックネーム検索",
  "chat.search_search_toggle_menu_writername": "ニックネーム",
  "chat.rewards_revenue_information": "収益情報",
  "chat.rewards_revenue_information_total_revenue": "累積収益",
  "chat.rewards_revenue_information_total_withdrawals": "累積出金額",
  "chat.rewards_revenue_information_last months_withdrawal": "先月の収益",
  "chat.rewards_revenue_information_withdrawable_revenue": "出金可能収益",
  "chat.rewards_revenue_information_withdrawable_revenue_help_text": "純収益から収益配分率によって精算された金額です。<br/>毎月15日に金額が更新されます。",
  "chat.rewards_revenue_information_profit_sharing_rate": "収益配分率",
  "chat.rewards_revenue_information_request_a_withdrawal": "出金申請",
  "chat.rewards_revenue_converted_amount_help_text": "一度、換算して差し引かれた金額は申請取り消しが不可能です。",
  "chat.rewards_creator_information": "クリエーター情報",
  "chat.rewards_creator_information_username": "ユーザーコード",
  "chat.rewards_creator_information_identity_verification": "本人認証",
  "chat.rewards_creator_information_completed_button": "認証完了",
  "chat.rewards_creator_information_email": "メール",
  "chat.rewards_creator_information_edit": "修正",
  "chat.rewards_creator_information_account_verification": "口座認証",
  "chat.rewards_creator_information_verify": "認証する",
  "chat.rewards_tracking_revenue": "収益金の推移",
  "chat.rewards_tracking_revenue_total": "全体",
  "chat.rewards_tracking_revenue_characters": "キャラクター",
  "chat.rewards_tracking_revenue_universes": "世界観",
  "chat.rewards_tracking_revenue_scenes": "シーン",
  "chat.rewards_tracking_revenue_day_button": "日別",
  "chat.rewards_tracking_revenue_week_button": "週別",
  "chat.rewards_tracking_revenue_month_button": "月別",
  "chat.rewards_monthly_sales": "月収",
  "chat.rewards_monthly_sales_my_assets": "マイアセット",
  "chat.rewards_monthly_sales_total": "全体",
  "chat.rewards_monthly_sales_characters_button": "キャラクター",
  "chat.rewards_monthly_sales_universes_button": "世界観",
  "chat.rewards_monthly_sales_scenes_button": "シーン",
  "chat.home_require_alert_login_age_verification_character": "ログインと年齢確認が必要なキャラクターです。",
  "chat.home_require_alert_login_age_verification_universe": "ログインと年齢確認が必要な世界観です。",
  "chat.home_require_alert_login_age_verification_scene": "ログインと年齢確認が必要なシーンです。",
  "chat.home_require_alert_age_verification_character": "年齢確認が必要なキャラクターです。",
  "chat.home_require_alert_age_verification_universe": "年齢確認が必要な世界観です。",
  "chat.home_require_alert_age_verification_scene": "年齢確認が必要なシーンです。",
  "chat.modify_modal_select_public_description": "選択した世界観/シーンが非公開に設定されているため、公開キャラクターに修正することはできません。<br/>公開されている世界観/シーンを選択してください。",
  "chat.rewards_convert_bubbles_button": "バブルチャージする",
  "chat.rewards_convert_bubbles_modal_title": "バブルチャージする",
  "chat.rewards_convertible_bubbles": "交換可能バブル",
  "chat.rewards_bubbles_to_convert": "交換申請バブル",
  "chat.rewards_convert_bubbles_description_calculated": "* 交換可能バブルは、出金可能収益から税金3.3%を精算した値です。",
  "chat.rewards_convert_bubbles_description_refund": "一度交換差し引かれたバブルは、申請の取り消しまたは払い戻しができません。(与信専門金融業法第70条の第3項第2号に基づく)",
  "chat.rewards_convert_bubbles_description_units": "バブル交換は1,000バブル単位で可能で、申請後すぐに差し引かれます。",
  "chat.rewards_convert_bubbles_alert_units": "交換は1,000バブル単位で可能です。",
  "chat.rewards_convert_bubbles_alert_limit": "交換は一度に150万バブルまで可能です。",
  "chat.rewards_notification_profit_application": "収益出金受付のご案内",
  "chat.rewards_notification_subtitle_first": "こんにちは。クリエイター様、BubbleChatです。",
  "chat.rewards_notification_subtitle_second": "収益出金の結果についてご案内いたします。",
  "chat.rewards_notification_profit_application_description": "以下の通り、収益出金が受付されました。",
  "chat.rewards_notification_request_amount": "申請金額",
  "chat.rewards_notification_request_date": "出金申請日",
  "chat.rewards_notification_withdrawal_date": "出金(予定)日",
  "chat.rewards_notification_status": "状態",
  "chat.rewards_notification_pending": "待機",
  "chat.rewards_notification_completed": "完了",
  "chat.rewards_notification_rejected": "却下",
  "chat.rewards_notification_hold": "保留",
  "chat.rewards_notification_deposit_amount": "入金額",
  "chat.rewards_notification_note": "備考",
  "chat.rewards_notification_deposit_tax": "入金額は事業所得(3.3%)控除後の金額です。",
  "chat.rewards_notification_contact_us": "このご案内メールの内容について追加でご不明な点がございましたら、お客様センターへお問い合わせください。",
  "chat.rewards_notification_profit_completion": "収益出金完了のご案内",
  "chat.rewards_notification_profit_completion_description": "以下のように収益の出金が完了しました。",
  "chat.rewards_notification_profit_reject": "収益出金却下のご案内",
  "chat.rewards_notification_profit_reject_description": "あいにく、今回の出金要請は却下処理されました。",
  "chat.rewards_notification_profit_reject_reasons": "出金申請は、以下のような事由が発生した場合に却下されることがあります。",
  "chat.rewards_notification_profit_reject_reasons_copyright": "キャラクター/世界観/シーンが著作権に違反した場合",
  "chat.rewards_notification_profit_reject_reasons_policy": "その他のBubbleChatポリシーに違反した場合",
  "chat.rewards_notification_profit_reject_amount": "申請却下処理された金額は{{int_amount}}ウォンです。",
  "chat.rewards_notification_profit_reject_amount_description": "当該金額は出金可能金額に再反映され、問題が解決された後、再度出金申請することができます。",
  "chat.rewards_notification_profit_hold": "収益引き出し保留のご案内",
  "chat.rewards_notification_profit_hold_description": "残念ながら、今回の出金申請は保留処理されました。",
  "chat.rewards_notification_profit_hold_reasons": "出金の保留は、以下のような理由が発生した場合に保留されます。",
  "chat.rewards_notification_profit_hold_amount": "保留処理された金額は{{int_amount}}ウォンです。",
  "chat.rewards_notification_conversion_completion": "バブル交換完了のご案内",
  "chat.rewards_notification_conversion_completion_description": "以下のようにバブル交換が完了しました。",
  "chat.rewards_notification_conversion_amount": "バブル交換申請金額",
  "chat.rewards_notification_conversion_date": "バブル交換日",
  "chat.rewards_notification_conversion_number": "支給されたバブル数",
  "chat.rewards_notification_conversion_tax": "申請金額に事業所得(3.3%)を差し引いた後、バブルが支給されます。",
  "chat.rewards_top_sales_monthly": "{{int_month}}月売上TOP",
  "chat.rewards_profit_sharing_terms": "クリエイター利用規約",
  "chat.rewards_terms_of_service": "利用規約",
  "chat.rewards_privacy_policy": "個人情報処理方針",
  "chat.rewards_operational_policy": "運用ポリシー",
  "chat.rewards_juvenile_protection_policy": "青少年保護政策",
  "chat.rewards_verify_identify_email_account": "口座認証のために本人認証とメール認証を先に行ってください。",
  "charging_stn_free_modal_allow_web_tracking_title": "ウェブ追跡許可同意",
  "charging_stn_free_modal_allow_web_tracking_description": "広告パフォーマンス向上のためのトラッキングを使用するように<br/>許可しますか？",
  "charging_stn_free_modal_allow_web_tracking_allow": "許可",
  "charging_stn_free_modal_allow_web_tracking_decline": "拒否",
  "chat.rewards_currency_krw": "（ウォン）",
  "chat.rewards_confirmation_email": "交換履歴はメールにてご案内いたします。",
  "chat.rewards_account_holder": "預金者",
  "chat.rewards_bank": "銀行",
  "chat.rewards_account_number": "口座番号",
  "chat.rewards_account_info_update": "口座情報変更",
  "chat.rewards_legal_responsibility": "他人の名義を盗用したり、本人の個人情報でない場合、法的責任を行うことに同意します。",
  "chat.rewards_real name_id": "本人認証名義と同じ名前を入力してください。",
  "chat.rewards_digit_number": "-' なしで数字だけ入力してください。",
  "chat.rewards_only_number": "-' なしで数字だけ入力してください。",
  "chat.rewards_account_holder_name_description": "預金者名は名前と同じである必要があります。",
  "chat.rewards_verify_button": "認証する",
  "chat.rewards_account_verification": "口座認証",
  "chat.rewards_agree_personal_information": "<link1>個人情報の収集および利用</link1>に同意します。",
  "chat.rewards_available_withdrawal_amount": "出金可能金額",
  "chat.rewards_withdrawal_request_amount": "出金申請金額",
  "chat.rewards_withdrawal_amount_deduction": "* 出金可能金額は、出金可能収益から税金3.3%を精算した金額です。",
  "chat.rewards_withdrawal_increments": "出金は10,000ウォン単位で可能で、申請後すぐに差し引かれます。",
  "chat.rewards_requests_made_date": "当月15日以前に出金申請した金額は当月25日に入金され、当月15日あるいはそれ以降に申請した金額は翌月25日に入金されます。 入金完了時にメールにてご案内いたします。",
  "chat.rewards_withdrawal_request_cancel": "キャンセル",
  "chat.rewards_withdrawal_request_submit": "申請する",
  "chat.rewards_modal_reclaimed": "非公開処理されたキャラクター/世界観/シーンがあり、収益の一部が回収されました。 関連のお問い合わせは、<link1>お客様センター</link1>へお問い合わせください。",
  "chat.rewards_modal_reclaimed_button": "確認",
  "chat.rewards_currency_bubbles_zero": "バブル",
  "chat.rewards_currency_bubbles_one": "バブル",
  "chat.rewards_currency_bubbles_other": "バブル",
  "chat.rewards_withdrawal_title": "出金申請する",
  "chat.rewards_withdrawal_currency_krw": "ウォン",
  "chat.rewards_agree_legal_terms": "法的責任に同意してください。",
  "chat.rewards_select_bank": "銀行を選択してください。",
  "chat.rewards_correct_rrn": "正確な身分証番号を入力してください。",
  "chat.rewards_consent_collect_personal_info": "個人情報の収集および利用に同意してください。",
  "chat.rewards_enter_bank_code": "銀行コードを入力してください。",
  "chat.rewards_bubble_conversion_verify_complete": "本人認証とメール認証、口座認証をすべて完了後、交換申請が可能です",
  "chat.rewards_withdrawal_verify_complete": "本人認証とメール認証、口座認証をすべて完了後、出金申請が可能です",
  "chat.rewards_account_verification_help_text": "口座認証のために本人認証とメール認証を先に行ってください。",
  "chat.rewards_modal_unsaved_content_title": "保存していない内容があります。",
  "chat.rewards_modal_unsaved_content_description": "作成された情報がすべて消えます。<br/>それでもページを離れますか？",
  "chat.rewards_modal_unsaved_content_cancel": "キャンセル",
  "chat.rewards_modal_unsaved_content_back": "離れる",
  "chat.rewards_withdrawal_request_completed": "出金申請が完了しました。",
  "chat.rewards_withdrawal_request_failed": "出金申請に失敗しました。",
  "chat.rewards_bubble_conversion_request_completed": "交換申請が完了しました。",
  "chat.rewards_bubble_conversion_request_failed": "交換申請に失敗しました。",
  "chat.rewards_total_revenue_time_update_alert_title": "累積収益の更新サイクル変更",
  "chat.rewards_total_revenue_time_update_alert_description": "システムの改善および安定化のため<br/>24時間を基準として1日1回更新されるようになりました。<br/><br/>ご利用の際にご参考ください。",
  "chat.rewards_total_revenue_time_update_alert_button1": "今後表示しない",
  "chat.rewards_total_revenue_time_update_alert_button2": "確認",
  "chat.rewards_total_revenue_time_update_tooltip": "金額は24時間を基準に1日1回更新されます。",
  "chat.rewards_no_transferable_alert_title": "[9/26~9/30]<br/>バブル変換サービス一時停止のお知らせ",
  "chat.rewards_no_transferable_alert_description": "10月初旬の円滑な所得税申告および精算のため、\nバブル変換サービスを9月26日 00:00から9月30日 23:59まで一時的に停止いたします。",
  "chat.rewards_no_transferable_alert_ok_button": "確認",
  "chat.content_moderation_word_create_validation_message": "不適切な言葉 {{string_words}} が含まれています。",
  "chat.content_moderation_word_create_failed_message": "不適切な言葉が含まれています。修正してから再度お試しください。",
  "chat.content_moderation_word_multi_image_error_message": "画像「{{int_imageNumbers}}」に不適切な言葉が含まれています。",
  "chat.content_moderation_word_multi_image_validation_message": "不適切な言葉が含まれています。{{string_words}} ",
  "chat.content_moderation_word_conversation_toast": "不適切な言葉が含まれています。<br/>{{string_words}} ",
  "chat.content_moderation_word_create_failed_message_button": "確認",
  "chat.content_moderation_word_keyword_book_error_message": "キーワードブック『{{int_keywordbookNumbers}}』に不適切な表現が含まれています。",
  "chat.home_sidebar_support_center": "お客様センター",
  "chat.support_center_top_title": "FAQ",
  "chat.support_center_unresolved_issues": "問題は解決しましたか？",
  "chat.support_center_contact_button": "お問い合わせする",
  "chat.support_center_contact_history_button": "問い合わせ内容",
  "chat.support_center_contact_submit_alert": "お問い合わせを受け付けました。",
  "chat.notification_contact_title": "お問い合わせする",
  "chat.notification_contact_reply": "お問い合わせに対する回答が完了しました。 72時間以内に追加のお問い合わせがない場合、お問い合わせは終了します。",
  "chat.notification_contact_reply_additional_inquiry": "追加のお問い合わせに対する回答が完了しました。 72時間以内に追加のお問い合わせがない場合、お問い合わせは終了します。",
  "chat.support_center_contact_information_title": "1:1お問い合わせのご案内",
  "chat.support_center_contact_information_description1": "回答は平日09:00~17:00の間に順次行われます。",
  "chat.support_center_contact_information_description2": "同じお問い合わせについて、さらにご質問がございましたら、『追加お問い合わせ』から引き続きご記入ください。",
  "chat.support_center_contact_information_description3": "お問い合わせが具体的であればあるほど、より正確なご案内が可能です。",
  "chat.support_center_contact_information_description4": "追加の問い合わせは最大4件まで登録可能です。他の種類の内容は、新しいお問い合わせとして登録してください。",
  "chat.support_center_contact_category_title": "分類",
  "chat.support_center_contact_category_placeholder": "お問い合わせ内容の選択",
  "chat.support_center_contact_user_environment_title": "ユーザー環境",
  "chat.support_center_contact_user_environment_app": "App",
  "chat.support_center_contact_user_environment_web": "Web",
  "chat.support_center_contact_user_environment_manual": "直接入力",
  "chat.support_center_contact_user_environment_placeholder": "ユーザー環境を選択してください。",
  "chat.support_center_contact_inquiry_title": "件名",
  "chat.support_center_contact_inquiry_placeholder": "お問い合わせの件名を入力してください。",
  "chat.support_center_contact_inquiry_detail": "お問い合わせ内容",
  "chat.support_center_contact_inquiry_detail_placeholder": "お問い合わせの内容をお気軽におっしゃってください！",
  "chat.support_center_contact_add_image_optional": "画像添付(選択)",
  "chat.support_center_contact_add_image_format": "JPEG/PNG/WEBP/GIF",
  "chat.support_center_contact_add_image_size": "最大 10MB",
  "chat.support_center_contact_input_category_alert": "分類を選択してください",
  "chat.support_center_contact_user_environment_input_alert": "ユーザー環境を選択してください",
  "chat.support_center_contact_subject_title_input_alert": "件名を入力してください",
  "chat.support_center_contact_subject_detail_input_alert": "内容を入力してください",
  "chat.support_center_contact_status_inquiry_completed": "登録完了",
  "chat.support_center_contact_status_reply_completed": "回答完了",
  "chat.support_center_contact_status_reply_closed": "お問い合わせ終了",
  "chat.support_center_contact_view": "詳細を見る",
  "chat.support_center_contact_view_no_inquiry_history": "お問い合わせの履歴がありません",
  "chat.support_center_contact_view_success_inquiry_message": "お問い合わせが正常に登録されました。<br/>現在、ご提供いただいた内容を確認中で、できるだけ早くご回答いたします。<br/>回答は平日9:00～17:00の間に順次行われます。",
  "chat.support_center_contact_view_inquiry_delete_modal": "お問い合わせをキャンセルしますか？",
  "chat.support_center_contact_view_inquiry_delete_modal_description": "お問い合わせの内容が削除されます。",
  "chat.support_center_contact_modify": "お問い合わせの修正",
  "chat.support_center_contact_unresolved_issue_alert_modal": "まだ問題が解決されていませんか？",
  "chat.support_center_contact_unresolved_issue_alert_modal_description1": "追加のお問い合わせで引き続き質問できます！",
  "chat.support_center_contact_unresolved_issue_alert_modal_description2": "追加のお問い合わせは最大4回まで可能です！",
  "chat.support_center_contact_unresolved_issue_alert_modal_description3": "他の分類のお問い合わせは、新たに受付していただければ、正確にお手伝いができます！",
  "chat.support_center_contact_unresolved_issue_alert_modal_button": "追加のお問い合わせ",
  "chat.support_center_contact_response_check_title": "お問い合わせに対する回答が役に立ちましたか？",
  "chat.support_center_contact_response_additional_inquiry_button": "追加のお問い合わせをする",
  "chat.support_center_contact_response_closed_inquiry_button": "お問い合わせを終了する",
  "chat.support_center_contact_previous_inquiry_title": "以前のお問い合わせと回答",
  "chat.support_center_contact_hide_button": "閉じる",
  "chat.support_center_contact_see_more_button": "詳細を見る",
  "chat.support_center_contact_success_inquiry_closed_toast": "お問い合わせが正常に終了しました",
  "chat.support_center_contact_resolved_inquiry_message": "解決されたお問い合わせです",
  "chat.support_center_contact_fail_submit_toast": "お問い合わせの登録に失敗しました。 もう一度お試しください",
  "chat.support_center_contact_fail_update_toast": "お問い合わせの修正に失敗しました。 もう一度お試しください",
  "chat.support_center_contact_fail_additional_submit_toast": "追加お問い合わせの登録に失敗しました。 追加のお問い合わせは4回まで可能です。",
  "chat.support_center_contact_fail_closed_toast": "お問い合わせの終了に失敗しました。 もう一度お試しください",
  "chat.support_center_contact_fail_cancel_toast": "お問い合わせのキャンセルに失敗しました。 もう一度お試しください",
  "chat.support_center_contact_user_environment_manual_placeholder": "ユーザー環境を直接入力してください。",
  "chat.support_center_contact_user_environment_manual_input_alert": "ユーザー環境を直接入力してください。",
  "chat.support_center_contact_cancel_success_toast": "お問い合わせのキャンセルが完了しました。",
  "chat.support_center_contact_inquiry_complete_success_toast": "お問い合わせが正常に終了しました。",
  "chat.support_center_contact_view_inquiry_support_team": "BubbleChatお客様センター",
  "chat.support_center_contact_enter_title_input_alert": "タイトルは50文字以内で入力してください。",
  "chat.support_center_contact_view_inquiry_cancel_inquiry": "お問い合わせのキャンセル",
  "chat.support_center_contact_view_inquiry_attached_image": "添付画像",
  "statistic_list_title": "統計",
  "statistic_domestic": "国内",
  "statistic_international": "海外",
  "statistic_identity_verification_modal_title": "統計は本人認証の完了後にご確認いただけます。",
  "statistic_payment_history_rewards_button": "リワード",
  "statistic_period_record_title": "最近<span>{{string_time}}</span>{{string_name}}さんの{{string_assets}}で交わした会話の総数は<span>'{{int_numbers}}チャット'</span>です！",
  "statistic_all_record_title": "{{string_name}}さんの{{string_assets}}が交わした会話数は <span>'{{int_numbers}}チャット'</span>です！",
  "statistic_help_information": "集計は 1 時間周期で更新されます。<br/>100チャット未満のアセットは集計されません。",
  "statistic_history_no_record": "100チャット以上の{{string_name}}のみ表示されます。",
  "manual_identity_verification": "本人認証",
  "manual_identity_verification_notify1": "個人情報の収集と利用に同意します",
  "manual_identity_verification_notify2": "他人の名義を盗用したり、本人の個人情報でない場合、法的責任を果たすことに同意します",
  "manual_identity_verification_id_card": "身分証明書",
  "manual_identity_verification_id_card_tooltip": "身分証明書は住民登録証のみ有効です",
  "manual_identity_verification_id_card_file_format": "JPEG/PNG/WEBP/GIF",
  "manual_identity_verification_id_card_file_size": "最大10MB",
  "manual_identity_verification_id_card_name_placeholder": "氏名",
  "manual_identity_verification_id_card_name_guide_th": "氏名はタイ語または英語で入力してください。",
  "manual_identity_verification_id_card_number_placeholder": "身分証明書",
  "manual_identity_verification_id_card_address_placeholder": "住所",
  "manual_identity_verification_id_card_address_guide": "身分証明書の住所と一致しない場合、認証に失敗する可能性があります",
  "manual_identity_verification_id_card_email_placeholder": "メールアドレス",
  "manual_identity_verification_id_card_birthdate_placeholder": "生年月日",
  "manual_identity_verification_submit_button": "提出する",
  "manual_identity_verification_request_complete_title_modal": "本人認証　申請完了",
  "manual_identity_verification_request_complete_description_modal": "ご提出いただいた内容は、3営業日以内に<br/>確認後に処理されます",
  "manual_identity_verification_ok_button": "確認",
  "manual_identity_verification_pending_title_modal": "本人認証待機中",
  "manual_identity_verification_pending_description_modal": "提出された資料は正常に受付ました。<br/>検討後3営業日以内に処理されます",
  "manual_identity_verification_verifying_description": "すでに本人認証が要請された名義です。",
  "manual_identity_verification_complete_title_modal": "本人認証　完了",
  "manual_identity_verification_complete_description_modal": "{{string_date}}に本人認証が<br/>完了しました",
  "manual_identity_verification_waiting_menu": "待機中",
  "web_tracking_consent_alert_modal_title": "ウェブ追跡の許可に同意",
  "web_tracking_consent_alert_modal_description": "ウェブ追跡のために広告識別子を<br/>使用することを許可しますか？",
  "web_tracking_consent_alert_modal_decline_button": "拒否",
  "web_tracking_consent_alert_modal_allow_button": "同意",
  "chat.contest_page_submit_button": "キャラクターを提出する",
  "chat.contest_modal_title": "コンテスト提出",
  "chat.contest_modal_description": "参加条件に合うキャラクターのみ一覧に表示されます",
  "chat.contest_modal_tooltip_title": "参加条件",
  "chat.contest_modal_tooltip_description1": "{{int_year}}年{{int_month}}月{{int_day}}日{{int_hour}}時{{int_minute}}分以降に初公開されたキャラクター",
  "chat.contest_modal_tooltip_description2": "マルチイメージ{{int_number}}個以上のキャラクター",
  "chat.contest_modal_submitted_character": "提出完了",
  "chat.contest_modal_character_empty": "条件に合うキャラクターがありません",
  "chat.contest_modal_production_grant_title": "制作支援金を申請する",
  "chat.contest_modal_production_grant_description1": "キャラクター{{int_number}}体以上提出で申請可能です",
  "chat.contest_modal_production_grant_description2": "キャラクターを提出した時点で、注意事項に同意したものとみなされます",
  "chat.contest_modal_submit_button": "提出する",
  "chat.contest_modal_production_grant_title_complete": "制作支援金の申請が完了しました",
  "chat.contest_modal_submit_alert_title": "キャラクターを提出しますか？",
  "chat.contest_modal_submit_alert_description": "提出後はキャンセルできません",
  "chat.contest_modal_submit_successful_title": "キャラクターの提出が完了しました",
  "chat.contest_submission_period_ended_alert_title": "提出期間が終了しました",
  "chat.information_selected_persona_title": "現在のキャラ設定",
  "chat.information_selected_persona_login_to_use": "ログイン後に利用",
  "chat.information_conversation_mode_title": "対話モード",
  "chat.information_conversation_mode_messenger": "チャット形式",
  "chat.information_persona_bottomsheet_title": "どんなキャラ設定で会話しますか？",
  "chat.information_persona_bottomsheet_description": "キャラ設定なしでもすぐに会話できます",
  "chat.information_conversation_mode_bottomsheet_title": "どんな形式で会話しますか？",
  "chat.information_conversation_mode_bottomsheet_description": "小説形式では没入感のある会話を<br/>チャット形式では気軽で負担のない会話を楽しんでみてください",
  "chat.information_conversation_mode_bottomsheet_example1": "キャラクターが挨拶した",
  "chat.information_conversation_mode_bottomsheet_example2": "こんにちは",
  "chat.information_conversation_mode_bottomsheet_example3": "ユーザーが返事をした",
  "chat.conversation_menu_my_balance": "保有財貨",
  "chat.conversation_long_term_memory_current_memory": "現在の記憶",
  "chat.conversation_long_term_memory_current_memory_title": "現在のチャットルームに適用中の記憶です",
  "chat.conversation_long_term_memory_current_memory_description": "設定した要約周期ごとに、これまでの会話を自動で要約・更新します",
  "chat.conversation_long_term_memory_current_memory_auto_update_toggle": "自動更新",
  "chat.conversation_long_term_memory_current_memory_next_update_label": "次回更新まで",
  "chat.conversation_long_term_memory_current_memory_turns_remaining": "あと {{int_number}} ターン",
  "chat.conversation_long_term_memory_history_description1": "好きな記憶を選択して、現在の記憶に読み込めます",
  "chat.conversation_long_term_memory_history_description2": "記憶が20個を超えると、古い記憶から削除されます({{int_numbers}}/20)",
  "chat.conversation_long_term_memory_summary_settings_title": "キャラクターの記憶が要約される方式を設定してみてください",
  "chat.conversation_long_term_memory_summary_settings_description": "キャラクターの記憶を、どんな頻度、分量<br/>基準で要約するか設定できます",
  "chat.conversation_long_term_memory_summary_settings_interval_caption": "{{int_numbers}}ターンごとに記憶を要約します",
  "chat.conversation_long_term_memory_summary_settings_length_caption": "記憶を {{int_numbers}} 文字まで要約します",
  "chat.conversation_long_term_memory_summary_settings_summary_instructions": "要約指針",
  "chat.conversation_long_term_memory_summary_settings_guideline_placeholder": "要約指針を入力してください",
  "chat.conversation_long_term_memory_summary_settings_auto_guideline_info": "記憶を要約する指針を自動設定します",
  "chat.conversation_output_environment_header_title": "出力される会話の品質と分量を設定してみましょう",
  "chat.conversation_output_environment_header_description": "記憶力と出力量が高いほど、消費される財貨が増えます",
  "chat.conversation_output_environment_memory_title": "記憶力",
  "chat.conversation_output_environment_memory_description": "キャラクターが最近の会話をどれくらい覚えるか設定します",
  "chat.conversation_output_environment_memory_limit_caption": "{{int_numbers}}ターンまで記憶します",
  "chat.conversation_output_environment_memory_warning_description": "記憶力が要約周期より短いため、キャラクターが重要な内容を忘れる可能性があります",
  "chat.conversation_output_environment_response_length_title": "出力量",
  "chat.conversation_output_environment_response_length_description": "キャラクターが一度にどれくらい長く返答するか設定します",
  "chat.conversation_output_environment_response_length_short_button": "少なめ",
  "chat.conversation_output_environment_response_length_medium_button": "普通",
  "chat.conversation_output_environment_response_length_long_button": "多め",
  "chat.conversation_output_environment_response_length_short_description": "状況説明とセリフが要点中心で簡潔に出力されます",
  "chat.conversation_output_environment_response_length_medium_description": "状況説明とセリフが適度な長さでバランスよく出力されます",
  "chat.conversation_output_environment_response_length_long_description": "状況説明とセリフが繊細な描写で豊かに出力されます",
  "chat.conversation_free_limit_modal_title1": "より優れたモデル、より深い没入感",
  "chat.conversation_free_limit_modal_description1": "流れを遮る広告なしで<br/>物語に完全に没入してみましょう",
  "chat.conversation_free_limit_modal_miru_description": "しっかりしたストーリー構成と深みのあるストーリーテリング",
  "chat.conversation_free_limit_modal_ads_title": "広告削除",
  "chat.conversation_free_limit_modal_persona_title": "キャラ設定拡張",
  "chat.conversation_free_limit_modal_persona_description": "最大{{string_chars}}文字",
  "chat.conversation_free_limit_modal_usernote_title": "ユーザーノート拡張",
  "chat.conversation_free_limit_modal_usernote_description": "最大{{string_chars}}文字",
  "chat.conversation_free_limit_modal_memory_title": "長期記憶拡張",
  "chat.conversation_free_limit_modal_memory_description": "最大{{string_chars}}文字、要約周期カスタム",
  "chat.conversation_free_limit_modal_output_title": "出力設定カスタム",
  "chat.conversation_free_limit_modal_output_description": "記憶力、出力量の調整",
  "chat.conversation_free_limit_modal_upgrade_button": "{{string_signature}}に変更",
  "chat.conversation_free_limit_modal_ad_button": "広告を見て無料で会話する",
  "chat.conversation_convert_to_free_modal_title_suffix": "{{string_modelname}}で会話が進行します",
  "chat.conversation_convert_to_free_modal_subtitle": "一部機能の範囲が縮小されます",
  "chat.conversation_convert_to_free_modal_persona_from": "プロフィール {{string_chars}}文字",
  "chat.conversation_convert_to_free_modal_persona_to": "→ {{string_chars}}文字",
  "chat.conversation_convert_to_free_modal_usernote_from": "ユーザーノート {{string_chars}}文字",
  "chat.conversation_convert_to_free_modal_usernote_to": "→ 利用不可",
  "chat.conversation_convert_to_free_modal_memory_from": "長期記憶 {{string_chars}}文字",
  "chat.conversation_convert_to_free_modal_memory_to": "→ {{string_chars}}文字",
  "chat.conversation_convert_to_free_modal_output_settings_from": "出力環境設定可能",
  "chat.conversation_convert_to_free_modal_output_settings_to": "→ 変更不可",
  "chat.conversation_convert_to_free_modal_description1": "入力済みのプロフィールとユーザーノート内容は削除されませんが、実際の会話には縮小された文字数分のみ適用されます",
  "chat.conversation_convert_to_free_modal_description2": "長期記憶は現在適用中の要約周期が終了すると、変更後の設定値が適用されます",
  "chat.conversation_convert_to_free_modal_confirm_button": "それでも変更する",
  "chat.conversation_free_model_chip": "無料",
  "chat.conversation_free_model_banner_title": "無料モデルを使用中です",
  "chat.conversation_free_model_banner_persona_limit_description": "無料モデル使用中は、キャラ設定は{{string_chars}}文字までしか適用されません",
  "chat.conversation_free_model_banner_usernote_limit_description": "無料モデル使用中は、ユーザーノートは{{string_chars}}文字までしか適用されません",
  "chat.conversation_free_model_banner_memory_limit_description": "無料モデル使用中は、長期記憶は{{string_chars}}文字までしか適用されません",
  "chat.conversation_free_model_banner_feature_limit_description": "無料モデル使用中は、機能が制限されます",
  "chat.popup_model_my_bubbles_label": "保有バブル",
  "chat.popup_model_topup_button": "チャージ",
  "chat.bottomsheet_model_title": "AIモデルの選択",
  "chat.conversation_persona_no_set_persona_label": "設定されたキャラ設定はありません",
  "chat.conversation_persona_no_set_persona_description1": "選択されたキャラ設定がありません",
  "chat.conversation_persona_no_set_persona_description2": "マイページに登録されたニックネームで会話に参加します",
  "chat.conversation_paid_model_chip": "有料",
  "chat.bottomsheet_model_estimated_bubbles": "予想 {{int_value}} バブル",
  "chat.conversation_output_environment_memory_paid_only_description": "記憶力調整機能は、有料モデル利用時のみ設定できます",
  "chat.conversation_output_environment_response_length_paid_only_description": "出力量調整機能は、有料モデル利用時のみ設定できます",
  "chat.conversation_long_term_memory_summary_length_title": "要約文字数",
  "chat.conversation_long_term_memory_summary_length_description": "文字数を超えた場合、圧縮して履歴に保存されます",
  "chat.conversation_long_term_memory_summary_settings_custom_guideline_info": "記憶を要約するための指示を入力できます",
  "chat.conversation_long_term_memory_summary_interval_paid_only_description": "要約頻度調整機能は、有料モデル利用時のみ設定できます",
  "chat.conversation_long_term_memory_summary_length_paid_only_description": "要約文字数調整機能は、有料モデル利用時のみ設定できます",
  "chat.conversation_no_model_label": "モデルなし",
  "chat.free_model_ad_unavailable_toast": "広告を読み込めません。 しばらくしてからもう一度お試しください",
  "chat.free_model_ad_loading_title": "広告準備中",
  "chat.free_model_ad_loading_desc": "少々お待ちください···",
  "chat.conversation_free_limit_modal_ad_preparing_button": "広告準備中",
  "chat.information_conversation_mode_bottomsheet_character": "キャラクター",
  "chat.conversation_user_note_disabled_modal_title": "Weaveモデルでは利用できません",
  "chat.conversation_user_note_disabled_modal_description": "モデルを変更してください",
  "chat.creator_verification_create_not_verified_alert_description": "アセットを作成するには本人認証が必要です",
  "chat.creator_verification_create_not_verified_alert_identity_verify_button": "本人認証する",
  "chat.creator_verification_my_banner": "クリエイター認証をして、現金リワードを受け取りましょう！",
  "chat.creator_verification_create_modal_description": "BubbleChatクリエイターに申請して、現金リワードを受け取りましょう！",
  "chat.creator_verification_create_modal_view_benefits_button": "特典を見る",
  "chat.creator_verification_verified_modal_description": "BubbleChatクリエイターになりました！",
  "chat.creator_verification_not_verified_modal_description": "クリエイター申請の対象外です",
  "chat.creator_verification_verified_modal_view_rewards_button": "リワードを見る",
  "chat.rewards_revenue_sharing_terms_agreement_title": "リワード利用のためクリエイター利用規約に同意してください",
  "chat.rewards_revenue_sharing_terms_agreement_checkbox": "クリエイター利用規約に同意します",
  "chat.create_image_ai_generated_image_checkbox_description": "AI生成画像",
  "chat.conversation_ai_generated_banner": "この対話はAIによって生成された内容です",
  "dmm.point": "DMMポイント",
  "dmm.charge_button": "チャージ",
  "dmm.bubble": "バブル",
  "dmm.point_owned": "保有 DMMポイント",
  "dmm.not_enough_point_alert_description": "DMMポイントが不足していて、会話を続けることができません。",
  "dmm.not_enough_point_alert_charge_guide": "DMMポイントをチャージした後、キャラクターと引き続き会話してみてください。",
  "weave.daily_limit_indicator": "無料 {{int_current}}/{{int_max}}回",
  "weave.daily_limit_indicator_unlimited": "無料 ∞",
  "weave.daily_recharge_note": "毎日深夜0時チャージ",
  "weave.free_limit_reached_title": "無料チャットをすべて使い切りました",
  "weave.limit_reached_alert_title": "Weaveモデルの1日の利用回数を使い切りました",
  "weave.limit_reached_alert_body": "Weave Passで無制限チャットをお楽しみください",
  "weave.limit_reached_alert_switch_to_model_cta": "Miruに切り替えてチャットする",
  "weave.limit_reached_reset_notice": "無料チャットは明日の0時に回復します",
  "weave.pass_product_name": "Weave Pass",
  "weave.pass_product_30days_title": "Weave Pass 30日",
  "weave.pass_product_1day_title": "Weave Pass 1日",
  "weave.pass_price_dmm": "{{int_numbers}} DMMポイント",
  "weave.pass_benefit_1": "Weaveと回数無制限でチャット",
  "weave.pass_purchase_confirm": "{{string_productName}}を購入しますか？",
  "weave.pass_purchase_success": "購入が完了しました！",
  "weave.pass_purchase_fail": "購入に失敗しました。もう一度お試しください",
  "weave.pass_purchase_insufficient_title": "DMMポイントが不足しているため、{{string_productName}}を購入できませんでした",
  "weave.pass_purchase_insufficient_body": "DMMポイントをチャージしてから商品をご購入ください",
  "weave.pass_purchase_insufficient_current": "現在のDMMポイント",
  "weave.pass_purchase_insufficient_required": "購入に必要なDMMポイント",
  "weave.pass_purchase_insufficient_shortage": "不足しているDMMポイント",
  "weave.pass_purchase_insufficient_cta": "チャージする",
  "weave.pass_purchase_duplicate": "現在ご利用中の利用券があります。{{string_productName}}の利用終了後に購入できます",
  "weave.pass_active_badge": "Weave Pass利用中",
  "weave.pass_expired_title": "Weave Passの利用が終了しました",
  "weave.pass_expired_body": "このチャットから特典が適用されなくなります。<br/>利用券を再購入して、快適なチャットを続けましょう！",
  "pwa.common_later": "あとでする",
  "pwa.install_headline": "アプリをインストールせずに<br/>ホーム画面からすぐに{{appName}}",
  "pwa.install_banner_cta_install": "ホーム画面に追加",
  "pwa.install_banner_cta_open_browser": "ブラウザで開く",
  "pwa.install_banner_cta_open_safari": "Safariで開く",
  "pwa.install_banner_inapp_text": "快適にご利用いただくため<br/>{{appName}}をブラウザで開いてください",
  "pwa.install_banner_aria": "アプリインストール案内",
  "pwa.push_pre_title": "{{appName}}の最新情報を<br/>通知で受け取りましょう",
  "pwa.push_pre_desc": "お気に入りキャラクターからの新着メッセージや<br/>コンテスト・イベント情報をお知らせします",
  "pwa.push_pre_bullet_1": "イベント・お知らせ・新規アセット情報",
  "pwa.push_pre_bullet_2": "フォロー・いいね・コメント・返信などの通知",
  "pwa.push_pre_bullet_3": "バブル・シャンプー・利用券などのお知らせ",
  "pwa.push_pre_confirm": "通知を受け取る",
  "pwa.install_steps_title": "インストール方法",
  "pwa.install_steps_ios_1": "Safari下部の［共有］ボタンを選択",
  "pwa.install_steps_ios_2": "ホーム画面に［追加］を選択",
  "pwa.install_steps_ios_3": "右上の［追加］を選択",
  "pwa.install_steps_aos_1": "右上のメニュー（⋮）を選択",
  "pwa.install_steps_aos_2": "ホーム画面に追加を選択",
  "pwa.install_steps_aos_3": "追加を選択",
  "pwa.inapp_guide_title": "{{targetBrowser}}で開いてください",
  "pwa.inapp_guide_desc": "リンクをコピーして{{targetBrowser}}で開き<br/>以下の手順でインストールしてください",
  "pwa.inapp_guide_copy": "リンクをコピー",
  "pwa.inapp_guide_default_browser": "デフォルトブラウザ",
  "pwa.install_qr_caption": "スマートフォンのカメラでQRコードを読み取り、ダウンロードしてください",
  "pwa.install_qr_desktop_cta": "PCにショートカットを追加",
  "pwa.offline_message": "ネットワーク接続が不安定です<br/>しばらくしてからもう一度お試しください",
  "pwa.offline_reload": "更新",
  "pwa.toast_copy_success": "リンクをコピーしました",
  "pwa.toast_copy_fail": "リンクのコピーに失敗しました",
  "pwa.toast_desktop_install_unsupported": "このブラウザでは直接インストールできません。アドレスバーのインストールアイコンをご利用ください",
  "pwa.push_default_title": "通知",
  "login.start_with_kakao": "Kakaoで始める",
  "login.start_with_google": "Googleで始める",
  "login.start_with_apple": "Appleで始める",
  "login.start_with_line": "LINEで始める",
  "login.start_with_dmm": "DMMで始める",
  "chat.onboarding_conversation_watch_ad_alert": "チャットを続けるには、広告をご視聴ください",
  "chat.onboarding_chat_load_error_modal_description": "以前の会話を読み込めませんでした。もう一度試しますか？",
  "chat.onboarding_chat_load_error_modal_not_now_button": "あとで",
  "chat.onboarding_character_recommendation_title": "会話するキャラクターを選んでみましょう",
  "chat.onboarding_character_recommendation_button": "会話する",
  "chat.onboarding_conversation_watch_ad_alert_button": "広告を見る",
  "chat.onboarding_login_title": "簡単にログインして<br/>ときめくロマンスを続けましょう！",
  "general.chat": "BubbleChat",
  "general.chatlist": "会話",
  "chat.home_install_pwa_button": "すぐ追加",
  "chat.home_install_app_description": "最新情報はアプリでいち早く",
  "chat.custom_character_title": "プレイするキャラクターを選択してください",
  "chat.custom_universe_title": "プレイする世界観を選択してください",
  "chat.custom_scene_title": "プレイするシーンを選択してください",
  "chat.custom_character_browse_button": "キャラクター一覧へ",
  "chat.custom_universe_browse_button": "世界観一覧へ",
  "chat.custom_scene_browse_button": "シーン一覧へ",
  "chat.information_selected_persona_and_mode_description": "{{string_naming}} キャラ設定で {{string_type}} の会話を始めます",
  "chat.information_conversation_mode_bottomsheet_information": "チャットルームを作った後は変更できません",
  "chat.information_conversation_mode_character_line_story": "\"キャラクターのセリフです。 長く詳しく話を聞かせてくれます\"",
  "chat.information_conversation_mode_character_narrative_story": "状況を説明する部分です。 チャット形式よりも詳細で長い回答をくれます。",
  "chat.information_conversation_mode_user_line": "あなたのセリフです",
  "chat.information_conversation_mode_user_narrative": "あなたが入力した行動です",
  "chat.information_conversation_mode_character_line_messenger": "\"キャラクターのセリフです。 メッセンジャーのように短くやり取りします\"",
  "chat.information_conversation_mode_character_narrative_messenger": "状況を説明する部分です。",
  "chat.information_conversation_mode_messenger_bottomsheet_start_talk": "チャット形式ですぐに会話",
  "chat.information_conversation_mode_story_bottomsheet_start_talk": "小説形式ですぐに会話",
  "chat.information_bottomsheet_back": "選択して戻る",
  "chat.information_persona_bottomsheet_hint": "キャラ設定は会話中でも変更できます",
  "chat.information_persona_bottomsheet_start": "このキャラ設定で会話を始める",
  "chat.information_persona_edit_button": "編集",
  "chat.information_persona_delete_button": "削除",
  "chat.information_detail_cta_description": "'{{persona}}'キャラ設定で '{{mode}}' 会話を始めます",
  "chat.information_multi_image": "マルチイメージ",
  "chat.information_multi_image_count": "{{int_count}}件",
  "chat.information_creator_title": "製作者",
  "chat.information_reviews_count": "コメント {{int_count}}件",
  "chat.information_replies_expand": "返信 {{int_count}}件　もっと見る",
  "chat.information_replies_collapse": "返信{{int_count}}件　閉じる",
  "chat.information_reply_mention_button": "返信する",
  "chat.information_comment_pin_aria": "固定",
  "chat.information_comment_unpin_aria": "固定を解除",
  "chat.information_comment_edit_aria": "コメント編集",
  "chat.information_reply_edit_aria": "返信編集",
  "general.back_aria": "戻る",
  "general.share_aria": "共有",
  "general.previous_aria": "前へ",
  "chat.information_asset_nsfw": "スリル",
  "chat.bottomsheet_model_section_featured": "おすすめラインナップ",
  "chat.bottomsheet_model_section_others": "全モデル",
  "chat.bottomsheet_model_chip_etc": "その他",
  "chat.bottomsheet_model_own_model_label": "BubbleChat独自モデル",
  "chat.bottomsheet_model_changed_toast": "{{string_modelName}}に変更されました",
  "chat.guest_popup_signup_headline": "あなた好みのキャラクターがたくさん！",
  "chat.guest_popup_signup_subline": "ログインして、自分だけの物語を始めましょう",
  "chat.guest_popup_memory_headline": "今ここを離れたら、私のことを忘れちゃいますよ…",
  "chat.guest_popup_memory_subline": "ログインして、あなたのこと私に覚えさせてみましょう！",
  "chat.guest_popup_app_install_headline": "毎回検索してアクセスするの？",
  "chat.guest_popup_app_install_subline": "アプリをホーム画面に追加して、1秒でアクセス！",
  "chat.guest_popup_ad_removal_headline": "会話が途中で途切れるのが嫌なら？",
  "chat.guest_popup_ad_removal_subline": "登録して広告をなくし、無制限で楽しみましょう！",
  "chat.guest_popup_watch_ad_button": "広告を見て無料でチャットする",
  "chat.guest_popup_app_download_button": "アプリをダウンロード",
  "chat.profile_my_password_current_label": "現在のパスワード",
  "chat.profile_my_password_new_label": "新しいパスワード",
  "chat.profile_my_status_verified": "認証済み",
  "chat.profile_my_status_unverified": "未認証",
  "chat.profile_my_status_password_set": "設定済み",
  "chat.profile_my_status_password_unset": "未設定",
  "chat.profile_my_edit_view_content_current_country_description": "現在選択中の国で作られたコンテンツのみ表示されます",
  "chat.profile_my_edit_view_content_all_countries_description": "サービス提供中のすべての国で作られたコンテンツが表示されます",
  "chat.creator_verification_my_banner_button": "クリエイター登録",
  "chat.conversation_unsupported_feature_modal_title": "この機能を使いたいですか？",
  "chat.conversation_unsupported_feature_modal_current_label": "現在のモデル",
  "chat.conversation_unsupported_feature_modal_description1": "<model>{{string_modelName}}</model>では、この機能はご利用いただけません。",
  "chat.conversation_unsupported_feature_modal_description2": "他のモデルに切り替えて、もっと多彩な機能を使ってみましょう！",
  "profile.decorator_expired": "期限切れ",
  "general.no_products": "現在購入できる商品はありません",
  "general.loading": "読み込み中…",
  "profile.user_blocked_alert_message": "ブロックすると該当ユーザーのコメントを見ることができなくなります。<br/>本当にブロックしますか？",
  "chat.profile_my_decorator_apply_button": "適用する",
  "chat.profile_my_decorator_title": "デコター",
  "chat.rewards_mg_title": "星守リワード",
  "chat.rewards_mg_current_month_revenue_pre_tax": "当月の総リワード(税引前)",
  "chat.rewards_mg_current_month_revenue_after_tax": "当月の総リワード(税引後)",
  "chat.rewards_mg_settlement_period": "算定期間",
  "chat.rewards_mg_payout_date": "当月分の支払予定日",
  "chat.rewards_mg_previous_month_payout_date": "前月分の支払予定日",
  "chat.rewards_mg_previous_month_revenue_pre_tax": "前月の確定リワード(税引前)",
  "chat.rewards_mg_previous_month_revenue_after_tax": "前月の確定リワード(税引後)",
  "chat.rewards_mg_contract_amount": "契約上の最低保証額（MG）",
  "chat.rewards_mg_shortfall": "MG差額",
  "chat.rewards_mg_notice": "当月の総リワードが契約上の最低保証額(MG)を下回る場合、不足分が補填され、MGに達する金額が支払われます。\n総リワードがMG以上の場合、差額は発生せず、超過分が減額されることはありません。\nMGの差額は毎月末日23:59時点で算定し、翌月10日にお支払いします。\n支払日が土日祝日にあたる場合は、支払日が変更されることがあります。\n月末日23:59以降に発生したリワードは、翌月の算定に含まれます。",
  "chat.rewards_creator_information_grade": "クリエーターランク",
  "chat.creator_grade_stardust": "星屑",
  "chat.creator_grade_rising_star": "明星",
  "chat.creator_grade_starkeeper": "星守",
  "profile.user_unblocked_alert_message": "このユーザーのブロックを解除しますか？",
  "report.type.spam_text": "広告",
  "report.type.advertisement_text": "無許可広告",
  "report.type.inappropriate_text": "不適切な活動",
  "report.type.personal_info_text": "個人情報流出",
  "report.type.other_text": "その他",
  "payment.page_list_tag_sale_period": "シルバーウィーク限定！{{date}}まで",
  "payment.page_list_bonus_expiration": "本商品で付与されるボーナスバブルの有効期限は{{int_days}}日間です",
  "chat.conversation_reroll_guidance_title": "リロール指示",
  "chat.conversation_reroll_guidance_cost_tooltip": "リロール指示を使用すると、追加で財貨を消費する場合があります",
  "chat.conversation_reroll_guidance_description": "どのように再生成しますか？",
  "chat.conversation_reroll_guidance_description_sub": "出力設定から、リロール指示の表示設定を変更できます。",
  "chat.conversation_reroll_guidance_input_placeholder": "例）ステータス画面の形式はそのままにして、レイナの反応をもっと冷たく",
  "chat.conversation_reroll_guidance_input_caption": "指示は{{int_numbers}}文字まで入力できます",
  "chat.conversation_reroll_guidance_cost_info_button_label": "料金案内を見る",
  "chat.conversation_reroll_guidance_reset_button": "リセット",
  "chat.conversation_reroll_guidance_skip_button": "指示なしでリロール",
  "chat.conversation_reroll_guidance_submit_button": "リロール",
  "chat.conversation_reroll_guidance_discovery_toast": "毎回すぐにリロールする場合は、出力設定から変更できます",
  "chat.conversation_reroll_guidance_setting_title": "リロール指示",
  "chat.conversation_reroll_guidance_setting_description": "リロール時に、再生成の方向を入力する画面を表示します",
  "chat.conversation_reroll_guidance_setting_on_caption": "リロールをタップすると、指示入力画面が表示されます。",
  "chat.conversation_reroll_guidance_setting_off_caption": "リロールをタップすると、すぐに再生成されます",
  "chat.conversation_reroll_guidance_setting_off_toast": "これからはリロールをタップすると、すぐに再生成されます",
  "chat.custom_modal_input_settings": "入力欄設定",
  "chat.custom_modal_direction_button_position": "状況説明ボタンの位置",
  "chat.conversation_composition_title": "会話の構成",
  "chat.conversation_chat_link_copy_button": "リンクコピー",
  "chat.conversation_chat_copy_modal_description": "コピーの名前を決めてください。キャラクター・世界観・シーンの設定とこれまでの会話履歴がそのままコピーされます",
  "chat.free_model_ad_retry_wait_toast": "広告を読み込めませんでした。{{int_seconds}}秒後にもう一度お試しください",
  "chat.free_model_ad_retry_wait_minutes_toast": "広告を読み込めませんでした。{{int_minutes}}分後にもう一度お試しください",
  "chat.conversation_sidebar_chat_copy": "チャットコピー",
  "chat.conversation_sidebar_link_copied": "チャットルームのリンクをコピーしました",
  "pwa.install_steps_ipad_1": "Safari上部の［共有］ボタンを選択",
  "chat.custom_modal_tab_color": "カラー",
  "chat.custom_modal_tab_input": "入力欄",
  "chat.custom_modal_tab_lab": "ラボ",
  "chat.custom_modal_background_opacity": "背景の不透明度",
  "chat.custom_modal_opacity_min": "完全に透明",
  "chat.custom_modal_opacity_max": "完全に不透明",
  "chat.custom_modal_reset_viewer_button": "表示のみリセット",
  "chat.custom_modal_reset_text_button": "テキストのみリセット",
  "chat.custom_modal_reset_color_button": "カラーのみリセット",
  "chat.custom_modal_reset_input_button": "入力欄のみリセット",
  "chat.custom_modal_reset_lab_button": "ラボのみリセット",
  "chat.custom_modal_reset_all_button": "すべてリセット",
  "chat.custom_modal_reset_all_alert_title": "すべてリセットしますか？",
  "chat.custom_modal_reset_all_alert_description": "表示・テキスト・カラー・入力欄の設定がすべてデフォルトに戻ります。保存すると適用されます",
  "chat.custom_modal_reset_all_alert_description_lab": "表示・テキスト・カラー・入力欄・ラボの設定がすべてデフォルトに戻ります。保存すると適用されます",
  "chat.custom_modal_reset_all_toast": "デフォルトに戻しました。保存して適用してください",
  "chat.custom_modal_apply_scope_title": "どこに適用しますか？",
  "chat.custom_modal_apply_scope_description": "変更した設定の適用範囲を選んでください",
  "chat.custom_modal_apply_scope_room_button": "このチャットルームのみに適用",
  "chat.custom_modal_apply_scope_story_all_button": "小説形式のチャットルームすべてに適用",
  "chat.custom_modal_apply_scope_chat_all_button": "チャット形式のチャットルームすべてに適用",
  "chat.custom_modal_apply_scope_story_note": "一括適用は小説形式のチャットルームのみに反映されます。チャット形式のルームの設定はそのまま維持されます",
  "chat.custom_modal_apply_scope_chat_note": "一括適用はチャット形式のチャットルームのみに反映されます。小説形式のルームの設定はそのまま維持されます",
  "chat.custom_modal_apply_room_toast": "このチャットルームのみに適用しました",
  "chat.custom_modal_apply_all_toast": "すべてのチャットルームに適用しました",
  "chat.custom_modal_lab_font": "フォント",
  "chat.custom_modal_lab_font_batang": "明朝体",
  "chat.custom_modal_lab_font_handwriting": "手書き風",
  "chat.create_character_multi_images_main_image_chip": "代表",
  "chat.create_character_multi_images_bulk_edit_mixed": "混合",
  "chat.create_character_multi_images_bulk_edit_public_mixed_description": "公開状態が混在しています。タップすると、すべて公開に変更されます。",
  "chat.create_character_multi_images_bulk_edit_ai_mixed_description": "AI生成表示が混在しています。タップすると、すべてAI生成に変更されます。",
  "chat.create_character_multi_images_replace_image": "イメージ差し替え",
  "chat.create_character_multi_images_main_image_always_public": "代表イメージは常に公開されます",
  "dmm.adult_mismatch_toast_fanza": "この作品は一般向けのため、DMMキャラトークでご覧いただけます",
  "dmm.adult_mismatch_toast_dmm": "この作品は成人向けのため、FANZAでご覧いただけます",
  "common.service_name": "バブルチャット : BubbleChat",
  "chat.rewards_rising_star_monthly_achievement_bonus": "{{string_month}}達成ボーナス",
  "chat.rewards_rising_star_unpaid": "未払い",
  "chat.rewards_rising_star_not_morning_star_on_payout_date": "{{string_payoutDate}}の支給日時点で明星ではなかったため、支給されませんでした",
  "general.mode": "モード",
  "chat.rewards_rising_star_title": "明星達成ボーナス",
  "chat.rewards_rising_star_estimated_monthly_bonus": "{{string_month}}の達成ボーナス予想",
  "chat.rewards_rising_star_scheduled_monthly_bonus": "{{string_month}}の支給予定ボーナス",
  "chat.rewards_rising_star_paid_monthly_bonus": "{{string_month}}の支給済みボーナス",
  "chat.rewards_rising_star_estimated": "予想",
  "chat.rewards_rising_star_calculated": "算定完了",
  "chat.rewards_rising_star_paid": "支給完了",
  "chat.rewards_rising_star_estimate_description": "{{string_asOfAt}}時点の算定前の予想金額 · {{string_payoutDate}}に支給予定",
  "chat.rewards_rising_star_calculated_description": "{{string_asOfAt}}時点で算定完了 · {{string_payoutDate}}にリワードへ自動的に加算",
  "chat.rewards_rising_star_paid_description": "{{string_payoutDate}}にリワードへ加算済み",
  "chat.rewards_rising_star_next_calculation_date": "次回算定日",
  "chat.rewards_rising_star_payout_date": "支給日",
  "chat.rewards_rising_star_achievement_tiers": "達成段階一覧",
  "chat.rewards_rising_star_next_tier_description": "次の段階である{{string_threshold}}以上まであと{{string_remaining}} · 達成すると{{string_bonus}}のボーナスを獲得",
  "chat.rewards_rising_star_highest_tier_description": "最高段階に到達しています。合計リワードの50%がボーナスとして適用されます。",
  "chat.rewards_rising_star_threshold_or_more": "{{string_amount}}以上",
  "chat.rewards_rising_star_achievement_fifty_percent": "達成額の50%",
  "chat.rewards_rising_star_calculation_details": "計算内訳",
  "chat.rewards_rising_star_combined_rewards": "合計リワード",
  "chat.rewards_rising_star_applied_tier": "適用段階",
  "chat.rewards_rising_star_applied_rule": "適用ルール",
  "chat.rewards_rising_star_achievement_bonus": "達成ボーナス",
  "chat.rewards_rising_star_fixed_bonus": "固定ボーナス",
  "chat.rewards_rising_star_achievement_fifty_percent_rounded_up": "達成額の50%、小数点以下切り上げ",
  "chat.rewards_rising_star_not_achieved": "未達成",
  "chat.rewards_rising_star_eligible_assets": "算定対象アセット",
  "chat.rewards_rising_star_within_ninety_days_of_first_release": "初回公開から90日以内",
  "chat.rewards_rising_star_first_release": "初回公開",
  "chat.rewards_rising_star_excluded": "対象外",
  "chat.rewards_rising_star_total": "合計",
  "chat.rewards_rising_star_expand_all": "全{{int_count}}件を表示",
  "chat.rewards_rising_star_no_new_assets": "過去90日以内に新たに公開されたアセットはありません",
  "chat.rewards_rising_star_new_asset_description": "新しいアセットを公開すると、次回の算定から合計に含まれます",
  "chat.rewards_rising_star_bonus_history": "ボーナス付与履歴",
  "chat.rewards_rising_star_morning_star_bonus_history": "明星達成ボーナス付与履歴",
  "chat.rewards_rising_star_bonus_reclaimed": "ボーナス回収",
  "chat.rewards_rising_star_for_year_month": "{{string_yearMonth}}分",
  "chat.rewards_rising_star_payout_date_label": "{{string_payoutDate}}に支給",
  "chat.rewards_rising_star_base_rewards": "基本リワード",
  "chat.rewards_rising_star_monthly_total_rewards": "月間リワード合計",
  "chat.rewards_rising_star_bonus_guide": "明星達成ボーナスについて",
  "chat.rewards_rising_star_calculation_notice": "毎月25日23:59時点で、過去90日以内に初回公開されたアセットから同期間中に発生したリワードを合算し、達成ボーナスを算定します。算定されたボーナスは、毎月末日にリワードへ自動的に加算されます。",
  "chat.rewards_rising_star_non_cumulative_notice": "達成ボーナスは重複して支給されず、該当する段階のうち最も高いボーナスのみが適用されます。",
  "chat.rewards_rising_star_rounding_notice": "50%のボーナスは、小数点以下を切り上げて計算します。",
  "chat.rewards_rising_star_first_release_notice": "「新規公開」とは、アセットが初めて公開されたことを指します。",
  "chat.rewards_rising_star_recalculation_notice": "ボーナス算定後にアセットが削除または非公開になった場合、そのアセットのリワードは算定額から除外されます。25日の算定後、月末の支給前にこの変更が発生した場合は、支給直前にボーナスを再算定します。支給後に発生した場合は、支給済みのボーナスが回収されることがあります。",
  "chat.rewards_rising_star_rate_change_notice": "ボーナス算定後に収益分配率が変更されても、すでに算定された金額は変更されません。",
  "chat.image_number": "イメージ{{int_imageNumbers}}",
  "general.ai": "AI",
  "chat.contest_entry_required": "必須",
  "chat.contest_entry_per_character_fields_hint": "キャラクターごとに個別に入力してください · {{int_number}}件",
  "chat.contest_entry_staff_only_hint": "運営のみ確認できます · 提出後は編集不可",
  "chat.contest_entry_required_character_field_error": "必須項目です。このキャラクターの内容を入力してください",
  "chat.contest_entry_additional_fields_remaining": "追加項目を入力してください（残り{{int_number}}件）",
  "chat.contest_entry_review_confirmation_notice": "運営による確認後、参加が確定します。結果はお知らせで通知します",
  "chat.contest_entry_ineligible_characters_notice": "提出できないキャラクターがあります。リストを再度ご確認ください",
  "chat.contest_entry_pending_approval": "承認待ち",
  "chat.contest_entry_entry_confirmed": "参加確定",
  "chat.contest_entry_rejected": "却下",
  "chat.contest_entry_entry_canceled": "参加キャンセル",
  "chat.contest_entry_submitted_pending_review": "{{string_date}}に提出 · 審査待ち",
  "chat.contest_entry_closed_awaiting_results": "応募受付終了 · 審査結果待ち",
  "chat.contest_entry_approval_revoked_pending_review": "{{string_date}}に承認取消 · 再審査待ち",
  "chat.contest_entry_confirmed_date": "{{string_date}}に確定",
  "chat.contest_entry_confirmed_grant_amount_paid": "{{string_date}}に確定 · 制作支援金{{string_amount}}の支給完了",
  "chat.contest_entry_confirmed_grant_paid": "{{string_date}}に確定 · 制作支援金の支給完了",
  "chat.contest_entry_rejected_resubmissions_remaining": "{{string_date}}に却下 · 再提出可能回数：残り{{int_number}}回",
  "chat.contest_entry_rejected_no_resubmission": "{{string_date}}に却下 · 再提出不可",
  "chat.contest_entry_rejected_after_deadline": "受付終了後に却下 · 再提出不可",
  "chat.contest_entry_auto_canceled_private_character": "{{string_date}}に自動参加取消 · キャラクター非公開",
  "chat.contest_entry_public_characters_only": "公開キャラクターのみコンテストに参加できます",
  "chat.contest_entry_resubmissions_exhausted_notice": "再提出可能回数をすべて使い切りました。別の作品でご参加ください",
  "chat.contest_entry_rejected_after_deadline_notice": "応募受付終了後に却下された作品は、再提出できません",
  "chat.contest_entry_view_rejection_reason": "却下理由を見る",
  "chat.contest_entry_view_submission": "提出内容を見る",
  "chat.contest_entry_collapse_submission": "提出内容を閉じる",
  "chat.contest_entry_read_only_hint": "読み取り専用 · 提出後は編集不可",
  "chat.contest_entry_rejection_reason": "却下理由",
  "chat.contest_entry_processed_date": "{{string_date}}に処理",
  "chat.contest_entry_my_additional_information": "提出した追加情報",
  "chat.contest_entry_resubmission_attempts": "再提出可能回数",
  "chat.contest_entry_resubmissions_remaining": "残り{{int_number}}回（全3回中{{int_count}}回使用済み）",
  "chat.contest_entry_resubmissions_exhausted": "残り0回（全3回使用済み）",
  "chat.contest_entry_resubmission_closed": "再提出不可（応募受付終了）",
  "chat.contest_entry_resubmission_check_notice": "提出前に、却下理由に該当する箇所を修正できているか、もう一度ご確認ください",
  "chat.contest_entry_confirm_submission": "提出を確定",
  "chat.contest_entry_resubmitted_notice": "再提出しました。運営による確認後、結果をお知らせします",
  "chat.contest_entry_ineligible_resubmission_notice": "このキャラクターは参加条件を満たしていないため、再提出できません",
  "chat.contest_entry_resubmission_rules": "再提出ルール",
  "chat.contest_entry_resubmission_rules_attempts": "却下理由を踏まえて修正したうえで、最大3回まで再提出できます",
  "chat.contest_entry_resubmission_rules_review": "再提出すると、再び承認待ちの状態になります。運営による審査後、参加が確定します",
  "chat.contest_entry_resubmission_rules_deadline": "応募受付終了後に却下された作品は再提出できません。審査過程で承認の可否が最終決定されます",
  "chat.contest_entry_resubmit": "再提出する",
  "chat.contest_entry_approval_revoked": "承認取消",
  "chat.contest_entry_view_revocation_reason": "取消理由を見る",
  "chat.contest_entry_revocation_reason": "承認取消理由",
  "chat.tag_search_no_results": "{{string_keyword}}に一致するタグがありません",
  "chat.tag_search_try_another": "別のキーワードで検索してみてください",
  "chat.chat_list_edit_title": "チャット一覧を編集",
  "chat.chat_list_delete_selected_confirm": "選択したチャットルームを削除しますか？",
  "chat.profile_edit_heading": "プロフィール編集",
  "chat.chat_without_ads": "広告なしでチャットする",
  "notification.mark_all_read": "すべて既読にする",
  "chat.markdown_apply": "Markdownを適用",
  "chat.markdown_plain_text_description": "入力したとおりに表示します。#、*、- などの記号もそのまま文字として表示されます",
  "chat.create_short_intro_max_length": "一言紹介は{{int_number}}文字以内で入力してください",
  "chat.markdown_heading_large": "大見出し",
  "chat.markdown_heading_small": "小見出し",
  "chat.markdown_bold": "太字",
  "chat.markdown_italic": "斜体",
  "chat.markdown_list": "リスト",
  "chat.markdown_ordered_list": "番号付きリスト",
  "chat.markdown_quote": "引用",
  "chat.markdown_inline_code": "インラインコード",
  "chat.markdown_code_block": "コードブロック",
  "chat.markdown_table": "表",
  "chat.markdown_toggle": "折りたたみ／展開",
  "chat.markdown_format": "Markdown書式",
  "chat.markdown_table_select_size": "表のサイズを選択してください",
  "chat.markdown_table_dimensions": "{{int_cols}}列 × {{int_rows}}行",
  "chat.markdown_table_size": "表のサイズ",
  "chat.markdown_bold_text": "太字テキスト",
  "chat.markdown_italic_text": "斜体テキスト",
  "chat.markdown_code": "コード",
  "chat.markdown_list_item": "リスト項目",
  "chat.markdown_blockquote": "引用文",
  "chat.markdown_image_description": "画像の説明",
  "chat.markdown_code_placeholder": "コードを入力してください",
  "chat.markdown_collapsed_placeholder": "折りたたみ部分の内容を入力してください",
  "chat.markdown_item": "項目",
  "chat.create_short_intro": "一言紹介",
  "chat.create_review_info": "審査情報",
  "chat.create_character_info": "キャラクター情報",
  "chat.create_background_info": "背景情報",
  "chat.create_person": "人物",
  "chat.create_hidden_from_users": "ユーザーには表示されません",
  "chat.create_hidden_markdown_description": "この内容はユーザーには表示されません。## 見出し などのMarkdown記法はそのままAIに送信され、構造の理解に役立ちます",
  "chat.create_review_only_description": "審査のみに使用され、詳細ページには表示されません。ユーザーに見せたい場合は、詳細説明に希望する形式で記載してください",
  "chat.create_one_per_line": "1行に1つずつ入力してください",
  "chat.create_prompt_total_count": "プロンプト合計{{current}} / {{max}}文字",
  "chat.create_total_count": "合計{{current}} / {{max}}文字",
  "chat.create_public_description": "詳細説明",
  "chat.create_public_description_ai_notice": "この内容はAIに認識されません。ユーザー向けの紹介文を自由に入力してください。",
  "chat.create_public_description_ai_hidden": "この内容はAIに認識されません",
  "chat.create_public_description_ai_unread": "AIが読み取らない紹介文です",
  "chat.create_public_description_placeholder": "ユーザー向けの紹介文を入力してください",
  "chat.create_public_description_migrated": "以前公開設定にしていた内容をそのまま移しました。必要に応じて編集してください。",
  "chat.create_public_description_empty": "詳細説明が空欄です。このまま登録することもできますが、詳細説明があるとチャットを始めてもらいやすくなります。",
  "chat.create_character_limit_exceeded": "文字数の上限を超えています",
  "chat.create_public_description_max_length": "詳細説明は{{int_characters}}文字以内で入力してください。",
  "chat.create_public_description_token_notice": "プロンプトの文字数とは別にカウントされます。AIには送信されないため、トークン費用には影響しません。",
  "chat.create_public_description_separate_count": "AIには送信されません・別カウント",
  "chat.create_public_description_preview_placeholder": "詳細説明を入力すると、ここに表示されます",
  "chat.create_public_description_visible_area": "ユーザーに表示されるのはこの範囲のみです",
  "chat.image_load_failed": "画像を読み込めません",
  "chat.find_character": "キャラクターを探す",
  "chat.find_universe": "世界観を探す",
  "chat.find_scene": "シーンを探す",
  "chat.markdown_image": "画像",
  "chat.create_preview_label": "プレビュー",
  "common.list_load_failed": "あっ！一覧を読み込めませんでした",
  "validation.email_request_limit_exceeded": "メールのリクエスト回数を超過しました。メールボックスと迷惑メールフォルダを確認し、しばらくしてから再度お試しください。",
  "validation.email_unavailable": "使用できないメールアドレスです。別のメールアドレスを入力してください。",
  "payment.shampoo_sales_end_notice": "スーパーシャンプーおよびスーパーシャンプーのリフィル商品の販売は、11月25日をもって終了いたします",
  "payment.shampoo_free_provision_end_notice": "無料シャンプーの提供は12月16日をもって終了し、今後はログインボーナスに置き換わります。\nお手持ちの無料シャンプーは12月15日までご利用いただけます。",
  "payment.shampoo_purchased_access_continues": "購入済みのスーパーシャンプーは、販売終了後も残りの利用期間中は引き続きご利用いただけます。",
  "payment.shampoo_contact_support": "ご不明な点がございましたら、お客様センターまでお問い合わせください",
  "payment.shampoo_sales_ended": "スーパーシャンプー利用券( リフィルを含む)は、2026年11月25日をもって販売を終了いたしました",
  "payment.shampoo_pass_validity_continues": "販売終了前に購入された利用券は、残りの有効期間中、引き続き通常どおりご利用いただけます",
  "weave.purchase_verification_required": "本人認証完了後に購入できます",
  "weave.purchase_verified_adults_only": "Weave Plusは、本人認証を完了した成人の方のみご購入いただけます",
  "weave.purchase_adults_only": "Weave Plusは、成人の方のみご購入いただけます",
  "weave.purchase_minors_restricted": "関連法令により、未成年の方はWeave Plusをご購入いただけません",
  "weave.continued_use_verification_required": "Weave Plusを引き続きご利用いただくには、本人認証が必要です",
  "weave.verified_adults_notice": "{{string_date}}以降、Weave Plusは本人認証を完了した成人の方のみご利用いただけます。適用日までに本人認証を完了してください",
  "weave.unverified_by_effective_date": "適用日までに本人認証が完了していない場合",
  "weave.termination_prorated_refund": "Weave Plusのご利用は終了し、残りの利用期間に応じて料金を返金いたします",
  "weave.model_usage_notice_title": "Weaveモデルの利用に関するお知らせ",
  "weave.model_adults_only_notice": "{{string_date}}以降、Weaveモデルは成人の方のみご利用いただけます。Weaveモデルで利用していたチャットルームはGemini 3.8 Flashに引き継がれ、これまでの会話履歴もそのまま残ります",
  "weave.access_ending_title": "Weave Plusのご利用が終了します",
  "weave.access_ending_refund_notice": "{{string_date}}以降、Weaveモデルは成人の方のみご利用いただけるため、Weave Plusのご利用も終了します。料金は残りの利用期間に応じて返金いたします",
  "weave.app_store_subscription_heading": "App Storeからご購入の場合",
  "weave.apple_refund_instructions": "以下の［返金を申請する］からAppleに返金を申請してください。申請すると、自動更新もあわせて解約されます",
  "weave.request_refund": "返金を申請する",
  "weave.access_ending_automatic_refund_notice": "{{string_date}}以降、Weaveモデルは成人の方のみご利用いただけるため、Weave Plusのご利用も終了します。残りの利用期間に応じた料金を、お支払い時と同じ決済方法に自動的に返金いたします",
  "weave.adults_only_badge": "成人専用",
  "weave.minors_cannot_purchase": "未成年の方はWeave Plusをご購入いただけません"
}